// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
// import { Offcanvas } from 'react-bootstrap';
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import Swal from 'sweetalert2';
// import CloseButton from 'react-bootstrap/CloseButton';

// const ExpenseModal = ({ showModal, handleClose, expenseId, expenseData, projectId, clientId, addExpense, editExpense, users, fetchUsers, fetchExpenseTypes, expenseTypes, errors, setErrors, isEditMode, setIsEditMode }) => {
//     const [loading, setLoading] = useState(false); // Track loading state
//     const location = useLocation();
//     const isExpensePage = location.pathname === "/expenses";

//     const [clients, setClients] = useState([]);
//     const [vendors, setVendors] = useState([]);
//     const [projects, setProjects] = useState([]);
//     const [selectedClient, setSelectedClient] = useState("");
//     const [taxType, setTaxType] = useState(""); // 'taxable' or 'non-taxable'
//     const [taxFields, setTaxFields] = useState({});
//     const [loggedInUser, setLoggedInUser] = useState(null);
//     const [isAdmin, setIsAdmin] = useState(false);
//     const webzashUrl = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration'; // Adjust as needed
//     const webzashAPI = `${webzashUrl}/api/groups/index`;
//     const [webzashGroups, setWebzashGroups] = useState([]);
//     const [selectedWebzashGroup, setSelectedWebzashGroup] = useState('');
//     const [allWebzashGroups, setAllWebzashGroups] = useState([]);


//     const [formData, setFormData] = useState({
//         project_id: projectId || '',
//         amount: '',
//         expense_type: '',
//         user_id: '',
//         expense_type_id: '',
//         narration: '',
//         date: '',
//         attatchment: null,
//         client_id: clientId || '',
//         invoice_no: "",
//         invoice_date: "",
//         amount_without_tax: "",
//         tax: 5, // default tax percent (can be fetched dynamically too)
//         adjustment_amount: "",
//         total_amount: "",
//         tax_type: "",
//         type: isExpensePage ? "" : "internal",
//         reconciliation_status: 'pending',

//     });

//     useEffect(() => {
//         const userInfo = JSON.parse(localStorage.getItem('user-info'));
//         if (userInfo) {
//             const user = userInfo.user || userInfo; // handles both formats
//             setLoggedInUser(user);

//             const roles = userInfo.roles || [];
//             setIsAdmin(roles.includes('admin') || roles.includes('superadmin'));
//         }
//     }, []);

//     useEffect(() => {
//         if (showModal && users?.length === 0) {
//             fetchUsers();
//         }
//         if (showModal && expenseTypes?.length === 0) {
//             fetchExpenseTypes();
//         }
//         if (showModal && !expenseId && !expenseData && loggedInUser && !isAdmin) {
//             setFormData(prev => ({
//                 ...prev,
//                 user_id: loggedInUser.id // Set to logged-in user's ID
//             }));
//         }
//         if (expenseId && expenseData) {
//             setFormData({
//                 ...expenseData,
//                 project_id: expenseData.project_id || '',
//                 attatchment: null, // Reset attachment
//                 previewUrl: typeof expenseData.attatchment === "string" ? expenseData.attatchment : null,
//                 reconciliation_status: 'pending',
//             });
//             setTaxFields({
//                 invoice_no: expenseData.invoice_no || "",
//                 invoice_date: expenseData.invoice_date || "",
//                 amount_without_tax: expenseData.amount_without_tax || "",
//                 tax: expenseData.tax || 5,
//                 adjustment_amount: expenseData.adjustment_amount || "",
//                 total_amount: expenseData.total_amount || "",
//             });

//             if (expenseData.client_id) {
//                 setSelectedClient(expenseData.client_id);
//                 fetchProjects(expenseData.client_id);
//             }
//         } else if (showModal && !expenseData) {
//             const today = new Date().toISOString().split('T')[0];
//             setFormData({
//                 project_id: projectId || '',
//                 amount: '',
//                 expense_type: '',
//                 user_id: '',
//                 expense_type_id: '',
//                 narration: '',
//                 date: today,
//                 attatchment: null,
//                 previewUrl: null,
//                 client_id: clientId || '',
//                 invoice_no: '',
//                 invoice_date: '',
//                 amount_without_tax: '',
//                 total_amount: '',
//                 vendor_id: '',
//                 tax: 5,
//                 adjustment_amount: '',
//                 type: isExpensePage ? "" : "internal",
//                 tax_type: '',
//                 reconciliation_status: 'pending',

//             });
//             setTaxFields({
//                 invoice_no: '',
//                 invoice_date: '',
//                 amount_without_tax: '',
//                 tax: 5,
//                 adjustment_amount: '',
//                 total_amount: '',
//             });
//         }
//     }, [expenseId, expenseData, showModal, loggedInUser, isAdmin]);
//     const fetchExpenseGroups = async () => {
//         try {
//             const response = await axios.get(`${webzashAPI}`, {
//                 headers: {
//                     'x-api-key': process.env.REACT_APP_API_KEY,
//                     'Accept': 'application/json'
//                 },
//                 skipLoader: true,

//             });

//             const allGroups = response.data || [];

//             const expensesGroup = allGroups.find(g => g.Group.name === 'Expenses');

//             const expenseChildren = allGroups.filter(
//                 g => g.Group.parent_id === expensesGroup?.Group.id
//             );

//             setWebzashGroups(expenseChildren);
//             setAllWebzashGroups(allGroups);

//         } catch (error) {
//             console.error("Error fetching expense groups:", error);
//         }
//     };
//     const fetchClients = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contacts?type=client&issales=false`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });
//             setClients(response.data.Data || []); // Ensure safe access
//         } catch (error) {
//             console.error('Error fetching clients:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to fetch clients. Please try again.',
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//         }
//     };
//     const fetchVendors = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;

//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//                 skipLoader: true,

//             });
//             setVendors(response.data.Data || []); // Ensure safe access
//         } catch (error) {
//             console.error('Error fetching vendor:', error);
//             Swal.fire({
//                 toast: true,
//                 position: 'top-end',
//                 icon: 'error',
//                 title: 'Failed to fetch vendors. Please try again.',
//                 timer: 3000,
//                 timerProgressBar: false,
//                 showConfirmButton: false,
//                 didOpen: () => {
//                     const container = Swal.getContainer();
//                     container.style.top = '50px';
//                 },
//             });
//         }
//     };
//     // const fetchProjects = async (clientId) => {
//     //     try {
//     //         const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     //         const userInfo = JSON.parse(localStorage.getItem("user-info"));
//     //         const origin = localStorage.getItem("user-origin");
//     //         const token = userInfo?.token;

//     //         if (!clientId) {
//     //             setProjects([]); // ✅ Clear projects if no client selected
//     //             return;
//     //         }

//     //         const response = await axios.get(`${backendUrl}/api/projects?client_id=${clientId}`, {
//     //             headers: {
//     //                 Authorization: `Bearer ${token}`,
//     //                 'Tenant-Origin': origin,
//     //             },
//     //             skipLoader: true,

//     //         });

//     //         setProjects(response.data.Data || []); // ✅ Store only the selected client's projects
//     //     } catch (error) {
//     //         console.error("Error fetching projects:", error);
//     //         setProjects([]); // ✅ Ensure dropdown is cleared on error
//     //     }
//     // };
//     const fetchProjects = async (clientId) => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem("user-info"));
//             const origin = localStorage.getItem("user-origin");
//             const token = userInfo?.token;

//             // Case for fetching all projects (for external type)
//             if (formData.type === "external") {
//                 const response = await axios.get(`${backendUrl}/api/projects`, {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,
//                     },
//                     skipLoader: true,
//                 });
//                 setProjects(response.data.Data || []); // Store all projects
//             } else if (clientId) {
//                 // Case for fetching projects specific to the selected client (for internal type)
//                 const response = await axios.get(`${backendUrl}/api/projects?client_id=${clientId}`, {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                         'Tenant-Origin': origin,
//                     },
//                     skipLoader: true,
//                 });
//                 setProjects(response.data.Data || []); // Store client-specific projects
//             } else {
//                 setProjects([]); // Clear projects if no client or external type
//             }
//         } catch (error) {
//             console.error("Error fetching projects:", error);
//             setProjects([]); // Clear projects on error
//         }
//     };

//     useEffect(() => {
//         if (showModal && isExpensePage) {
//             fetchClients();
//             if (formData.type === "external") {
//                 fetchProjects(); // No clientId, will fetch all
//             }
//         }
//     }, [showModal, isExpensePage, formData.type]);
//     useEffect(() => {
//         if (showModal) {
//             fetchVendors();
//             fetchExpenseGroups();
//         }
//     }, [showModal]);

//     const handleClientChange = (e) => {
//         const clientId = e.target.value;
//         setFormData({ ...formData, client_id: clientId, project_id: "" }); // ✅ Save client_id
//         setSelectedClient(clientId);
//         fetchProjects(clientId); // Fetch projects for the selected client
//     };
//     const handleChange = (e) => {
//         const { name, value, files } = e.target;

//         if (name === "attatchment" && files.length > 0) {
//             setFormData({ ...formData, attatchment: files[0] });
//         } else {
//             setFormData({ ...formData, [name]: value });
//         }
//         if (errors[name]) {
//             setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
//         }
//     };

//     const handleTaxTypeChange = (e) => {
//         const value = e.target.value;
//         setTaxType(value);
//         setFormData({ ...formData, tax_type: value });

//         // ✅ Clear error for tax_type if it exists
//         if (errors.tax_type) {
//             setErrors(prevErrors => ({ ...prevErrors, tax_type: undefined }));
//         }
//     };


//     const handleTaxFieldChange = (e) => {
//         const { name, value } = e.target;
//         const updated = { ...taxFields, [name]: value };

//         if (name === "amount_without_tax" || name === "adjustment_amount") {
//             const base = parseFloat(updated.amount_without_tax || 0);
//             const tax = (base * (updated.tax || 0)) / 100;
//             const total = base + tax + parseFloat(updated.adjustment_amount || 0);
//             updated.total_amount = total.toFixed(2);
//         }

//         setTaxFields(updated);
//         setFormData(prev => ({
//             ...prev,
//             [name]: value,
//             total_amount: updated.total_amount
//         }));
//         if (errors[name] && value) {
//             setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
//         }
//     };
//     const validateForm = () => {
//         const newErrors = {};
//         if (!formData.tax_type) {
//             newErrors.tax_type = "Please select a Tax Type";
//         }
//         if (formData.tax_type === 'taxable' && !formData.amount_without_tax) {
//             newErrors.amount_without_tax = 'Amount is required for  expenses';
//         }
//         if (formData.tax_type === 'non-taxable' && !formData.amount) {
//             newErrors.amount = 'Amount is required for expenses';
//         }

//         if (isAdmin && formData.type === 'internal' && !formData.user_id) {
//             newErrors.user_id = 'User is required for internal expenses';
//         }

//         return newErrors;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true); // Start the button-specific loader
//         const validationErrors = validateForm();
//         if (Object.keys(validationErrors).length > 0) {
//             setErrors(validationErrors);
//             setLoading(false);
//             return; // Stop here if validation fails
//         }
//         console.log("Form Data before submission:", formData);
//         try {
//             const formDataObj = new FormData();

//             Object.entries(formData).forEach(([key, value]) => {
//                 if (value !== undefined && value !== null) {
//                     formDataObj.append(key, value);
//                 }
//             });
//             if (formData.tax_type === "taxable") {
//                 formDataObj.append("invoice_no", taxFields.invoice_no);
//                 formDataObj.append("invoice_date", taxFields.invoice_date);
//                 formDataObj.append("amount_without_tax", taxFields.amount_without_tax);
//                 formDataObj.append("tax", taxFields.tax);
//                 formDataObj.append("adjustment_amount", taxFields.adjustment_amount);
//                 formDataObj.append("total_amount", taxFields.total_amount);
//             }

//             // Append file if available
//             if (formData.attatchment instanceof File) {
//                 formDataObj.append("attatchment", formData.attatchment);
//             }

//             // Debug: Log FormData content
//             for (let pair of formDataObj.entries()) {
//                 console.log(`${pair[0]}:`, pair[1]);
//             }
//             let errors;
//             if (expenseId != null) {
//                 // Edit tenant
//                 errors = await editExpense(expenseId, formDataObj);
//             } else {
//                 // Add new tenant
//                 errors = await addExpense(formDataObj);
//             }
//             if (errors && Object.keys(errors).length > 0) {
//                 setErrors(errors); // Display validation errors
//             } else {
//                 setErrors({}); // Clear errors on success
//                 handleClose(); // Close modal on success
//             }
//         } catch (error) {
//             console.error("An error occurred:", error); // Log any unexpected errors
//         } finally {
//             setLoading(false); // Stop the button-specific loader
//         }
//     };

//     // const [isEditMode, setIsEditMode] = useState(false);

//     // useEffect(() => {
//     //     if (expenseId) {
//     //         setIsEditMode(false); // existing expense → readonly
//     //     } else {
//     //         setIsEditMode(true); // creating new → editable
//     //     }
//     // }, [expenseId]);


//     return (


//         <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '480px' }}>
//             <Offcanvas.Header closeButton>
//                 <Offcanvas.Title>
//                     {/* {expenseId ? 'Edit Expense' : 'Create Expense'} */}
//                     {isEditMode ? (expenseId ? 'Edit Expense' : 'Create Expense') : 'View Expense'}
//                 </Offcanvas.Title>
//             </Offcanvas.Header>
//             <hr style={{ margin: 0 }} /><br />

//             <Offcanvas.Body>
//                 <Form>
//                     {(formData.attatchment || formData.previewUrl) && (
//                         <div style={{ textAlign: "center", position: "relative", marginBottom: "1rem" }}>
//                             {(() => {
//                                 const file = formData.attatchment instanceof File ? formData.attatchment : null;
//                                 const backendUrl = process.env.REACT_APP_BACKEND_URL;
//                                 const fileUrl = file ? URL.createObjectURL(file) : `${backendUrl}/storage/${formData.previewUrl}`;
//                                 const fileName = file ? file.name : formData.previewUrl;
//                                 const extension = fileName?.split(".").pop().toLowerCase();

//                                 if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension)) {
//                                     return (
//                                         <img
//                                             src={fileUrl}
//                                             alt="Preview"
//                                             style={{
//                                                 width: "100%",
//                                                 maxHeight: "400px",
//                                                 cursor: formData.previewUrl ? "pointer" : "default",
//                                                 borderRadius: "10px",
//                                             }}
//                                             onClick={() => {
//                                                 if (formData.previewUrl) {
//                                                     const filename = formData.previewUrl.split('/').pop();
//                                                     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//                                                     const fileDownloadUrl = `${backendUrl}/api/expenses/download/${encodeURIComponent(filename)}`;
//                                                     const userInfo = JSON.parse(localStorage.getItem("user-info"));
//                                                     const origin = localStorage.getItem("user-origin");
//                                                     const token = userInfo?.token;

//                                                     axios
//                                                         .get(fileDownloadUrl, {
//                                                             responseType: "blob",
//                                                             headers: {
//                                                                 Authorization: `Bearer ${token}`,
//                                                                 Accept: "application/json",
//                                                                 "Tenant-Origin": origin,
//                                                             },
//                                                         })
//                                                         .then((response) => {
//                                                             const blob = new Blob([response.data]);
//                                                             const link = document.createElement("a");
//                                                             link.href = URL.createObjectURL(blob);
//                                                             link.setAttribute("download", filename);
//                                                             document.body.appendChild(link);
//                                                             link.click();
//                                                             document.body.removeChild(link);
//                                                             URL.revokeObjectURL(link.href);
//                                                         })
//                                                         .catch((error) => console.error("Error downloading file:", error));
//                                                 }
//                                             }}
//                                         />
//                                     );
//                                 } else if (["pdf"].includes(extension)) {
//                                     return (
//                                         <iframe
//                                             src={fileUrl}
//                                             style={{ width: "100%", height: "300px", border: "none" }}
//                                             title="PDF Preview"
//                                         />
//                                     );
//                                 } else {
//                                     return (
//                                         <a href={fileUrl} target="_blank" rel="noopener noreferrer">
//                                             View Attachment ({extension.toUpperCase()})
//                                         </a>
//                                     );
//                                 }
//                             })()}
//                             {isEditMode && (

//                                 <CloseButton
//                                     onClick={() => setFormData({ ...formData, attatchment: null, previewUrl: null })}
//                                     className="custom-close"
//                                 />
//                             )}
//                         </div>
//                     )}
//                     <Form.Group controlId="date" className="mb-3">
//                         <Form.Label className='form-font'>Date</Form.Label>
//                         <Form.Control
//                             className='form-control form-feild'
//                             type="date"
//                             name="date"
//                             value={formData.date}
//                             onChange={handleChange}
//                             disabled={!isEditMode}

//                         />
//                     </Form.Group>
//                     <Form.Group controlId="webzashGroup">
//                         <Form.Label className='form-label form-font'>Expense Group</Form.Label>
//                         <Form.Select
//                             name="group_id"
//                             value={selectedWebzashGroup || formData.group_id || ''}
//                             onChange={(e) => setSelectedWebzashGroup(e.target.value)}
//                             className="form-control form-feild"
//                         >
//                             <option value="">Select Group</option>
//                             {webzashGroups.map(({ Group }) => (
//                                 <option key={Group.id} value={Group.id}>
//                                     {Group.name}
//                                 </option>
//                             ))}
//                         </Form.Select>

//                     </Form.Group>
//                     {isExpensePage && (
//                         <Form.Group controlId="type" className="mb-3">
//                             <Form.Label className='form-font'> Type</Form.Label>
//                             <Form.Select name='type' value={formData.type} onChange={handleChange} className='form-feild' disabled={!isEditMode}
//                             >
//                                 <option value="">Select</option>
//                                 <option value="external">External</option>
//                                 <option value="internal">Internal</option>
//                             </Form.Select>
//                         </Form.Group>
//                     )}
//                     {isExpensePage && formData.type === "external" && (

//                         <Form.Group controlId="vendor" className="mb-3">
//                             <Form.Label className='form-font'>Vendor</Form.Label>
//                             <Form.Select name='vendor_id' value={formData.vendor_id} onChange={handleChange} className='form-feild' disabled={!isEditMode}
//                             >
//                                 <option value="">Select Vendor</option>
//                                 {vendors.map(vendor => (
//                                     <option key={vendor.id} value={vendor.id}>
//                                         {vendor.name}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </Form.Group>
//                     )}

//                     {isExpensePage && formData.type === "internal" && (
//                         <Form.Group controlId="client" className="mb-3">
//                             <Form.Label className='form-font'>Client</Form.Label>
//                             <Form.Select name='client_id' value={formData.client_id} onChange={handleClientChange} className='form-feild' disabled={!isEditMode}
//                             >
//                                 <option value="">Select Client</option>
//                                 {clients.map(client => (
//                                     <option key={client.id} value={client.id}>
//                                         {client.name}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </Form.Group>
//                     )}

//                     {/* ✅ Show Project Dropdown Only on /expenses */}
//                     {/* {isExpensePage && selectedClient && (
//                         <Form.Group controlId="project" className="mb-3">
//                             <Form.Label className='form-font'>Project</Form.Label>
//                             <Form.Select className='form-feild' name="project_id" value={formData.project_id} onChange={handleChange}>
//                                 <option value="">Select Project</option>
//                                 {projects.map(project => (
//                                     <option key={project.id} value={project.id}>
//                                         {project.name}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </Form.Group>
//                     )} */}
//                     {isExpensePage && formData.type === "internal" && selectedClient && (
//                         <Form.Group controlId="project" className="mb-3">
//                             <Form.Label className='form-font'>Project</Form.Label>
//                             <Form.Select
//                                 className='form-feild'
//                                 name="project_id"
//                                 value={formData.project_id}
//                                 onChange={handleChange}
//                                 disabled={!isEditMode}

//                             >
//                                 <option value="">Select Project</option>
//                                 {projects.map(project => (
//                                     <option key={project.id} value={project.id}>
//                                         {project.name}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </Form.Group>
//                     )}

//                     {isExpensePage && formData.type === "external" && projects.length > 0 && (
//                         <Form.Group controlId="project" className="mb-3">
//                             <Form.Label className='form-font'>Project</Form.Label>
//                             <Form.Select
//                                 className='form-feild'
//                                 name="project_id"
//                                 value={formData.project_id}
//                                 onChange={handleChange}
//                                 disabled={!isEditMode}
//                             >
//                                 <option value="">Select Project</option>
//                                 {projects.map(project => (
//                                     <option key={project.id} value={project.id}>
//                                         {project.name}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                         </Form.Group>
//                     )}


//                     <Form.Group controlId="expense_type" className="mb-3">
//                         <Form.Label className='form-font'>Expense Type</Form.Label>
//                         <Form.Select
//                             className='form-feild'
//                             name="expense_type_id"
//                             value={formData.expense_type_id}
//                             onChange={handleChange}
//                             disabled={!isEditMode}

//                         >
//                             <option value="">Select</option>
//                             {expenseTypes?.map(org => (
//                                 <option key={org.id} value={org.id}>
//                                     {org.name}
//                                 </option>
//                             ))}
//                         </Form.Select>
//                     </Form.Group>

//                     {/* {isAdmin ? (
//                         <Form.Group controlId="user" className="mb-3">
//                             <Form.Label className='form-font'>User</Form.Label>
//                             <Form.Select
//                                 name="user_id"
//                                 value={formData.user_id}
//                                 onChange={handleChange}
//                                 className={`form-feild  ${errors?.user_id ? 'is-invalid' : ''}`}
//                                 disabled={!isEditMode}
//                             >
//                                 <option value="">Select</option>
//                                 {users?.map(user => (
//                                     <option key={user.id} value={user.id}>
//                                         {user.name}
//                                     </option>
//                                 ))}
//                             </Form.Select>
//                             {errors.user_id && <div className="invalid-feedback font-size-12" >*{errors.user_id}</div>}
//                         </Form.Group>
//                     ) : (
//                         // For non-admin users, show the logged-in user's name (readonly)
//                         <Form.Group controlId="user" className="mb-3">
//                             <Form.Label className='form-font'>User</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={loggedInUser?.name || 'Current User'}
//                                 className="form-feild"
//                                 disabled
//                                 readOnly
//                             />

//                         </Form.Group>
//                     )} */}
//                     {isExpensePage && formData.type === "internal" && (
//                         isAdmin ? (
//                             <Form.Group controlId="user" className="mb-3">
//                                 <Form.Label className='form-font'>User</Form.Label>
//                                 <Form.Select
//                                     name="user_id"
//                                     value={formData.user_id}
//                                     onChange={handleChange}
//                                     className={`form-feild  ${errors?.user_id ? 'is-invalid' : ''}`}
//                                     disabled={!isEditMode}
//                                 >
//                                     <option value="">Select</option>
//                                     {users?.map(user => (
//                                         <option key={user.id} value={user.id}>
//                                             {user.name}
//                                         </option>
//                                     ))}
//                                 </Form.Select>
//                                 {errors.user_id && <div className="invalid-feedback font-size-12" >*{errors.user_id}</div>}
//                             </Form.Group>
//                         ) : (
//                             <Form.Group controlId="user" className="mb-3">
//                                 <Form.Label className='form-font'>User</Form.Label>
//                                 <Form.Control
//                                     type="text"
//                                     value={loggedInUser?.name || 'Current User'}
//                                     className="form-feild"
//                                     disabled
//                                     readOnly
//                                 />
//                             </Form.Group>
//                         )
//                     )}

//                     <Form.Group className="mb-3">
//                         <Form.Label className="form-font">Tax Redeemable</Form.Label>
//                         <Form.Select
//                             className={`form-feild  ${errors?.tax_type ? 'is-invalid' : ''}`}
//                             value={formData.tax_type}
//                             onChange={handleTaxTypeChange}
//                             name='tax_type'
//                             disabled={!isEditMode}
//                         >
//                             <option value="">Select</option>
//                             <option value="taxable">Yes</option>
//                             <option value="non-taxable">No</option>
//                         </Form.Select>
//                         {errors.tax_type && <div className="invalid-feedback font-size-12" >*{errors.tax_type}</div>}
//                     </Form.Group>

//                     {/* Taxable Fields Only */}
//                     {formData.tax_type === "taxable" && formData.tax_type !== "non-taxable" && (
//                         <>
//                             <Form.Group className="mb-3">
//                                 <Form.Label className="form-font">Invoice No</Form.Label>
//                                 <Form.Control
//                                     type="text"
//                                     name="invoice_no"
//                                     value={taxFields.invoice_no}
//                                     onChange={handleTaxFieldChange}
//                                     className="form-feild"
//                                     disabled={!isEditMode}
//                                 />
//                             </Form.Group>
//                             <Form.Group className="mb-3">
//                                 <Form.Label className="form-font">Invoice Date</Form.Label>
//                                 <Form.Control
//                                     type="date"
//                                     name="invoice_date"
//                                     value={taxFields.invoice_date}
//                                     onChange={handleTaxFieldChange}
//                                     className="form-feild"
//                                     disabled={!isEditMode}
//                                 />
//                             </Form.Group>
//                             <Form.Group className="mb-3">
//                                 <Form.Label className="form-font">Amount Without Tax</Form.Label>
//                                 <Form.Control
//                                     type="number"
//                                     name="amount_without_tax"
//                                     value={taxFields.amount_without_tax}
//                                     onChange={handleTaxFieldChange}
//                                     className={`form-feild  ${errors?.amount_without_tax ? 'is-invalid' : ''}`}
//                                     disabled={!isEditMode}
//                                 />
//                                 {errors.amount_without_tax && <div className="invalid-feedback font-size-12" >*{errors.amount_without_tax}</div>}
//                             </Form.Group>
//                             <Form.Group className="mb-3">
//                                 <Form.Label className="form-font">Tax (%)</Form.Label>
//                                 <Form.Control
//                                     type="number"
//                                     name="tax"
//                                     value={taxFields.tax}
//                                     onChange={handleTaxFieldChange}
//                                     className="form-feild"
//                                     disabled={!isEditMode}
//                                 />
//                             </Form.Group>
//                             <Form.Group className="mb-3">
//                                 <Form.Label className="form-font">Adjustment Amount</Form.Label>
//                                 <Form.Control
//                                     type="number"
//                                     name="adjustment_amount"
//                                     value={taxFields.adjustment_amount}
//                                     onChange={handleTaxFieldChange}
//                                     className="form-feild"
//                                     disabled={!isEditMode}
//                                 />
//                             </Form.Group>
//                             <Form.Group className="mb-3">
//                                 <Form.Label className="form-font">Total Amount</Form.Label>
//                                 <Form.Control
//                                     type="text"
//                                     name="total_amount"
//                                     value={taxFields.total_amount}
//                                     readOnly
//                                     className="form-feild"
//                                     disabled={!isEditMode}

//                                 />
//                             </Form.Group>
//                         </>
//                     )}
//                     {formData.tax_type === "non-taxable" && (<Form.Group controlId="amount" className="mb-3">
//                         <Form.Label className='form-font'>Amount</Form.Label>
//                         <Form.Control
//                             className={`form-feild  ${errors?.amount ? 'is-invalid' : ''}`}
//                             type="text"
//                             name="amount"
//                             value={formData.amount}
//                             onChange={handleChange}
//                             disabled={!isEditMode}
//                         />
//                         {errors.amount && <div className="invalid-feedback font-size-12" >*{errors.amount}</div>}
//                     </Form.Group>
//                     )}

//                     <Form.Group className="mb-3" >
//                         <Form.Label className='form-font'>Narration</Form.Label>
//                         <Form.Control
//                             className='form-control form-feild'
//                             type="text"
//                             name="narration"
//                             value={formData.narration}
//                             onChange={handleChange}
//                             disabled={!isEditMode}
//                         />
//                     </Form.Group>


//                     {isEditMode && (
//                         <Form.Group controlId="attatchment" className="mb-3">
//                             <Form.Label className="form-font">Attachment</Form.Label>
//                             <Form.Control
//                                 type="file"
//                                 disabled={!isEditMode}
//                                 onChange={(e) => {
//                                     const file = e.target.files[0];
//                                     if (file) {
//                                         setFormData(prev => ({
//                                             ...prev,
//                                             attatchment: file,
//                                             previewUrl: URL.createObjectURL(file), // Show preview immediately
//                                         }));
//                                     }
//                                 }}
//                             />
//                         </Form.Group>
//                     )}


//                 </Form>
//             </Offcanvas.Body>

//             <br />
//             <div className="p-3 d-flex justify-content-end border-top">
//                 <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
//                     Close
//                 </button>
//                 {/* <button
//                     type="button"
//                     className="btn btn-primary"
//                     onClick={handleSubmit}
//                 >

//                     Save
//                 </button> */}
//                 {!isEditMode && expenseId ? (
//                     <button
//                         type="button"
//                         className="btn btn-primary"
//                         onClick={() => setIsEditMode(true)}
//                     >
//                         Edit
//                     </button>
//                 ) : (
//                     <button
//                         type="button"
//                         className="btn btn-primary"
//                         onClick={handleSubmit}
//                     >
//                         Save
//                     </button>
//                 )}
//             </div>
//         </Offcanvas>

//     );
// };

// export default ExpenseModal;


import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col, Spinner, Badge } from 'react-bootstrap';
import { Offcanvas } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import CloseButton from 'react-bootstrap/CloseButton';
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";

const ExpenseModal = ({ showModal, handleClose, expenseId, expenseData, projectId, clientId, addExpense, editExpense, users, fetchUsers, fetchExpenseTypes, expenseTypes, errors, setErrors, isEditMode, setIsEditMode }) => {
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const isExpensePage = location.pathname === "/expenses";
    const [ledgerSearch, setLedgerSearch] = useState("");
    const [filteredLedgers, setFilteredLedgers] = useState([]);
    // New state for step-by-step form
    const [currentStep, setCurrentStep] = useState(1);
    const [paymentType, setPaymentType] = useState(""); // 'direct' or 'indirect'
    const [paymentMethod, setPaymentMethod] = useState(""); // 'bank' or 'petty_cash'


    const [clients, setClients] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [projects, setProjects] = useState([]);
    const [selectedClient, setSelectedClient] = useState("");
    const [taxType, setTaxType] = useState(""); // 'taxable' or 'non-taxable'
    const [taxFields, setTaxFields] = useState({});
    
    const [deferredFields, setDeferredFields] = useState({
        recognition_period: 'monthly',
        deferred_start_date: '',
        deferred_end_date: '',
        total_periods: 0,
        amount_per_period: 0
    });

    const calculateDeferredPeriods = (startDate, endDate, periodType, totalAmount) => {
        if (!startDate || !endDate || !totalAmount) return { periods: 0, perPeriod: 0 };
        const start = dayjs(startDate);
        const end = dayjs(endDate);
        if (end.isBefore(start)) return { periods: 0, perPeriod: 0 };

        let periods = 0;
        if (periodType === 'monthly') {
            periods = end.diff(start, 'month') + 1;
        } else if (periodType === 'quarterly') {
            periods = Math.ceil((end.diff(start, 'month') + 1) / 3);
        } else if (periodType === 'yearly') {
            periods = end.diff(start, 'year') + 1;
        }

        const perPeriod = periods > 0 ? (totalAmount / periods).toFixed(2) : 0;
        return { periods, perPeriod };
    };

    const handleDeferredFieldChange = (field, value) => {
        setDeferredFields(prev => {
            const updated = { ...prev, [field]: value };
            const amount = parseFloat(taxFields.total_amount || formData.total_amount || formData.amount || 0);
            
            if (updated.deferred_start_date && updated.deferred_end_date) {
                const { periods, perPeriod } = calculateDeferredPeriods(
                    updated.deferred_start_date,
                    updated.deferred_end_date,
                    updated.recognition_period,
                    amount
                );
                updated.total_periods = periods;
                updated.amount_per_period = perPeriod;
            }
            return updated;
        });
    };



    const [loggedInUser, setLoggedInUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const webzashUrl = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
    const webzashLedgersAPI = `${webzashUrl}/api/ledgers/index`;
    const [allLedgers, setAllLedgers] = useState([]);
    const [officeLedgers, setOfficeLedgers] = useState([]);
    const [indirectExpenseLedgers, setIndirectExpenseLedgers] = useState([]);
    // New state for view mode
    const [viewModeStep, setViewModeStep] = useState(1);
    const isCreateMode = !expenseId && !expenseData;
    const isViewMode = !isEditMode && (expenseId || expenseData);
    const [vendorAdvances, setVendorAdvances] = useState([]);
    const [payrollProviders, setPayrollProviders] = useState([]);
    const [activeTab, setActiveTab] = useState('details'); // 'details' or 'preview'
    const [expensePaymentHistory, setExpensePaymentHistory] = useState([]);
    const [expensePaymentSummary, setExpensePaymentSummary] = useState({
        totalPaid: 0,
        remainingBalance: 0,
        status: 'pending',
    });



    // Add these state variables near your other state declarations
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState("");
    const [selectedCurrency, setSelectedCurrency] = useState("AED"); // Default currency
    const [showCurrencyDropdown, setShowCurrencyDropdown] = useState(false);
    const [activeCurrencyDropdownBillId, setActiveCurrencyDropdownBillId] = useState(null);
    const [accountGroups, setAccountGroups] = useState([]);
    const [selectedExpenseType, setSelectedExpenseType] = useState(null);
    const [selectedVendorObj, setSelectedVendorObj] = useState(null);
    const [formData, setFormData] = useState({
        project_id: projectId || '',
        amount: '',
        expense_type: '',
        user_id: '',
        expense_type_id: '',
        narration: '',
        date: '',
        attatchment: null,
        client_id: clientId || '',
        invoice_no: "",
        invoice_date: "",
        amount_without_tax: "",
        tax: 5,
        adjustment_amount: "",
        total_amount: "",
        tax_type: "",
        type: isExpensePage ? "" : "internal",
        reconciliation_status: 'pending',
        payment_type: '',
        payment_method: '',
        vendor_id: '',
        office_ledger_id: '',
        indirect_expense_type_id: '',
        bank_account_id: '',
        petty_cash_employee_id: '',
        voucher_no: '',
        purchase_order_id: '',
        wps_charge: '',
        wps_vat: '',
        payroll_provider_id: '',
        journal_id: '',
    });

    // Multiple Bills Mode State & Handlers
    const [billMode, setBillMode] = useState('single'); // 'single' | 'multiple'

    const createNewBillItem = () => ({
        id: Date.now() + Math.random(),
        bill_no: '',
        invoice_no: '',
        bill_date: '',
        invoice_date: '',
        amount: '',
        amount_without_tax: '',
        tax: 5,
        vat_amount: '',
        adjustment_amount: '',
        total_amount: '',
        attatchment: null,
        previewUrl: null,
        narration: '',
        error: {}
    });

    const [multipleBills, setMultipleBills] = useState([createNewBillItem()]);
    const [commonBillDate, setCommonBillDate] = useState('');

    // When common bill date changes, push it to all bills that haven't been individually overridden
    const handleCommonBillDateChange = (newDate) => {
        setCommonBillDate(newDate);
        setMultipleBills(prev => prev.map(bill => {
            // Only overwrite if the bill is still using the previous common date (not individually overridden)
            if (!bill._dateOverridden) {
                return { ...bill, bill_date: newDate, invoice_date: newDate };
            }
            return bill;
        }));
    };

    const addBillItem = () => {
        setMultipleBills(prev => [
            ...prev,
            createNewBillItem()
        ]);
    };

    const removeBillItem = (id) => {
        if (multipleBills.length <= 1) return;
        setMultipleBills(prev => prev.filter(bill => bill.id !== id));
    };

    const updateBillItem = (id, field, value) => {
        setMultipleBills(prev => prev.map(bill => {
            if (bill.id !== id) return bill;
            const updated = { ...bill, [field]: value };

            if (field === 'bill_no') updated.invoice_no = value;
            if (field === 'invoice_no') updated.bill_no = value;
            if (field === 'bill_date') {
                updated.invoice_date = value;
                // Mark as individually overridden only if value differs from common date
                updated._dateOverridden = value !== commonBillDate;
            }
            if (field === 'invoice_date') {
                updated.bill_date = value;
                updated._dateOverridden = value !== commonBillDate;
            }

            if (formData.tax_type === 'taxable') {
                if (field === 'amount_without_tax' || field === 'tax') {
                    const base = parseFloat(field === 'amount_without_tax' ? value : updated.amount_without_tax) || 0;
                    const taxRate = parseFloat(field === 'tax' ? value : updated.tax) || 5;
                    const calcVat = ((base * taxRate) / 100).toFixed(2);
                    updated.vat_amount = calcVat;
                    const adj = parseFloat(updated.adjustment_amount || 0);
                    updated.total_amount = (base + parseFloat(calcVat) + adj).toFixed(2);
                } else if (field === 'vat_amount') {
                    const base = parseFloat(updated.amount_without_tax || 0);
                    const vat = parseFloat(value || 0);
                    const adj = parseFloat(updated.adjustment_amount || 0);
                    updated.total_amount = (base + vat + adj).toFixed(2);
                } else if (field === 'adjustment_amount') {
                    const base = parseFloat(updated.amount_without_tax || 0);
                    const vat = parseFloat(updated.vat_amount || 0);
                    const adj = parseFloat(value || 0);
                    updated.total_amount = (base + vat + adj).toFixed(2);
                }
            } else {
                if (field === 'amount' || field === 'adjustment_amount') {
                    const base = parseFloat(field === 'amount' ? value : updated.amount) || 0;
                    const adj = parseFloat(field === 'adjustment_amount' ? value : updated.adjustment_amount) || 0;
                    updated.total_amount = (base + adj).toFixed(2);
                }
            }

            if (updated.error && updated.error[field]) {
                updated.error = { ...updated.error, [field]: undefined };
            }

            return updated;
        }));
    };

    const handleBillAttachmentChange = (id, file) => {
        if (!file) return;
        const maxSize = 5 * 1024 * 1024;
        if (file.size > maxSize) {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'File size must be less than 5MB',
                timer: 3000,
                showConfirmButton: false,
            });
            return;
        }

        const preview = URL.createObjectURL(file);
        setMultipleBills(prev => prev.map(bill => {
            if (bill.id !== id) return bill;
            return {
                ...bill,
                attatchment: file,
                previewUrl: preview
            };
        }));
    };

    const removeBillAttachment = (id) => {
        setMultipleBills(prev => prev.map(bill => {
            if (bill.id !== id) return bill;
            return {
                ...bill,
                attatchment: null,
                previewUrl: null
            };
        }));
    };

    const multipleBillsTotal = React.useMemo(() => {
        let totalBase = 0;
        let totalVat = 0;
        let grandTotal = 0;

        multipleBills.forEach(bill => {
            if (formData.tax_type === 'taxable') {
                const base = parseFloat(bill.amount_without_tax || 0);
                const vat = parseFloat(bill.vat_amount || 0);
                const adj = parseFloat(bill.adjustment_amount || 0);
                totalBase += base;
                totalVat += vat;
                grandTotal += (base + vat + adj);
            } else {
                const amt = parseFloat(bill.amount || 0);
                const adj = parseFloat(bill.adjustment_amount || 0);
                totalBase += amt;
                grandTotal += (amt + adj);
            }
        });

        return {
            count: multipleBills.length,
            totalBase: totalBase.toFixed(2),
            totalVat: totalVat.toFixed(2),
            grandTotal: grandTotal.toFixed(2)
        };
    }, [multipleBills, formData.tax_type]);

    // Auto-synchronize deferred per-period amount whenever amount or dates change
    useEffect(() => {
        if (formData.type === 'deferred' && deferredFields.deferred_start_date && deferredFields.deferred_end_date) {
            const amount = parseFloat(taxFields.total_amount || formData.total_amount || formData.amount || 0);
            const { periods, perPeriod } = calculateDeferredPeriods(
                deferredFields.deferred_start_date,
                deferredFields.deferred_end_date,
                deferredFields.recognition_period,
                amount
            );
            
            // Only update if values actually changed to avoid infinite loops
            if (parseFloat(perPeriod) !== parseFloat(deferredFields.amount_per_period) || 
                periods !== deferredFields.total_periods) {
                setDeferredFields(prev => ({
                    ...prev,
                    total_periods: periods,
                    amount_per_period: perPeriod
                }));
            }
        }
    }, [
        formData.type,
        formData.amount,
        formData.total_amount,
        taxFields.total_amount,
        deferredFields.deferred_start_date,
        deferredFields.deferred_end_date,
        deferredFields.recognition_period
    ]);


    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        if (userInfo) {
            const user = userInfo.user || userInfo;
            setLoggedInUser(user);
            const roles = userInfo.roles || [];
            setIsAdmin(roles.includes('admin') || roles.includes('superadmin'));
        }
    }, []);
    const fetchVendorAdvances = async (vendorId, poId = null) => {
        try {
            const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
            const backendUrl = `${API}/api`;
            const headers = {
                'x-api-key': process.env.REACT_APP_API_KEY,
                'Accept': 'application/json'
            };

            const params = {
                vendor_id: vendorId,
                ledger_name: 'Vendor Advances'
            };

            if (poId) {
                params.po_id = poId;
            }

            const response = await axios.get(`${backendUrl}/entries/search`, {
                headers,
                params,
                skipLoader: true,
            });

            if (response.data.success) {
                let filteredAdvances = response.data.advances || [];
                let calculatedTotal = response.data.total_advance || 0;

                // If handling specific PO (even if null for "direct"), filter the list
                // Case 1: PO ID is provided -> Filter for THAT PO
                // if (poId) {
                //     filteredAdvances = filteredAdvances.filter(adv => adv.po_id == poId);
                // }
                // // Case 2: No PO ID provided -> Filter for advances with NO PO (direct advances)
                // // Case 2: No PO ID provided -> Filter for advances with NO PO (direct advances)
                // else {
                //     filteredAdvances = filteredAdvances.filter(adv => !adv.po_id);
                // }

                // Recalculate total based on filtered list
                // Calculate total given - total used for the filtered advances
                // Note: The structure shows 'advances' list. Use 'available_advance' if trustworthy, 
                // but since we are filtering, we might need to sum up the 'amount' of 'advance_given' type?
                // Actually, backend returns 'total_advance' which is usually aggregated. 
                // We should rely on the filtered list to derive the usable amount if possible, 
                // OR just trust the list if it contains balance entries.
                // Looking at the JSON:
                // "advances" contains history. "total_advance" is the sum.
                // We should probably sum the 'amount' of filtered advances?
                // Wait, the JSON shows "matches" and "advance_used". 
                // Let's safe-bet: use the filtered list length to decide valid advances, 
                // and for the AMOUNT, we might need to sum (given - used) for these specific entries.
                // However, without complex logic, let's just use the filtered advances list for display
                // and if the user wants to limit the AMOUNT, we might need to sum it up.

                // Let's try to sum it up to be accurate:
                const given = filteredAdvances
                    .filter(a => a.type === 'advance_given')
                    .reduce((sum, a) => sum + parseFloat(a.amount || 0), 0);

                const used = filteredAdvances
                    .filter(a => a.type === 'advance_used')
                    .reduce((sum, a) => sum + Math.abs(parseFloat(a.amount || 0)), 0);

                calculatedTotal = given - used;
                console.log("DEBUG: fetchVendorAdvances", {
                    vendorId,
                    poId,
                    totalAdvancesCount: response.data.advances.length,
                    filteredCount: filteredAdvances.length,
                    given,
                    used,
                    calculatedTotal
                });

                setFormData(prev => ({
                    ...prev,
                    vendor_advance_balance: calculatedTotal
                }));

                setVendorAdvances(filteredAdvances);

                // If there's advance, auto-fill the advance field
                if (calculatedTotal > 0) {
                    const expenseAmount = formData.tax_type === "taxable"
                        ? parseFloat(taxFields.amount_without_tax || 0)
                        : parseFloat(formData.amount || 0);

                    const maxAdvance = Math.min(calculatedTotal, expenseAmount);

                    setFormData(prev => ({
                        ...prev,
                        advance_applied: maxAdvance,
                        apply_advance: maxAdvance > 0
                    }));
                }
            }
        } catch (error) {
            console.warn("Could not fetch vendor advances:", error);
        }
    };

    const fetchPayrollProviders = async () => {
        try {
            const API = process.env.REACT_APP_WEBZASH_URL || 'http://localhost/webzash-integration';
            const backendUrl = process.env.REACT_APP_BACKEND_URL; // Use standard backend URL for this

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const headers = {
                Authorization: `Bearer ${token}`,
                'Tenant-Origin': origin,
            };

            // Fetch from both endpoints similar to TransactionModal
            const [payrollRes, bankRes] = await Promise.all([
                axios.get(`${backendUrl}/api/payroll-providers`, {
                    headers,
                    skipLoader: true,
                }),
                axios.get(`${backendUrl}/api/bank-accounts`, {
                    headers,
                    params: { is_payroll_provider: true, type: 'bank account' },
                    skipLoader: true,
                }),
            ]);

            const pProviders = (payrollRes.data?.data || []).map(p => ({
                id: p.id,
                name: p.name,
                provider_type: 'payroll',
                is_payroll_provider: true
            }));

            const bProviders = (bankRes.data?.account || [])
                .filter(b => b.is_payroll_provider === true || b.is_payroll_provider === 'true' || b.is_payroll_provider === 1 || b.is_payroll_provider === '1')
                .map(b => ({
                    id: b.id,
                    name: b.name,
                    provider_type: 'bank',
                    is_payroll_provider: true
                }));

            const combined = [...pProviders, ...bProviders];
            // Sort combined list alphabetically by name
            const sortedCombined = combined.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setPayrollProviders(sortedCombined);

        } catch (error) {
            console.warn("Could not fetch payroll providers:", error);
        }
    };

    const parseAmount = (value) => {
        const numericValue = parseFloat(value);
        return Number.isFinite(numericValue) ? numericValue : 0;
    };

    const getExpenseVoucherLabel = (transaction) => {
        return (
            transaction?.transaction_voucher_id ||
            transaction?.voucher_id ||
            transaction?.voucher_no ||
            transaction?.reference_no ||
            (transaction?.id ? `TXN-${transaction.id}` : 'Transaction')
        );
    };

    const getExpensePaymentCurrency = (transaction) => {
        if (transaction?.currency?.currency) return transaction.currency.currency;
        if (transaction?.currency?.code) return transaction.currency.code;
        if (typeof transaction?.currency === 'string') return transaction.currency;
        if (transaction?.account?.base_currency?.currency) return transaction.account.base_currency.currency;
        if (transaction?.account?.currency?.currency) return transaction.account.currency.currency;
        if (transaction?.account?.currency) return transaction.account.currency;
        return formData.vendor_currency || selectedCurrency || 'AED';
    };

    useEffect(() => {
        const fetchExpensePaymentHistory = async () => {
            if (!showModal || !isViewMode || !expenseId) {
                setExpensePaymentHistory([]);
                setExpensePaymentSummary({
                    totalPaid: 0,
                    remainingBalance: 0,
                    status: 'pending',
                });
                return;
            }

            try {
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const origin = localStorage.getItem('user-origin');
                const token = userInfo?.token;

                const currentType = expenseData?.type || formData.type;
                const params = { type: currentType === 'salary' ? 'payroll' : 'expense', per_page: 9999 };
                if (expenseData?.vendor_id || formData.vendor_id) {
                    params.vendor_id = expenseData?.vendor_id || formData.vendor_id;
                }
                if (expenseData?.user_id || formData.user_id) {
                    params.user_id = expenseData?.user_id || formData.user_id;
                }

                let rawTransactions = [];
                if (expenseData && Array.isArray(expenseData.transactionItems) && expenseData.transactionItems.length > 0) {
                    rawTransactions = expenseData.transactionItems.map(item => ({
                        ...item.transaction,
                        transaction_expense_items: [item]
                    }));
                } else {
                    const response = await axios.get(`${backendUrl}/api/transactions`, {
                        params,
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                        skipLoader: true,
                    });
                    rawTransactions = response.data?.data?.data || response.data?.data || [];
                }
                const matchedPayments = [];

                rawTransactions.forEach((transaction) => {
                    const allExpenseItems = transaction?.transaction_expense_items || [];
                    const allBillAllocations = transaction?.bill_allocations || [];
                    
                    // Combine all allocations for this transaction
                    const allAllocations = [
                        ...allExpenseItems.map(item => {
                            const expenseNarration = item.expense?.narration;
                            const expenseTypeName = expenseTypes?.find(et => String(et.id) === String(item.expense?.expense_type_id))?.name;
                            
                            return {
                                expenseId: String(item.expense_id || item.expense?.id),
                                amount: parseAmount(item.amount || item.paid_amount || item.amount_paid),
                                remaining_balance: parseAmount(item.balance_amount || item.remaining_balance || item.balance),
                                label: expenseNarration || expenseTypeName || item.expense?.invoice_no || item.expense?.external_id || `Expense #${item.expense_id}`,
                                poRef: item.po_reference_no || item.expense?.purchase_order?.ref_no || ''
                            };
                        }),
                        ...allBillAllocations.map(item => ({
                            expenseId: String(item.expense_id),
                            amount: parseAmount(item.allocated_amount || item.amount || item.amount_paid || item.paid_amount),
                            remaining_balance: parseAmount(item.remaining_balance || 0),
                            label: item.narration || `Expense #${item.expense_id}`,
                            poRef: item.po_reference_no || ''
                        }))
                    ];

                    const currentAllocation = allAllocations.find(a => a.expenseId === String(expenseId));

                    if (currentAllocation && currentAllocation.amount > 0) {
                        const txnTotalAmount = parseAmount(transaction.amount || transaction.total_bank_amount || transaction.base_amount);
                        const totalAllocatedAmount = allAllocations.reduce((sum, a) => sum + a.amount, 0);
                        const storedRate = parseFloat(transaction.exchange_rate || 1);
                        
                        // Derive accurate rate if stored rate is 1.0 but currencies definitely differ
                        let effectiveRate = storedRate;
                        if (storedRate === 1 && Math.abs(txnTotalAmount - totalAllocatedAmount) > 0.01 && totalAllocatedAmount > 0) {
                            effectiveRate = txnTotalAmount / totalAllocatedAmount;
                        }

                        matchedPayments.push({
                            key: `payment-${transaction.id}-${expenseId}`,
                            transactionId: transaction.id,
                            date: transaction.date,
                            voucherId: getExpenseVoucherLabel(transaction),
                            amount: currentAllocation.amount, // Record in original currency (for balance logic)
                            transactionAmount: currentAllocation.amount * effectiveRate, // Display in AED
                            totalTransactionAmount: txnTotalAmount,
                            currency: getExpensePaymentCurrency(transaction),
                            exchangeRate: effectiveRate.toFixed(4),
                            accountName: transaction?.account?.name || transaction?.bank_name || transaction?.account_name || '',
                            otherAllocations: allAllocations.filter(a => a.expenseId !== String(expenseId)),
                            // CRITICAL: Use the allocated bill's remaining balance
                            rawRemainingBalance: currentAllocation.remaining_balance || 0,
                        });
                    }
                });

                matchedPayments.sort((a, b) => {
                    const dateA = a.date ? new Date(a.date).getTime() : 0;
                    const dateB = b.date ? new Date(b.date).getTime() : 0;
                    return dateA - dateB;
                });

                const expenseTotalAmount = parseAmount(expenseData?.total_amount || expenseData?.amount || formData.total_amount || formData.amount);
                let runningPaid = 0;
                const normalizedPayments = matchedPayments.map(payment => {
                    runningPaid += payment.amount;
                    const computedRemaining = Math.max(0, expenseTotalAmount - runningPaid);

                    return {
                        ...payment,
                        remainingBalance: payment.rawRemainingBalance > 0 ? payment.rawRemainingBalance : computedRemaining,
                    };
                });

                const totalPaid = normalizedPayments.reduce((sum, payment) => sum + payment.amount, 0);
                const remainingBalance = Math.max(0, expenseTotalAmount - totalPaid);
                
                // Use is_paid from database as primary source of truth for 'fully_paid'
                const isPaidInDb = expenseData?.is_paid === 1 || expenseData?.is_paid === '1' || expenseData?.is_paid === true;
                
                const status = isPaidInDb
                    ? 'fully_paid'
                    : totalPaid > 0
                        ? 'partially_paid'
                        : 'pending';

                setExpensePaymentHistory(normalizedPayments);
                setExpensePaymentSummary({
                    totalPaid,
                    remainingBalance,
                    status,
                });
            } catch (error) {
                console.error('Error fetching expense payment history:', error);
                setExpensePaymentHistory([]);
                setExpensePaymentSummary({
                    totalPaid: 0,
                    remainingBalance: 0,
                    status: 'pending',
                });
            }
        };

        fetchExpensePaymentHistory();
    }, [showModal, isViewMode, expenseId, expenseData, formData.vendor_id, formData.user_id, formData.total_amount, formData.amount, formData.vendor_currency, selectedCurrency]);

    useEffect(() => {
        if (showModal && users?.length === 0) {
            fetchUsers();
        }
        if (showModal && expenseTypes?.length === 0) {
            fetchExpenseTypes();
        }
        if (showModal && !expenseId && !expenseData && loggedInUser && !isAdmin) {
            setFormData(prev => ({
                ...prev,
                user_id: loggedInUser.id
            }));
        }

        // Reset form when modal opens
        if (showModal && !expenseData) {
            const today = new Date().toISOString().split('T')[0];
            setFormData({
                project_id: projectId || '',
                amount: '',
                expense_type: '',
                user_id: '',
                expense_type_id: '',
                narration: '',
                date: today,
                attatchment: null,
                previewUrl: null,
                client_id: clientId || '',
                invoice_no: '',
                invoice_date: '',
                amount_without_tax: '',
                total_amount: '',
                vendor_id: '',
                tax: 5,
                adjustment_amount: '',
                type: isExpensePage ? "" : "internal",
                tax_type: '',
                reconciliation_status: 'pending',
                payment_type: '',
                payment_method: '',
                office_ledger_id: '',
                indirect_expense_type_id: '',
                bank_account_id: '',
                petty_cash_employee_id: '',
                voucher_no: '',
                wps_charge: '',
                wps_vat: '',
                payroll_provider_id: '',
                journal_id: '',
                vendor_currency: 'AED',
            });
            setSelectedCurrency('AED');
            setTaxFields({
                invoice_no: '',
                invoice_date: '',
                amount_without_tax: '',
                tax: 5,
                vat_amount: '',
                adjustment_amount: '',
                total_amount: '',
            });
            setCurrentStep(1);
            setPaymentType("");
            setPaymentMethod("");
            setLockError('');
            setBillMode('single');
            setMultipleBills([createNewBillItem()]);
            setCommonBillDate('');
            setActiveCurrencyDropdownBillId(null);
            setDeferredFields({
                recognition_period: 'monthly',
                deferred_start_date: '',
                deferred_end_date: '',
                total_periods: 0,
                amount_per_period: 0
            });
        }

        if (expenseId && expenseData) {
            console.log('EDIT MODE INITIALIZATION:', {
                expenseData,
                expense_type_id: expenseData.expense_type_id,
                payment_type: expenseData.payment_type,
                vendor_currency: expenseData.vendor_currency
            });

            const currencyToUse = expenseData.vendor_currency || "AED";
            setSelectedCurrency(currencyToUse);
            if (expenseData.vendor_id) {
                setSelectedVendor(expenseData.vendor_id);
            }

            setFormData({
                ...expenseData,
                project_id: expenseData.project_id || '',
                attatchment: null,
                previewUrl: typeof expenseData.attatchment === "string" ? expenseData.attatchment : null,
                reconciliation_status: 'pending',
                purchase_order_id: expenseData.purchase_order_id || '', // Add this
                expense_type_id: expenseData.expense_type_id || '',
                payroll_provider_id: expenseData.payroll_provider_id || '',
                wps_charge: expenseData.wps_charge || '',
                wps_vat: expenseData.wps_vat || '',
            });
            setTaxFields({
                invoice_no: expenseData.invoice_no || "",
                invoice_date: expenseData.invoice_date || "",
                amount_without_tax: expenseData.amount_without_tax || "",
                tax: parseFloat(expenseData.tax) || 5,
                vat_amount: expenseData.vat_amount || "",
                adjustment_amount: expenseData.adjustment_amount || "",
                total_amount: expenseData.total_amount || "",
            });
            setPaymentType(expenseData.payment_type || "");
            setPaymentMethod(expenseData.payment_method || "");
            if (expenseData.type === 'deferred') {
                setDeferredFields({
                    recognition_period: expenseData.recognition_period || 'monthly',
                    deferred_start_date: expenseData.deferred_start_date || '',
                    deferred_end_date: expenseData.deferred_end_date || '',
                    total_periods: expenseData.total_periods || 0,
                    amount_per_period: expenseData.amount_per_period || 0
                });
            }

            if (expenseData.expense_type_id && expenseTypes.length > 0) {
                const selectedExpenseType = expenseTypes.find(et =>
                    et.id?.toString() === expenseData.expense_type_id?.toString()
                );

                if (selectedExpenseType) {
                    console.log('Found expense type for edit:', selectedExpenseType);
                    setSelectedExpenseType(selectedExpenseType);

                    // Determine payment type from expense type
                    const determinedPaymentType = decidePaymentType(selectedExpenseType);
                    console.log('Determined payment type:', determinedPaymentType);

                    // Use the determined payment type (it's more accurate than saved payment_type)
                    setPaymentType(determinedPaymentType);

                    // Update formData with correct payment type
                    setFormData(prev => ({
                        ...prev,
                        payment_type: determinedPaymentType,
                        group_id: selectedExpenseType.group_id || selectedExpenseType.category?.group_id || "",
                        category_type: selectedExpenseType.category?.category_type || ""
                    }));
                }
            }

            if (expenseData.client_id) {
                setSelectedClient(expenseData.client_id);
                fetchProjects(expenseData.client_id);
            }
            setLockError('');
        }
    }, [expenseId, expenseData, showModal, loggedInUser, isAdmin, expenseTypes]);

    useEffect(() => {
        if (!showModal) {
            setCommonBillDate('');
            setMultipleBills([createNewBillItem()]);
            setActiveCurrencyDropdownBillId(null);
        }
    }, [showModal]);


    const createHierarchicalExpenseTypeStructure = (ledgers, groups, expenseTypes) => {
        console.log('=== CREATE HIERARCHICAL STRUCTURE DEBUG ===');

        // Step 1: Build a map of all groups from Webzash
        const groupsById = {};

        groups.forEach((groupItem) => {
            const group = groupItem.Group || groupItem;
            if (group && group.id) {
                groupsById[group.id] = {
                    id: group.id,
                    name: group.name,
                    parent_id: group.parent_id,
                    children: []
                };
            }
        });

        // Step 2: Build parent-child relationships for groups
        Object.values(groupsById).forEach(group => {
            if (group.parent_id && groupsById[group.parent_id]) {
                groupsById[group.parent_id].children.push(group);
            }
        });

        // Step 3: Create ledger mapping
        const ledgerMap = {};
        ledgers.forEach((ledgerItem) => {
            const ledger = ledgerItem.Ledger || ledgerItem;
            if (ledger && ledger.name) {
                const normalizedName = ledger.name.trim().toLowerCase();
                ledgerMap[normalizedName] = {
                    id: ledger.id,
                    name: ledger.name,
                    group_id: ledger.group_id
                };
            }
        });

        // Step 4: Group expense types by their category (child group)
        // First, let's organize expense types by their category
        const expenseTypesByCategory = {};

        expenseTypes.forEach((expenseType) => {
            // Get category info
            const category = expenseType.category;
            if (!category) {
                console.warn(`Expense type "${expenseType.name}" has no category`);
                return;
            }

            const categoryId = category.id;
            const categoryName = category.name;
            const groupId = category.group_id;

            if (!categoryId || !categoryName) {
                console.warn(`Expense type "${expenseType.name}" has invalid category`);
                return;
            }

            // Create category entry if it doesn't exist
            if (!expenseTypesByCategory[categoryId]) {
                expenseTypesByCategory[categoryId] = {
                    id: categoryId,
                    name: categoryName,
                    group_id: groupId,
                    parent_group_id: groupsById[groupId]?.parent_id,
                    expenseTypes: []
                };
            }

            // Find matching ledger
            const normalizedExpenseName = expenseType.name?.trim().toLowerCase() || '';
            const matchingLedger = ledgerMap[normalizedExpenseName];

            // Add expense type to its category
            expenseTypesByCategory[categoryId].expenseTypes.push({
                id: expenseType.id,
                name: expenseType.name,
                category_id: categoryId,
                category_name: categoryName,
                matchingLedger: matchingLedger,
                expenseTypeData: expenseType,
                ledgerId: matchingLedger?.id || null
            });
        });

        // Step 5: Define the main parent groups to display
        const parentGroupsToShow = [
            { id: 12, name: 'Direct Expenses', parent_id: 4 },
            { id: 14, name: 'Indirect Expenses', parent_id: 4 },
            { id: 5, name: 'Fixed Assets', parent_id: 1 },
            { id: 6, name: 'Current Assets', parent_id: 1 }
        ];

        // Step 6: Build the display structure - group categories by their parent group
        const result = parentGroupsToShow.map(parentConfig => {
            const parentGroupId = parentConfig.id;

            // Find all categories that belong to this parent group
            // Categories are matched by: category.group_id === parentGroupId 
            // OR groupsById[category.group_id]?.parent_id === parentGroupId
            const categoriesForParent = Object.values(expenseTypesByCategory).filter(category => {
                // Direct match: category's group is this parent
                if (category.group_id === parentGroupId) {
                    return true;
                }

                // Indirect match: category's parent group is this parent
                const categoryGroup = groupsById[category.group_id];
                if (categoryGroup && categoryGroup.parent_id === parentGroupId) {
                    return true;
                }

                return false;
            });

            // Separate categories into direct (under parent) and child groups
            const directCategories = [];
            const childGroupCategories = [];

            categoriesForParent.forEach(category => {
                // Sort expense types within category
                category.expenseTypes.sort((a, b) => a.name.localeCompare(b.name));

                if (category.group_id === parentGroupId) {
                    // This category is directly under the parent
                    directCategories.push(category);
                } else {
                    // This category is under a child group of the parent
                    childGroupCategories.push(category);
                }
            });

            // Prepare display children
            const displayChildren = [];

            // 1. Add direct categories (if any)
            if (directCategories.length > 0) {
                // If there's only one direct category with the same name as parent, use it directly
                if (directCategories.length === 1 && directCategories[0].name === parentConfig.name) {
                    displayChildren.push({
                        id: directCategories[0].id,
                        name: directCategories[0].name,
                        type: 'category',
                        expenseTypes: directCategories[0].expenseTypes
                    });
                } else {
                    // Multiple direct categories or different name
                    directCategories.forEach(category => {
                        displayChildren.push({
                            id: category.id,
                            name: category.name,
                            type: 'direct_category',
                            expenseTypes: category.expenseTypes
                        });
                    });
                }
            }

            // 2. Add child group categories
            childGroupCategories.forEach(category => {
                displayChildren.push({
                    id: category.id,
                    name: category.name, // This is the category name from expenseType.category.name
                    type: 'child_category',
                    expenseTypes: category.expenseTypes
                });
            });

            // Sort children: direct categories first, then alphabetically
            displayChildren.sort((a, b) => {
                if (a.type === 'direct_category' && b.type !== 'direct_category') return -1;
                if (a.type !== 'direct_category' && b.type === 'direct_category') return 1;
                return a.name.localeCompare(b.name);
            });

            // Only include parent if it has children
            if (displayChildren.length === 0) {
                return null;
            }

            return {
                id: parentGroupId,
                name: parentConfig.name,
                children: displayChildren
            };
        }).filter(Boolean);

        // Step 7: Debug logging
        console.log('FINAL STRUCTURE:');
        result.forEach(parent => {
            console.log(`\n=== ${parent.name} ===`);
            parent.children.forEach(child => {
                console.log(`  ├─ ${child.name} [${child.type}] (${child.expenseTypes.length} types)`);
                child.expenseTypes.forEach(expenseType => {
                    console.log(`  │  └─ ${expenseType.name}`);
                });
            });
        });

        console.log('\n=== SUMMARY ===');
        console.log(`Total parent groups: ${result.length}`);
        result.forEach(parent => {
            const totalExpenseTypes = parent.children.reduce((sum, child) => sum + child.expenseTypes.length, 0);
            console.log(`${parent.name}: ${parent.children.length} categories, ${totalExpenseTypes} expense types`);
        });

        return result;
    };

    // Updated filter function
    const filterHierarchicalExpenseTypes = (hierarchicalData, searchTerm) => {
        if (!searchTerm || !searchTerm.trim()) {
            return hierarchicalData.filter(parent =>
                parent.children.some(child => child.expenseTypes.length > 0)
            );
        }

        const searchLower = searchTerm.toLowerCase();

        return hierarchicalData
            .map(parent => {
                // Filter children (categories)
                const filteredChildren = parent.children
                    .map(child => {
                        // Check if category name matches
                        const childMatches = child.name.toLowerCase().includes(searchLower);

                        // Filter expense types in this category
                        const filteredExpenseTypes = child.expenseTypes.filter(expenseType =>
                            expenseType.name.toLowerCase().includes(searchLower)
                        );

                        // Include if category name matches or has matching expense types
                        if (childMatches || filteredExpenseTypes.length > 0) {
                            return {
                                ...child,
                                expenseTypes: childMatches ? child.expenseTypes : filteredExpenseTypes
                            };
                        }

                        return null;
                    })
                    .filter(child => child !== null && child.expenseTypes.length > 0);

                // Check if parent name matches
                const parentMatches = parent.name.toLowerCase().includes(searchLower);

                // Include parent if it matches or has filtered children
                if (parentMatches || filteredChildren.length > 0) {
                    return {
                        ...parent,
                        children: filteredChildren
                    };
                }

                return null;
            })
            .filter(parent => parent !== null);
    };

    // Updated HierarchicalExpenseTypeDropdown component
    const HierarchicalExpenseTypeDropdown = ({
        label,
        value,
        onChange,
        error,
        disabled = false
    }) => {
        const [isOpen, setIsOpen] = useState(false);
        const [searchTerm, setSearchTerm] = useState('');

        // Filter data
        const filteredData = filterHierarchicalExpenseTypes(filteredLedgers, searchTerm);

        const handleSelect = (expenseTypeId, expenseTypeName, expenseTypeData) => {
            const selectedExpenseType = expenseTypes.find(et =>
                et.id.toString() === expenseTypeId.toString()
            );

            const determinedPaymentType = decidePaymentType(selectedExpenseType);

            onChange({
                target: {
                    name: 'expense_type_id',
                    value: expenseTypeId,
                    expenseTypeName: expenseTypeName,
                    expenseTypeData: expenseTypeData.expenseTypeData,
                    paymentType: determinedPaymentType,
                    ledger_id: expenseTypeData.ledgerId || ''
                }
            });

            setIsOpen(false);
            setSearchTerm('');
        };

        // Get selected expense type name
        // const selectedExpenseTypeName = filteredData
        //     .flatMap(parent => parent.children.flatMap(child => child.expenseTypes))
        //     .find(expenseType => expenseType.id.toString() === value?.toString())?.name || '';

        // In your HierarchicalExpenseTypeDropdown component, fix the selected value display:
        const selectedExpenseTypeName = React.useMemo(() => {
            if (!value) return '';

            // Try to find in filtered data first
            for (const parent of filteredData) {
                for (const child of parent.children) {
                    for (const expenseType of child.expenseTypes) {
                        if (expenseType.id.toString() === value.toString()) {
                            return expenseType.name;
                        }
                    }
                }
            }

            // If not found in filtered data (maybe due to search), check expenseTypes
            const found = expenseTypes.find(et => et.id.toString() === value.toString());
            return found ? found.name : '';
        }, [value, filteredData, expenseTypes]);

        // Count total
        const totalExpenseTypes = filteredData.reduce((total, parent) =>
            total + parent.children.reduce((childTotal, child) =>
                childTotal + child.expenseTypes.length, 0
            ), 0
        );

        return (
            <Form.Group className="mb-3" style={{ position: 'relative' }}>
                <Form.Label className='form-font'>{label}</Form.Label>

                {/* Selected Value Display */}
                <div
                    className={`form-control form-feild ${error ? 'is-invalid' : ''}`}
                    onClick={() => !disabled && setIsOpen(!isOpen)}
                    style={{
                        cursor: disabled ? 'not-allowed' : 'pointer',
                        backgroundColor: disabled ? '#e9ecef' : 'white',
                        minHeight: '38px',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        userSelect: 'none'
                    }}
                    disabled={disabled}
                >
                    <span className={`${value ? 'text-dark' : 'text-muted'}`}>
                        {value ? selectedExpenseTypeName : 'Select expense type...'}
                    </span>

                    {!disabled && (
                        <div className="position-absolute end-0 me-2 d-flex align-items-center">
                            <small className="text-muted me-2">
                                {totalExpenseTypes} types
                            </small>
                            <i className={`mdi mdi-chevron-${isOpen ? 'up' : 'down'}`}></i>
                        </div>
                    )}
                </div>

                {/* Dropdown Panel */}
                {isOpen && !disabled && (
                    <>
                        <div
                            className="border rounded bg-white shadow-sm mt-1"
                            style={{
                                maxHeight: '400px',
                                overflowY: 'auto',
                                position: 'absolute',
                                width: '100%',
                                zIndex: 1050,
                                top: '100%',
                                left: 0
                            }}
                        >
                            {/* Search Bar */}
                            <div className="p-2 border-bottom bg-light sticky-top">
                                <Form.Control
                                    type="text"
                                    placeholder="Search expense types..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="form-control-sm"
                                    autoFocus
                                />
                                {searchTerm && (
                                    <small className="text-muted d-block mt-1">
                                        Found {totalExpenseTypes} matches
                                    </small>
                                )}
                            </div>

                            {/* Content */}
                            {filteredData.length > 0 ? (
                                filteredData.map(parent => (
                                    <div key={`parent-${parent.id}`}>
                                        {/* Parent Group Header */}
                                        <div className="p-2 bg-light text-dark sticky-top" style={{ top: '40px' }}>
                                            <small className="fw-bold">
                                                <i className="mdi mdi-folder-outline me-2"></i>
                                                {parent.name}
                                            </small>
                                        </div>

                                        {/* Categories (Child Groups) */}
                                        {parent.children.map(category => (
                                            <div key={`category-${category.id}`}>
                                                {/* Category Header */}
                                                <div className="p-2 ps-3 bg-light">
                                                    <small className="fw-semibold text-dark">
                                                        <i className="mdi mdi-folder me-2"></i>
                                                        {category.name}
                                                        <span className="badge bg-white text-dark border ms-2">
                                                            {category.expenseTypes.length}
                                                        </span>
                                                    </small>
                                                </div>

                                                {/* Expense Types */}
                                                {category.expenseTypes.map(expenseType => (
                                                    <div
                                                        key={expenseType.id}
                                                        className="p-2 ps-5 border-bottom"
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: value === expenseType.id ? '#e8f4fd' : 'transparent',
                                                            borderLeft: value === expenseType.id ? '3px solid #0d6efd' : 'none'
                                                        }}
                                                        onClick={() => handleSelect(
                                                            expenseType.id,
                                                            expenseType.name,
                                                            expenseType
                                                        )}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <div className="d-flex align-items-center">
                                                                <i className="mdi mdi-file-document-outline me-2"></i>
                                                                <span>{expenseType.name}</span>
                                                            </div>
                                                            {value === expenseType.id && (
                                                                <i className="mdi mdi-check-circle text-primary"></i>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                ))
                            ) : (
                                <div className="p-4 text-center">
                                    <i className="mdi mdi-file-search-outline display-4 text-muted mb-3"></i>
                                    <p className="text-muted mb-0">
                                        {searchTerm ? 'No matches found' : 'No data available'}
                                    </p>
                                </div>
                            )}
                        </div>

                        {/* Click Outside to Close */}
                        <div
                            className="position-fixed top-0 start-0 w-100 h-100"
                            style={{ zIndex: 1040 }}
                            onClick={() => setIsOpen(false)}
                        />
                    </>
                )}

                {error && <div className="invalid-feedback d-block font-size-12">*{error}</div>}
            </Form.Group>
        );
    };

    const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null);
    const [originalPOAmount, setOriginalPOAmount] = useState(0); // Store original PO amount in vendor currency
    const [originalPOCurrency, setOriginalPOCurrency] = useState("AED"); // Store original PO currency


    const fetchPurchaseOrders = async (vendorId, projectId, expenseType, paymentTypeParam) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Get the selected vendor
            const selectedVendor = vendors.find(v => v.id?.toString() === vendorId?.toString());
            const vendorCurrency = selectedVendor?.currency || "AED";

            // Build query parameters - ALWAYS fetch ALL POs for the vendor
            const params = {
                vendor_id: vendorId,
                product_null: true
            };

            // Remove project filtering for now to get all POs
            // We'll filter on frontend instead
            // if (expenseType === 'internal' && projectId) {
            //     params.project_id = projectId;
            // }
            const currentPaymentType = paymentTypeParam || paymentType || formData.payment_type;

            console.log('PO Fetching Logic:', {
                vendorId,
                projectId,
                expenseType,
                currentPaymentType,
                shouldFilterByProject: currentPaymentType === 'direct' && projectId
            });

            // SIMPLIFIED LOGIC: If it's a direct expense AND we have a project, filter by project
            if (currentPaymentType === 'direct' && projectId) {
                params.project_id = projectId;
                console.log('✅ FILTERING: Only POs for project', projectId);
            }
            // For internal expenses (petty cash), also filter by project if available
            else if (expenseType === 'internal' && projectId) {
                params.project_id = projectId;
                console.log('✅ FILTERING: Internal expense POs for project', projectId);
            }
            // For external expenses without project filter
            else if (expenseType === 'external') {
                console.log('✅ NO FILTER: Showing all POs for vendor (external expense)');
                // No project filter for external expenses
            }
            else {
                console.log('❌ NOT SHOWING POs - Invalid condition');
                setPurchaseOrders([]);
                return;
            }

            // Fetch purchase orders
            const response = await axios.get(`${backendUrl}/api/purchase-order`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: params,
                skipLoader: true,
            });

            // Calculate remaining amount for each PO
            let purchaseOrders = response.data.purchaseorders?.map(po => {
                const basicAmount = parseFloat(po.basic_amount || po.amount || 0);
                const usedAmount = parseFloat(po.used_amount || 0);
                const poCurrency = po.vendor_currency || vendorCurrency;
                const refNo = po.ref_no;

                const remainingAmountInPOCurrency = basicAmount - usedAmount;

                // Convert remaining amount to selected currency for display
                let remainingAmountInSelectedCurrency = remainingAmountInPOCurrency;
                if (poCurrency !== selectedCurrency) {
                    remainingAmountInSelectedCurrency = convertCurrency(
                        remainingAmountInPOCurrency,
                        poCurrency,
                        selectedCurrency
                    );
                }

                return {
                    ...po,
                    basic_amount: basicAmount,
                    used_amount: usedAmount,
                    remaining_amount: remainingAmountInPOCurrency,
                    converted_remaining_amount: remainingAmountInSelectedCurrency,
                    vendor_currency: poCurrency,
                    ref_no: refNo,

                    // Flag if this is the currently selected PO
                    isSelected: expenseId && formData.purchase_order_id &&
                        po.id.toString() === formData.purchase_order_id.toString()
                };
            }) || [];

            // CRITICAL: If we're editing and the selected PO isn't in the list, fetch it separately
            if (expenseId && formData.purchase_order_id) {
                const selectedPOId = formData.purchase_order_id;
                const selectedPOAlreadyInList = purchaseOrders.some(po =>
                    po.id.toString() === selectedPOId.toString()
                );

                if (!selectedPOAlreadyInList) {
                    try {
                        const poResponse = await axios.get(`${backendUrl}/api/purchase-order/${selectedPOId}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                'Tenant-Origin': origin,
                            },
                            skipLoader: true,
                        });

                        if (poResponse.data.purchaseorder) {
                            const po = poResponse.data.purchaseorder;
                            const basicAmount = parseFloat(po.basic_amount || po.amount || 0);
                            const usedAmount = parseFloat(po.used_amount || 0);
                            const poCurrency = po.vendor_currency || vendorCurrency;
                            const remainingAmountInPOCurrency = basicAmount - usedAmount;

                            let remainingAmountInSelectedCurrency = remainingAmountInPOCurrency;
                            if (poCurrency !== selectedCurrency) {
                                remainingAmountInSelectedCurrency = convertCurrency(
                                    remainingAmountInPOCurrency,
                                    poCurrency,
                                    selectedCurrency
                                );
                            }

                            // Add the PO to the list
                            purchaseOrders.unshift({
                                ...po,
                                basic_amount: basicAmount,
                                used_amount: usedAmount,
                                remaining_amount: remainingAmountInPOCurrency,
                                converted_remaining_amount: remainingAmountInSelectedCurrency,
                                vendor_currency: poCurrency,
                                isSelected: true
                            });
                        }
                    } catch (error) {
                        console.error('Error fetching selected PO:', error);
                    }
                }
            }

            // Sort: Selected PO first, then by ref_no alphabetically, then by remaining balance
            purchaseOrders.sort((a, b) => {
                if (a.isSelected && !b.isSelected) return -1;
                if (!a.isSelected && b.isSelected) return 1;

                // Secondary sort: ref_no alphabetically
                const refA = a.ref_no || `PO-${a.id}`;
                const refB = b.ref_no || `PO-${b.id}`;
                const nameCompare = refA.localeCompare(refB);
                if (nameCompare !== 0) return nameCompare;

                const aBalance = a.converted_remaining_amount || 0;
                const bBalance = b.converted_remaining_amount || 0;
                return bBalance - aBalance; // Higher balance first
            });

            setPurchaseOrders(purchaseOrders);

            console.log('Purchase Orders loaded:', {
                total: purchaseOrders.length,
                selectedPO: expenseId ? formData.purchase_order_id : null,
                selectedInList: purchaseOrders.filter(po => po.isSelected).length
            });

        } catch (error) {
            console.error('Error fetching purchase orders:', error);
            setPurchaseOrders([]);
        }
    };


    const handleVendorChange = async (e) => {
        const vendorId = e.target.value;
        if (vendorId) {
            await fetchVendorAdvances(vendorId);
        }
        const selectedVendorObjLocal = vendors.find(v => v.id.toString() === vendorId.toString());
        setSelectedVendorObj(selectedVendorObjLocal);

        setSelectedVendor(vendorId);
        setSelectedPurchaseOrder(null);
        setOriginalPOAmount(0);
        setOriginalPOCurrency("AED");

        setFormData(prev => ({
            ...prev,
            vendor_id: vendorId,
            purchase_order_id: "",
            amount: "",
            amount_without_tax: "",
            total_amount: "",
        }));

        // Reset tax fields
        setTaxFields(prev => ({
            ...prev,
            amount_without_tax: "",
            total_amount: "",
        }));

        // Set currency to vendor's currency
        if (selectedVendorObjLocal && selectedVendorObjLocal.currency) {
            setSelectedCurrency(selectedVendorObjLocal.currency);
        } else {
            setSelectedCurrency("AED");
        }

        // Fetch purchase orders when vendor is selected
        if (vendorId) {
            const expenseType = formData.type === "external" ? "external" : "internal";

            // Get the current payment type from formData or state
            const currentPaymentType = formData.payment_type || paymentType;

            console.log('Fetching POs with:', {
                vendorId,
                projectId: formData.project_id,
                expenseType,
                paymentTypeFromForm: formData.payment_type,
                paymentTypeFromState: paymentType,
                currentPaymentType
            });

            fetchPurchaseOrders(vendorId, formData.project_id, expenseType, currentPaymentType);
        } else {
            setPurchaseOrders([]);
        }
    };
    // Remove this state
    // const [isClientBasedProject, setIsClientBasedProject] = useState(false);

    // Update handleProjectChange
    const handleProjectChange = (e) => {
        const projectId = e.target.value;

        setFormData({
            ...formData,
            project_id: projectId,
            purchase_order_id: ""
        });

        // Reset PO if project changes
        setSelectedPurchaseOrder(null);

        // Fetch purchase orders for this project if vendor is selected
        if (formData.vendor_id) {
            const expenseType = formData.type === "external" ? "external" : "internal";
            fetchPurchaseOrders(formData.vendor_id, projectId, expenseType, paymentType);
        } else {
            setPurchaseOrders([]);
        }
    };

    const convertCurrency = (amount, fromCurrency, toCurrency) => {
        if (amount === null || amount === undefined) return 0;

        const amountNum = Number(amount);
        if (Number.isNaN(amountNum) || amountNum === 0) return 0;

        const from = String(fromCurrency).toUpperCase();
        const to = String(toCurrency).toUpperCase();

        if (from === to) return amountNum;

        const exchangeRateGlobal = parseFloat(localStorage.getItem('exchange_rate') || 3.692);

        const exchangeRates = {
            'USD_AED': exchangeRateGlobal || process.env.REACT_APP_EXCHANGE_RATE_USD_AED,
            'AED_USD': 1 / exchangeRateGlobal,
            'EUR_AED': 3.95,
            'AED_EUR': 0.25,
            'GBP_AED': 4.62,
            'AED_GBP': 0.22,
        };

        const rateKey = `${from}_${to}`;
        const rate = exchangeRates[rateKey];

        if (!rate) {
            console.warn('⚠️ Missing exchange rate for', rateKey);
            return amountNum; // safer than 1
        }

        return amountNum * rate;
    };

    const [lockError, setLockError] = useState('');
    // Helper to check if date is locked using your backend API
    const checkIfDateLocked = async (date) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/accounting/check-lock-status`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    params: { date },
                    skipLoader: true,
                }
            );

            return response.data.is_locked || false;
        } catch (error) {
            console.error('Error checking date lock:', error);
            return false; // Don't block on error, let backend handle it
        }
    };

    // const handleCurrencyChange = (newCurrency) => {
    //     // If currency is already the same, do nothing
    //     if (newCurrency === selectedCurrency) {
    //         setShowCurrencyDropdown(false);
    //         return;
    //     }

    //     // Only convert if we have an amount from PO
    //     if (originalPOAmount > 0 && formData.purchase_order_id) {
    //         // If original PO currency is USD and new currency is also USD, no conversion needed
    //         if (originalPOCurrency === newCurrency) {
    //             // Same currency - use original amount
    //             if (formData.tax_type === "taxable") {
    //                 setTaxFields(prev => ({
    //                     ...prev,
    //                     amount_without_tax: originalPOAmount.toFixed(2)
    //                 }));
    //                 setFormData(prev => ({
    //                     ...prev,
    //                     amount_without_tax: originalPOAmount.toFixed(2)
    //                 }));
    //             } else {
    //                 setFormData(prev => ({
    //                     ...prev,
    //                     amount: originalPOAmount.toFixed(2)
    //                 }));
    //             }

    //             Swal.fire({
    //                 toast: true,
    //                 position: 'top-end',
    //                 icon: 'info',
    //                 title: `Currency changed to ${newCurrency} (no conversion needed)`,
    //                 timer: 3000,
    //                 timerProgressBar: true,
    //                 showConfirmButton: false,
    //             });
    //         } else {
    //             // Different currency - convert
    //             const convertedAmount = convertCurrency(
    //                 originalPOAmount,
    //                 originalPOCurrency,
    //                 newCurrency
    //             );

    //             if (formData.tax_type === "taxable") {
    //                 setTaxFields(prev => ({
    //                     ...prev,
    //                     amount_without_tax: convertedAmount.toFixed(2)
    //                 }));
    //                 setFormData(prev => ({
    //                     ...prev,
    //                     amount_without_tax: convertedAmount.toFixed(2)
    //                 }));
    //             } else {
    //                 setFormData(prev => ({
    //                     ...prev,
    //                     amount: convertedAmount.toFixed(2)
    //                 }));
    //             }

    //             Swal.fire({
    //                 toast: true,
    //                 position: 'top-end',
    //                 icon: 'info',
    //                 title: `Converted: ${originalPOCurrency} ${originalPOAmount.toFixed(2)} = ${newCurrency} ${convertedAmount.toFixed(2)}`,
    //                 timer: 3000,
    //                 timerProgressBar: true,
    //                 showConfirmButton: false,
    //             });
    //         }
    //     }

    //     // Update selected currency
    //     setSelectedCurrency(newCurrency);
    //     setFormData(prev => ({
    //         ...prev,
    //         vendor_currency: newCurrency
    //     }));
    //     setShowCurrencyDropdown(false);
    // };

    // const handleCurrencyChange = (newCurrency) => {
    //     const oldCurrency = selectedCurrency;

    //     if (newCurrency === selectedCurrency) {
    //         setShowCurrencyDropdown(false);
    //         return;
    //     }

    //     // 1. First, get the vendor's original currency
    //     const vendorCurrency = selectedVendor?.currency || "AED";

    //     // 2. Get the original PO amount and currency
    //     const originalPOAmountInPOCurrency = originalPOAmount; // This is in originalPOCurrency
    //     const originalPOCurrencyValue = originalPOCurrency; // This is the PO's currency

    //     // 3. Convert the base amount (amount_without_tax)
    //     let newBaseAmount = parseFloat(taxFields.amount_without_tax || 0);

    //     // If we have a PO amount, use that as reference
    //     if (originalPOAmountInPOCurrency > 0 && formData.purchase_order_id) {
    //         // Convert from PO's currency to new currency
    //         newBaseAmount = convertCurrency(
    //             originalPOAmountInPOCurrency,
    //             originalPOCurrencyValue,
    //             newCurrency
    //         );
    //     } else if (newBaseAmount > 0) {
    //         // Convert existing amount from old currency to new currency
    //         newBaseAmount = convertCurrency(
    //             newBaseAmount,
    //             oldCurrency,
    //             newCurrency
    //         );
    //     }

    //     // 4. Handle advance conversion if applicable
    //     let newAdvanceAmount = parseFloat(formData.advance_applied || 0);

    //     if (formData.apply_advance && newAdvanceAmount > 0) {
    //         // Important: The advance should be converted based on its ORIGINAL currency (vendor's currency)
    //         // not based on the old selected currency

    //         // First, if advance was stored in old currency, convert it back to vendor currency
    //         let advanceInVendorCurrency = newAdvanceAmount;
    //         if (oldCurrency !== vendorCurrency) {
    //             advanceInVendorCurrency = convertCurrency(
    //                 newAdvanceAmount,
    //                 oldCurrency,
    //                 vendorCurrency
    //             );
    //         }

    //         // Then convert from vendor currency to new currency
    //         newAdvanceAmount = convertCurrency(
    //             advanceInVendorCurrency,
    //             vendorCurrency,
    //             newCurrency
    //         );

    //         // Update formData with converted advance
    //         setFormData(prev => ({
    //             ...prev,
    //             advance_applied: newAdvanceAmount
    //         }));
    //     }

    //     // 5. Update the taxFields with new base amount
    //     const updatedTaxFields = { ...taxFields };

    //     if (formData.tax_type === "taxable") {
    //         updatedTaxFields.amount_without_tax = newBaseAmount.toFixed(2);

    //         // Recalculate total amount with the new base and advance
    //         const netAmount = Math.max(0, newBaseAmount - newAdvanceAmount);
    //         const tax = (netAmount * (taxFields.tax || 5)) / 100;
    //         const adjustment = parseFloat(taxFields.adjustment_amount || 0);
    //         updatedTaxFields.total_amount = (netAmount + tax + adjustment).toFixed(2);

    //         setTaxFields(updatedTaxFields);
    //         setFormData(prev => ({
    //             ...prev,
    //             amount_without_tax: newBaseAmount.toFixed(2),
    //             total_amount: updatedTaxFields.total_amount
    //         }));
    //     } else {
    //         // For non-taxable
    //         setFormData(prev => ({
    //             ...prev,
    //             amount: newBaseAmount.toFixed(2)
    //         }));
    //     }

    //     // 6. Update selected currency
    //     setSelectedCurrency(newCurrency);
    //     setFormData(prev => ({
    //         ...prev,
    //         vendor_currency: newCurrency
    //     }));
    //     setShowCurrencyDropdown(false);

    //     // 7. Show clear message
    //     Swal.fire({
    //         toast: true,
    //         position: 'top-end',
    //         icon: 'info',
    //         title: `Currency changed from ${oldCurrency} to ${newCurrency}`,
    //         html: formData.apply_advance && formData.advance_applied > 0
    //             ? `<div class="text-start">
    //              <div>Base Amount: ${newBaseAmount.toFixed(2)} ${newCurrency}</div>
    //              <div>Advance Applied: ${newAdvanceAmount.toFixed(2)} ${newCurrency}</div>
    //              <div>Net Amount: ${Math.max(0, newBaseAmount - newAdvanceAmount).toFixed(2)} ${newCurrency}</div>
    //            </div>`
    //             : `<div>Amount: ${newBaseAmount.toFixed(2)} ${newCurrency}</div>`,
    //         timer: 4000,
    //         timerProgressBar: true,
    //         showConfirmButton: false,
    //     });
    // };

    const handleCurrencyChange = (newCurrency) => {
        const oldCurrency = selectedCurrency;

        if (newCurrency === selectedCurrency) {
            setShowCurrencyDropdown(false);
            return;
        }

        // 1. Get the vendor's original currency
        const vendorCurrency = selectedVendor?.currency || "AED";

        // 2. Get the original PO amount and currency
        const originalPOAmountInPOCurrency = parseFloat(originalPOAmount) || 0;
        const originalPOCurrencyValue = originalPOCurrency || "AED";

        // 3. Convert the base amount (amount_without_tax)
        let newBaseAmount = parseFloat(taxFields.amount_without_tax || 0) || 0;

        // If we have a PO amount, use that as reference
        if (originalPOAmountInPOCurrency > 0 && formData.purchase_order_id) {
            // Convert from PO's currency to new currency
            newBaseAmount = convertCurrency(
                originalPOAmountInPOCurrency,
                originalPOCurrencyValue,
                newCurrency
            );
            newBaseAmount = parseFloat(newBaseAmount) || 0;
        } else if (newBaseAmount > 0) {
            // Convert existing amount from old currency to new currency
            newBaseAmount = convertCurrency(
                newBaseAmount,
                oldCurrency,
                newCurrency
            );
            newBaseAmount = parseFloat(newBaseAmount) || 0;
        }

        // 4. Handle advance conversion if applicable
        let newAdvanceAmount = parseFloat(formData.advance_applied || 0) || 0;

        if (formData.apply_advance && newAdvanceAmount > 0) {
            // First, if advance was stored in old currency, convert it back to vendor currency
            let advanceInVendorCurrency = newAdvanceAmount;

            // Ensure we have valid currencies before converting
            if (oldCurrency && vendorCurrency && oldCurrency !== vendorCurrency) {
                const convertedAdvance = convertCurrency(
                    newAdvanceAmount,
                    oldCurrency,
                    vendorCurrency
                );
                advanceInVendorCurrency = parseFloat(convertedAdvance) || 0;
            }

            // Then convert from vendor currency to new currency
            if (vendorCurrency && newCurrency && vendorCurrency !== newCurrency) {
                newAdvanceAmount = convertCurrency(
                    advanceInVendorCurrency,
                    vendorCurrency,
                    newCurrency
                );
                newAdvanceAmount = parseFloat(newAdvanceAmount) || 0;
            }

            // Update formData with converted advance
            setFormData(prev => ({
                ...prev,
                advance_applied: newAdvanceAmount
            }));
        }

        // 5. Update the taxFields with new base amount
        const updatedTaxFields = { ...taxFields };

        if (formData.tax_type === "taxable") {
            updatedTaxFields.amount_without_tax = newBaseAmount.toFixed(2);

            // Recalculate total amount with the new base and advance
            const netAmount = Math.max(0, newBaseAmount - newAdvanceAmount);
            const tax = (netAmount * (parseFloat(taxFields.tax) || 5)) / 100;
            const adjustment = parseFloat(taxFields.adjustment_amount || 0) || 0;
            updatedTaxFields.total_amount = (netAmount + tax + adjustment).toFixed(2);

            setTaxFields(updatedTaxFields);
            setFormData(prev => ({
                ...prev,
                amount_without_tax: newBaseAmount.toFixed(2),
                total_amount: updatedTaxFields.total_amount
            }));
        } else {
            // For non-taxable
            setFormData(prev => ({
                ...prev,
                amount: newBaseAmount.toFixed(2)
            }));
        }

        // Convert multiple bills amounts if present
        if (multipleBills && multipleBills.length > 0) {
            setMultipleBills(prev => prev.map(bill => {
                if (formData.tax_type === 'taxable') {
                    const currentBase = parseFloat(bill.amount_without_tax || 0);
                    let newBase = currentBase;
                    if (currentBase > 0) {
                        newBase = parseFloat(convertCurrency(currentBase, oldCurrency, newCurrency)) || 0;
                    }
                    const taxRate = parseFloat(bill.tax !== undefined ? bill.tax : 5) || 5;
                    const effVat = (newBase * taxRate) / 100;
                    const adj = parseFloat(bill.adjustment_amount || 0);
                    const finalizedTotal = (newBase + effVat + adj).toFixed(2);
                    return {
                        ...bill,
                        amount_without_tax: newBase > 0 ? newBase.toFixed(2) : bill.amount_without_tax,
                        vat_amount: effVat.toFixed(2),
                        total_amount: finalizedTotal,
                        amount: finalizedTotal
                    };
                } else {
                    const currentAmt = parseFloat(bill.amount || 0);
                    let newAmt = currentAmt;
                    if (currentAmt > 0) {
                        newAmt = parseFloat(convertCurrency(currentAmt, oldCurrency, newCurrency)) || 0;
                    }
                    return {
                        ...bill,
                        amount: newAmt > 0 ? newAmt.toFixed(2) : bill.amount,
                        total_amount: newAmt > 0 ? newAmt.toFixed(2) : bill.amount
                    };
                }
            }));
        }

        // 6. Update selected currency
        setSelectedCurrency(newCurrency);
        setFormData(prev => ({
            ...prev,
            vendor_currency: newCurrency
        }));
        setShowCurrencyDropdown(false);
        setActiveCurrencyDropdownBillId(null);

        // 7. Show clear message
        // Swal.fire({
        //     toast: true,
        //     position: 'top-end',
        //     icon: 'info',
        //     title: `Currency changed from ${oldCurrency} to ${newCurrency}`,
        //     html: formData.apply_advance && formData.advance_applied > 0
        //         ? `<div class="text-start">
        //          <div>Base Amount: ${newBaseAmount.toFixed(2)} ${newCurrency}</div>
        //          <div>Advance Applied: ${newAdvanceAmount.toFixed(2)} ${newCurrency}</div>
        //          <div>Net Amount: ${Math.max(0, newBaseAmount - newAdvanceAmount).toFixed(2)} ${newCurrency}</div>
        //        </div>`
        //         : `<div>Amount: ${newBaseAmount.toFixed(2)} ${newCurrency}</div>`,
        //     timer: 4000,
        //     timerProgressBar: true,
        //     showConfirmButton: false,
        // });
    };



    const nextViewStep = () => {
        setViewModeStep(prev => prev + 1);
    };

    const prevViewStep = () => {
        setViewModeStep(prev => prev - 1);
    };

    // Determine modal title based on mode
    const getModalTitle = () => {
        if (isCreateMode) {
            return billMode === 'multiple' ? 'Create Journal (Multiple Bills)' : 'Create Journal';
        } else if (isEditMode) {
            return 'Edit Journal';
        } else {
            return 'View Journal';
        }
    };

    const renderContent = () => {
        if (isCreateMode && billMode === 'multiple') {
            return renderMultipleBillsMode();
        }
        if (isCreateMode || isEditMode) {
            // Create mode OR Edit mode - show the step form
            return renderEditMode();
        } else {
            // View mode - show narration first, then details
            return renderViewMode();
        }
    };


    // const renderViewMode = () => {
    //     // Get vendor details
    //     const selectedVendorObj = vendors.find(v => v.id?.toString() === formData.vendor_id?.toString());

    //     // Determine the vendor's original currency
    //     const vendorOriginalCurrency = selectedVendorObj?.currency || "AED";

    //     // Get the currency that was selected when creating/editing the expense
    //     const vendorCurrencyUsed = formData.vendor_currency || vendorOriginalCurrency;
    //      const advanceApplied = parseFloat(formData.advance_applied || 0);
    // const isAdvanceApplied = formData.apply_advance && advanceApplied > 0;

    // // Get available advance balance
    // const vendorAdvanceBalance = parseFloat(formData.vendor_advance_balance || 0);

    //     // Function to convert amount based on currency
    //     const convertAmountForDisplay = (amount, fromCurrency, toCurrency) => {
    //         if (!amount || parseFloat(amount) === 0) return { amount: "0", currency: toCurrency };

    //         const amountNum = parseFloat(amount);

    //         // If fromCurrency is AED and we want to display in USD (vendor is USD)
    //         if (fromCurrency === "AED" && toCurrency === "USD") {
    //             // You should implement dynamic exchange rate here
    //             // For now, using a fixed rate
    //             const exchangeRate = 0.27; // 1 AED = 0.27 USD
    //             return {
    //                 amount: (amountNum * exchangeRate).toFixed(2),
    //                 currency: "USD"
    //             };
    //         }

    //         // If currencies are same or no conversion needed
    //         return {
    //             amount: amountNum.toFixed(2),
    //             currency: fromCurrency
    //         };
    //     };


    //     // Determine if we need to convert for display
    //     const shouldConvertForDisplay = vendorCurrencyUsed === "AED" && vendorOriginalCurrency === "USD";

    //     // Convert main amount
    //     const rawAmount = formData.amount || formData.amount_without_tax || "0";
    //     const displayAmountInfo = shouldConvertForDisplay ?
    //         convertAmountForDisplay(rawAmount, "AED", "USD") :
    //         { amount: rawAmount, currency: vendorCurrencyUsed };

    //     // Convert tax-related amounts if taxable
    //     let displayTaxInfo = {};
    //     if (formData.tax_type === "taxable") {
    //         const fieldsToConvert = ['amount_without_tax', 'adjustment_amount', 'total_amount'];
    //         fieldsToConvert.forEach(field => {
    //             const converted = shouldConvertForDisplay ?
    //                 convertAmountForDisplay(taxFields[field] || "0", "AED", "USD") :
    //                 { amount: taxFields[field] || "0", currency: vendorCurrencyUsed };
    //             displayTaxInfo[field] = converted;
    //         });
    //     }

    //     // Format date to dd-mm-yyyy
    //     const formatDate = (dateString) => {
    //         if (!dateString) return "";

    //         try {
    //             const date = new Date(dateString);
    //             if (isNaN(date.getTime())) return dateString; // Return original if invalid

    //             const day = String(date.getDate()).padStart(2, '0');
    //             const month = String(date.getMonth() + 1).padStart(2, '0');
    //             const year = date.getFullYear();

    //             return `${day}-${month}-${year}`;
    //         } catch (error) {
    //             console.error("Date formatting error:", error);
    //             return dateString;
    //         }
    //     };

    //     // Format amount with commas (US format) and currency symbol
    //     const formatAmount = (amount, currency) => {
    //         if (!amount || parseFloat(amount) === 0) return "";

    //         const currencySymbols = {
    //             'AED': 'AED ',
    //             'USD': '$',
    //             'EUR': '€',
    //             'GBP': '£'
    //         };

    //         const symbol = currencySymbols[currency] || currency + ' ';

    //         // Convert to number and format with commas
    //         const numAmount = parseFloat(amount);
    //         const formattedAmount = numAmount.toLocaleString('en-US', {
    //             minimumFractionDigits: 2,
    //             maximumFractionDigits: 2
    //         });

    //         return `${symbol}${formattedAmount}`;
    //     };

    //     // Format amount without currency symbol (just the number with commas)
    //     const formatAmountNumber = (amount) => {
    //         if (!amount || parseFloat(amount) === 0) return "0.00";

    //         const numAmount = parseFloat(amount);
    //         return numAmount.toLocaleString('en-US', {
    //             minimumFractionDigits: 2,
    //             maximumFractionDigits: 2
    //         });
    //     };

    //     return (
    //         <div className="view-mode-content">
    //             {/* Header */}
    //             <div className="text-center mb-4">
    //                 <h5 className="text-primary mb-2">Expense Details</h5>
    //                 <div className="d-flex justify-content-center align-items-center gap-3">
    //                     <span className="badge bg-secondary">{formData.type === "external" ? "Bank" : "Petty Cash"}</span>
    //                     {formData.tax_type && (
    //                         <span className={`badge ${formData.tax_type === "taxable" ? "bg-success" : "bg-warning"}`}>
    //                             {formData.tax_type}
    //                         </span>
    //                     )}
    //                     {/* Display currency info */}
    //                     <span className="badge bg-info">
    //                         {displayAmountInfo.currency}
    //                     </span>
    //                     {shouldConvertForDisplay && (
    //                         <span className="badge bg-warning">
    //                             Converted
    //                         </span>
    //                     )}
    //                 </div>
    //             </div>

    //             {/* Currency Conversion Alert */}
    //             {/* {shouldConvertForDisplay && (
    //         <div className="alert alert-info mb-4">
    //             <i className="mdi mdi-currency-usd me-2"></i>
    //             <strong>Currency Conversion Applied:</strong> Amounts converted from AED to USD for display.
    //             <div className="mt-1 small">
    //                 Vendor's currency: <strong>{vendorOriginalCurrency}</strong> | 
    //                 Transaction currency: <strong>{vendorCurrencyUsed}</strong> | 
    //                 Display currency: <strong>{displayAmountInfo.currency}</strong>
    //             </div>
    //         </div>
    //     )} */}

    //             {/* Narration Section */}
    //             <div className="mb-4">
    //                 <div className="card border-0 shadow-sm">
    //                     <div className="card-header bg-gradient-primary text-white">
    //                         <h6 className="mb-0">
    //                             <i className="mdi mdi-text-box-outline me-2"></i>
    //                             Narration
    //                         </h6>
    //                     </div>
    //                     <div className="card-body">
    //                         <p className="card-text fs-6 mb-0 text-muted">
    //                             {formData.narration || "No narration provided"}
    //                         </p>
    //                     </div>
    //                 </div>
    //             </div>

    //             {/* Main Details Grid */}
    //             <div className="row">
    //                 {/* Left Column - Basic Information */}
    //                 <div className="col-md-6">
    //                     <div className="card h-100 border-0 shadow-sm">
    //                         <div className="card-header bg-light">
    //                             <h6 className="mb-0">
    //                                 <i className="mdi mdi-information-outline me-2"></i>
    //                                 Basic Information
    //                             </h6>
    //                         </div>
    //                         <div className="card-body">
    //                             <div className="detail-item mb-3">
    //                                 <small className="text-muted">Date</small>
    //                                 <div className="fw-semibold">{formatDate(formData.date)}</div>
    //                             </div>
    //                             <div className="detail-item mb-3">
    //                                 <small className="text-muted">Expense Type</small>
    //                                 <div className="fw-semibold">
    //                                     {expenseTypes.find(et => et.id === formData.expense_type_id)?.name || ""}
    //                                 </div>
    //                             </div>
    //                             <div className="detail-item mb-3">
    //                                 <small className="text-muted">
    //                                     {formData.tax_type === "taxable" ? "Total Amount" : "Amount"}
    //                                 </small>
    //                                 <div className="fw-semibold text-success fs-5">
    //                                     {formatAmount(displayAmountInfo.amount, displayAmountInfo.currency)}
    //                                 </div>
    //                                 {/* Show original amount if converted */}
    //                                 {shouldConvertForDisplay && rawAmount && parseFloat(rawAmount) > 0 && (
    //                                     <small className="text-muted d-block mt-1">
    //                                         Original: {formatAmount(rawAmount, "AED")}
    //                                     </small>
    //                                 )}
    //                             </div>
    //                             {/* <div className="detail-item mb-3">
    //                         <small className="text-muted">Currency Information</small>
    //                         <div className="fw-semibold small">
    //                             <div>Vendor's Currency: {vendorOriginalCurrency}</div>
    //                             <div>Transaction Currency: {vendorCurrencyUsed}</div>
    //                             <div>Display Currency: {displayAmountInfo.currency}</div>
    //                         </div>
    //                     </div> */}
    //                             <div className="detail-item">
    //                                 <small className="text-muted">VAT Type</small>
    //                                 <div className="fw-semibold">{formData.tax_type || ""}</div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //                 {/* Right Column - Payment & Status */}
    //                 <div className="col-md-6">
    //                     <div className="card h-100 border-0 shadow-sm">
    //                         <div className="card-header bg-light">
    //                             <h6 className="mb-0">
    //                                 <i className="mdi mdi-credit-card-outline me-2"></i>
    //                                 Payment & Status
    //                             </h6>
    //                         </div>
    //                         <div className="card-body">
    //                             <div className="detail-item mb-3">
    //                                 <small className="text-muted">Payment Method</small>
    //                                 <div className="fw-semibold">
    //                                     {formData.type === "external" ? (
    //                                         <span className="badge bg-info">Direct</span>
    //                                     ) : (
    //                                         <span className="badge bg-secondary">Petty Cash</span>
    //                                     )}
    //                                 </div>
    //                             </div>
    //                             <div className="detail-item">
    //                                 <small className="text-muted">Reconciliation Status</small>
    //                                 <div className="fw-semibold">
    //                                     <span className={`badge ${formData.reconciliation_status === 'reconciled' ? 'bg-success' : 'bg-warning'}`}>
    //                                         {formData.reconciliation_status || 'pending'}
    //                                     </span>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>

    //             {/* Tax Details Section - Updated with converted amounts */}
    //             {formData.tax_type === "taxable" && (
    //                 <div className="mt-4">
    //                     <div className="card border-0 shadow-sm">
    //                         <div className="card-header bg-light">
    //                             <h6 className="mb-0">
    //                                 <i className="mdi mdi-calculator me-2"></i>
    //                                 Tax Details ({displayAmountInfo.currency})
    //                             </h6>
    //                         </div>
    //                         <div className="card-body">
    //                             <div className="row">
    //                                 <div className="col-md-6">
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">Invoice No</small>
    //                                         <div className="fw-semibold">{taxFields.invoice_no || ""}</div>
    //                                     </div>
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">Invoice Date</small>
    //                                         <div className="fw-semibold">{formatDate(taxFields.invoice_date) || ""}</div>
    //                                     </div>
    //                                     <div className="detail-item">
    //                                         <small className="text-muted">Amount (Excl. VAT)</small>
    //                                         <div className="fw-semibold">
    //                                             {formatAmount(displayTaxInfo.amount_without_tax?.amount, displayTaxInfo.amount_without_tax?.currency)}
    //                                         </div>
    //                                         {/* Show original amount if converted */}
    //                                         {shouldConvertForDisplay && taxFields.amount_without_tax && (
    //                                             <small className="text-muted d-block mt-1">
    //                                                 Original: {formatAmount(taxFields.amount_without_tax, "AED")}
    //                                             </small>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                                 <div className="col-md-6">
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">VAT %</small>
    //                                         <div className="fw-semibold">{taxFields.tax ? `${taxFields.tax}%` : ""}</div>
    //                                     </div>
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">Adjustment Amount</small>
    //                                         <div className="fw-semibold">
    //                                             {formatAmount(displayTaxInfo.adjustment_amount?.amount, displayTaxInfo.adjustment_amount?.currency)}
    //                                         </div>
    //                                         {shouldConvertForDisplay && taxFields.adjustment_amount && (
    //                                             <small className="text-muted d-block mt-1">
    //                                                 Original: {formatAmount(taxFields.adjustment_amount, "AED")}
    //                                             </small>
    //                                         )}
    //                                     </div>
    //                                     <div className="detail-item">
    //                                         <small className="text-muted">Total Amount</small>
    //                                         <div className="fw-semibold text-success fs-5">
    //                                             {formatAmount(displayTaxInfo.total_amount?.amount, displayTaxInfo.total_amount?.currency)}
    //                                         </div>
    //                                         {shouldConvertForDisplay && taxFields.total_amount && (
    //                                             <small className="text-muted d-block mt-1">
    //                                                 Original: {formatAmount(taxFields.total_amount, "AED")}
    //                                             </small>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                             </div>

    //                             {/* Additional numeric display without currency symbol */}
    //                             <div className="row mt-3 pt-3 border-top">
    //                                 <div className="col-12">
    //                                     <small className="text-muted d-block mb-2">Numeric Values:</small>
    //                                     <div className="d-flex flex-wrap gap-4">
    //                                         <div>
    //                                             <small className="text-muted">Amount w/o VAT:</small>
    //                                             <div className="fw-semibold">
    //                                                 {formatAmountNumber(displayTaxInfo.amount_without_tax?.amount)}
    //                                             </div>
    //                                         </div>
    //                                         <div>
    //                                             <small className="text-muted">VAT Amount:</small>
    //                                             <div className="fw-semibold">
    //                                                 {(() => {
    //                                                     const amount = parseFloat(displayTaxInfo.amount_without_tax?.amount || 0);
    //                                                     const taxRate = parseFloat(taxFields.tax || 0);
    //                                                     const vatAmount = amount * (taxRate / 100);
    //                                                     return formatAmountNumber(vatAmount);
    //                                                 })()}
    //                                             </div>
    //                                         </div>
    //                                         <div>
    //                                             <small className="text-muted">Adjustment:</small>
    //                                             <div className="fw-semibold">
    //                                                 {formatAmountNumber(displayTaxInfo.adjustment_amount?.amount)}
    //                                             </div>
    //                                         </div>
    //                                         <div>
    //                                             <small className="text-muted">Total:</small>
    //                                             <div className="fw-semibold text-success">
    //                                                 {formatAmountNumber(displayTaxInfo.total_amount?.amount)}
    //                                             </div>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             )}
    // const renderViewMode = () => {
    //     // Get vendor details
    //     const selectedVendorObj = vendors.find(v => v.id?.toString() === formData.vendor_id?.toString());

    //     // Determine the vendor's original currency
    //     const vendorOriginalCurrency = selectedVendorObj?.currency || "AED";

    //     // Get the currency that was selected when creating/editing the expense
    //     const vendorCurrencyUsed = formData.vendor_currency || vendorOriginalCurrency;

    //     // Check if advance was applied
    //     const advanceApplied = parseFloat(formData.advance_applied || 0);
    //     const isAdvanceApplied = formData.apply_advance && advanceApplied > 0;

    //     // Get available advance balance
    //     const vendorAdvanceBalance = parseFloat(formData.vendor_advance_balance || 0);

    //     // Function to convert amount based on currency
    //     const convertAmountForDisplay = (amount, fromCurrency, toCurrency) => {
    //         if (!amount || parseFloat(amount) === 0) return { amount: "0", currency: toCurrency };

    //         const amountNum = parseFloat(amount);

    //         // If fromCurrency is AED and we want to display in USD (vendor is USD)
    //         if (fromCurrency === "AED" && toCurrency === "USD") {
    //             // You should implement dynamic exchange rate here
    //             // For now, using a fixed rate
    //             const exchangeRate = 0.27; // 1 AED = 0.27 USD
    //             return {
    //                 amount: (amountNum * exchangeRate).toFixed(2),
    //                 currency: "USD"
    //             };
    //         }

    //         // If currencies are same or no conversion needed
    //         return {
    //             amount: amountNum.toFixed(2),
    //             currency: fromCurrency
    //         };
    //     };

    //     // Determine if we need to convert for display
    //     const shouldConvertForDisplay = vendorCurrencyUsed === "AED" && vendorOriginalCurrency === "USD";

    //     // Convert main amount
    //     const rawAmount = formData.amount || formData.amount_without_tax || "0";
    //     const displayAmountInfo = shouldConvertForDisplay ?
    //         convertAmountForDisplay(rawAmount, "AED", "USD") :
    //         { amount: rawAmount, currency: vendorCurrencyUsed };

    //     // Convert advance amounts
    //     let displayAdvanceInfo = {};
    //     let displayAdvanceBalanceInfo = {};

    //     if (isAdvanceApplied) {
    //         displayAdvanceInfo = shouldConvertForDisplay ?
    //             convertAmountForDisplay(advanceApplied, "AED", "USD") :
    //             { amount: advanceApplied.toFixed(2), currency: vendorCurrencyUsed };

    //         displayAdvanceBalanceInfo = shouldConvertForDisplay ?
    //             convertAmountForDisplay(vendorAdvanceBalance, "AED", "USD") :
    //             { amount: vendorAdvanceBalance.toFixed(2), currency: vendorCurrencyUsed };
    //     }

    //     // Convert tax-related amounts if taxable
    //     let displayTaxInfo = {};
    //     if (formData.tax_type === "taxable") {
    //         const fieldsToConvert = ['amount_without_tax', 'adjustment_amount', 'total_amount'];
    //         fieldsToConvert.forEach(field => {
    //             const converted = shouldConvertForDisplay ?
    //                 convertAmountForDisplay(taxFields[field] || "0", "AED", "USD") :
    //                 { amount: taxFields[field] || "0", currency: vendorCurrencyUsed };
    //             displayTaxInfo[field] = converted;
    //         });
    //     }

    //     // Format date to dd-mm-yyyy
    //     const formatDate = (dateString) => {
    //         if (!dateString) return "";

    //         try {
    //             const date = new Date(dateString);
    //             if (isNaN(date.getTime())) return dateString; // Return original if invalid

    //             const day = String(date.getDate()).padStart(2, '0');
    //             const month = String(date.getMonth() + 1).padStart(2, '0');
    //             const year = date.getFullYear();

    //             return `${day}-${month}-${year}`;
    //         } catch (error) {
    //             console.error("Date formatting error:", error);
    //             return dateString;
    //         }
    //     };

    //     // Format amount with commas (US format) and currency symbol
    //     const formatAmount = (amount, currency) => {
    //         if (!amount || parseFloat(amount) === 0) return "";

    //         const currencySymbols = {
    //             'AED': 'AED ',
    //             'USD': '$',
    //             'EUR': '€',
    //             'GBP': '£'
    //         };

    //         const symbol = currencySymbols[currency] || currency + ' ';

    //         // Convert to number and format with commas
    //         const numAmount = parseFloat(amount);
    //         const formattedAmount = numAmount.toLocaleString('en-US', {
    //             minimumFractionDigits: 2,
    //             maximumFractionDigits: 2
    //         });

    //         return `${symbol}${formattedAmount}`;
    //     };

    //     // Format amount without currency symbol (just the number with commas)
    //     const formatAmountNumber = (amount) => {
    //         if (!amount || parseFloat(amount) === 0) return "0.00";

    //         const numAmount = parseFloat(amount);
    //         return numAmount.toLocaleString('en-US', {
    //             minimumFractionDigits: 2,
    //             maximumFractionDigits: 2
    //         });
    //     };

    //     return (
    //         <div className="view-mode-content">
    //             {/* Header */}
    //             <div className="text-center mb-4">
    //                 <h5 className="text-primary mb-2">Expense Details</h5>
    //                 <div className="d-flex justify-content-center align-items-center gap-3">
    //                     <span className="badge bg-secondary">{formData.type === "external" ? "Bank" : "Petty Cash"}</span>
    //                     {formData.tax_type && (
    //                         <span className={`badge ${formData.tax_type === "taxable" ? "bg-success" : "bg-warning"}`}>
    //                             {formData.tax_type}
    //                         </span>
    //                     )}
    //                     {/* Display currency info */}
    //                     <span className="badge bg-info">
    //                         {displayAmountInfo.currency}
    //                     </span>
    //                     {shouldConvertForDisplay && (
    //                         <span className="badge bg-warning">
    //                             Converted
    //                         </span>
    //                     )}
    //                     {/* Advance Applied Badge */}
    //                     {isAdvanceApplied && (
    //                         <span className="badge bg-success">
    //                             <i className="mdi mdi-cash-check me-1"></i>
    //                             Advance Applied
    //                         </span>
    //                     )}
    //                 </div>
    //             </div>

    //             {/* Advance Section - Show prominently if advance was applied */}
    //             {isAdvanceApplied && (
    //                 <div className="mb-4">
    //                     <div className="card border-success border-2">
    //                         <div className="card-header bg-success text-white">
    //                             <h6 className="mb-0">
    //                                 <i className="mdi mdi-cash-check me-2"></i>
    //                                 Vendor Advance Applied
    //                             </h6>
    //                         </div>
    //                         <div className="card-body">
    //                             <div className="row">
    //                                 <div className="col-md-6">
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">Available Advance Balance</small>
    //                                         <div className="fw-bold text-primary">
    //                                             {formatAmount(displayAdvanceBalanceInfo.amount, displayAdvanceBalanceInfo.currency)}
    //                                         </div>
    //                                         {shouldConvertForDisplay && vendorAdvanceBalance > 0 && (
    //                                             <small className="text-muted d-block mt-1">
    //                                                 Original: {formatAmount(vendorAdvanceBalance, "AED")}
    //                                             </small>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                                 <div className="col-md-6">
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">Advance Applied</small>
    //                                         <div className="fw-bold text-success">
    //                                             {formatAmount(displayAdvanceInfo.amount, displayAdvanceInfo.currency)}
    //                                         </div>
    //                                         {shouldConvertForDisplay && advanceApplied > 0 && (
    //                                             <small className="text-muted d-block mt-1">
    //                                                 Original: {formatAmount(advanceApplied, "AED")}
    //                                             </small>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                             </div>

    //                             {/* Show original base amount calculation */}
    //                             {formData.tax_type === "taxable" ? (
    //                                 <div className="alert alert-info mt-3 mb-0">
    //                                     <div className="d-flex align-items-center">
    //                                         <i className="mdi mdi-information-outline me-2"></i>
    //                                         <div className="small">
    //                                             <strong>Amount Calculation:</strong>
    //                                             <div className="mt-1">
    //                                                 Original Base Amount: {formatAmountNumber(parseFloat(taxFields.amount_without_tax || 0) + advanceApplied)} {displayAmountInfo.currency}
    //                                                 <span className="mx-2">-</span>
    //                                                 Advance Applied: {formatAmountNumber(advanceApplied)} {displayAmountInfo.currency}
    //                                                 <span className="mx-2">=</span>
    //                                                 Net Base Amount: {formatAmountNumber(taxFields.amount_without_tax || 0)} {displayAmountInfo.currency}
    //                                             </div>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             ) : (
    //                                 <div className="alert alert-info mt-3 mb-0">
    //                                     <div className="d-flex align-items-center">
    //                                         <i className="mdi mdi-information-outline me-2"></i>
    //                                         <div className="small">
    //                                             <strong>Amount Calculation:</strong>
    //                                             <div className="mt-1">
    //                                                 Original Amount: {formatAmountNumber(parseFloat(formData.amount || 0) + advanceApplied)} {displayAmountInfo.currency}
    //                                                 <span className="mx-2">-</span>
    //                                                 Advance Applied: {formatAmountNumber(advanceApplied)} {displayAmountInfo.currency}
    //                                                 <span className="mx-2">=</span>
    //                                                 Net Amount: {formatAmountNumber(formData.amount || 0)} {displayAmountInfo.currency}
    //                                             </div>
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             )}
    //                         </div>
    //                     </div>
    //                 </div>
    //             )}

    //             {/* Narration Section */}
    //             <div className="mb-4">
    //                 <div className="card border-0 shadow-sm">
    //                     <div className="card-header bg-gradient-primary text-white">
    //                         <h6 className="mb-0">
    //                             <i className="mdi mdi-text-box-outline me-2"></i>
    //                             Narration
    //                         </h6>
    //                     </div>
    //                     <div className="card-body">
    //                         <p className="card-text fs-6 mb-0 text-muted">
    //                             {formData.narration || "No narration provided"}
    //                         </p>
    //                     </div>
    //                 </div>
    //             </div>

    //             {/* Main Details Grid */}
    //             <div className="row">
    //                 {/* Left Column - Basic Information */}
    //                 <div className="col-md-6">
    //                     <div className="card h-100 border-0 shadow-sm">
    //                         <div className="card-header bg-light">
    //                             <h6 className="mb-0">
    //                                 <i className="mdi mdi-information-outline me-2"></i>
    //                                 Basic Information
    //                             </h6>
    //                         </div>
    //                         <div className="card-body">
    //                             <div className="detail-item mb-3">
    //                                 <small className="text-muted">Date</small>
    //                                 <div className="fw-semibold">{formatDate(formData.date)}</div>
    //                             </div>
    //                             <div className="detail-item mb-3">
    //                                 <small className="text-muted">Expense Type</small>
    //                                 <div className="fw-semibold">
    //                                     {expenseTypes.find(et => et.id === formData.expense_type_id)?.name || ""}
    //                                 </div>
    //                             </div>
    //                             <div className="detail-item mb-3">
    //                                 <small className="text-muted">
    //                                     {formData.tax_type === "taxable" ? "Total Amount" : "Amount"}
    //                                 </small>
    //                                 <div className="fw-semibold text-success fs-5">
    //                                     {formatAmount(displayAmountInfo.amount, displayAmountInfo.currency)}
    //                                 </div>
    //                                 {/* Show original amount if converted */}
    //                                 {shouldConvertForDisplay && rawAmount && parseFloat(rawAmount) > 0 && (
    //                                     <small className="text-muted d-block mt-1">
    //                                         Original: {formatAmount(rawAmount, "AED")}
    //                                     </small>
    //                                 )}

    //                                 {/* Show breakdown if advance was applied */}
    //                                 {isAdvanceApplied && (
    //                                     <div className="mt-2 p-2 bg-light rounded">
    //                                         <small className="text-muted d-block">
    //                                             <strong>Breakdown:</strong>
    //                                         </small>
    //                                         <small className="text-muted d-block">
    //                                             Original: {formatAmountNumber(parseFloat(rawAmount) + advanceApplied)} {displayAmountInfo.currency}
    //                                         </small>
    //                                         <small className="text-danger d-block">
    //                                             - Advance: {formatAmountNumber(advanceApplied)} {displayAmountInfo.currency}
    //                                         </small>
    //                                         <small className="text-success d-block">
    //                                             = Payable: {formatAmountNumber(rawAmount)} {displayAmountInfo.currency}
    //                                         </small>
    //                                     </div>
    //                                 )}
    //                             </div>
    //                             <div className="detail-item">
    //                                 <small className="text-muted">VAT Type</small>
    //                                 <div className="fw-semibold">{formData.tax_type || ""}</div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>

    //                 {/* Right Column - Payment & Status */}
    //                 <div className="col-md-6">
    //                     <div className="card h-100 border-0 shadow-sm">
    //                         <div className="card-header bg-light">
    //                             <h6 className="mb-0">
    //                                 <i className="mdi mdi-credit-card-outline me-2"></i>
    //                                 Payment & Status
    //                             </h6>
    //                         </div>
    //                         <div className="card-body">
    //                             <div className="detail-item mb-3">
    //                                 <small className="text-muted">Payment Method</small>
    //                                 <div className="fw-semibold">
    //                                     {formData.type === "external" ? (
    //                                         <span className="badge bg-info">Direct</span>
    //                                     ) : (
    //                                         <span className="badge bg-secondary">Petty Cash</span>
    //                                     )}
    //                                 </div>
    //                             </div>

    //                             {/* Purchase Order Info if exists */}
    //                             {formData.purchase_order_id && (
    //                                 <div className="detail-item mb-3">
    //                                     <small className="text-muted">Purchase Order</small>
    //                                     <div className="fw-semibold">
    //                                         <span className="badge bg-primary">
    //                                             PO: {formData.purchase_order_id}
    //                                         </span>
    //                                     </div>
    //                                 </div>
    //                             )}

    //                             <div className="detail-item">
    //                                 <small className="text-muted">Reconciliation Status</small>
    //                                 <div className="fw-semibold">
    //                                     <span className={`badge ${formData.reconciliation_status === 'reconciled' ? 'bg-success' : 'bg-warning'}`}>
    //                                         {formData.reconciliation_status || 'pending'}
    //                                     </span>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>

    //             {/* Tax Details Section - Updated with converted amounts */}
    //             {formData.tax_type === "taxable" && (
    //                 <div className="mt-4">
    //                     <div className="card border-0 shadow-sm">
    //                         <div className="card-header bg-light">
    //                             <h6 className="mb-0">
    //                                 <i className="mdi mdi-calculator me-2"></i>
    //                                 Tax Details ({displayAmountInfo.currency})
    //                                 {isAdvanceApplied && (
    //                                     <span className="badge bg-success ms-2">
    //                                         After Advance
    //                                     </span>
    //                                 )}
    //                             </h6>
    //                         </div>
    //                         <div className="card-body">
    //                             <div className="row">
    //                                 <div className="col-md-6">
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">Invoice No</small>
    //                                         <div className="fw-semibold">{taxFields.invoice_no || ""}</div>
    //                                     </div>
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">Invoice Date</small>
    //                                         <div className="fw-semibold">{formatDate(taxFields.invoice_date) || ""}</div>
    //                                     </div>
    //                                     <div className="detail-item">
    //                                         <small className="text-muted">Amount (Excl. VAT)</small>
    //                                         <div className="fw-semibold">
    //                                             {formatAmount(displayTaxInfo.amount_without_tax?.amount, displayTaxInfo.amount_without_tax?.currency)}
    //                                         </div>
    //                                         {/* Show original amount if converted */}
    //                                         {shouldConvertForDisplay && taxFields.amount_without_tax && (
    //                                             <small className="text-muted d-block mt-1">
    //                                                 Original: {formatAmount(taxFields.amount_without_tax, "AED")}
    //                                             </small>
    //                                         )}

    //                                         {/* Show original base amount if advance was applied */}
    //                                         {isAdvanceApplied && taxFields.amount_without_tax && (
    //                                             <small className="text-success d-block mt-1">
    //                                                 <i className="mdi mdi-information-outline me-1"></i>
    //                                                 Original Base: {formatAmountNumber(parseFloat(taxFields.amount_without_tax || 0) + advanceApplied)} {displayAmountInfo.currency}
    //                                             </small>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                                 <div className="col-md-6">
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">VAT %</small>
    //                                         <div className="fw-semibold">{taxFields.tax ? `${taxFields.tax}%` : ""}</div>
    //                                     </div>
    //                                     <div className="detail-item mb-3">
    //                                         <small className="text-muted">Adjustment Amount</small>
    //                                         <div className="fw-semibold">
    //                                             {formatAmount(displayTaxInfo.adjustment_amount?.amount, displayTaxInfo.adjustment_amount?.currency)}
    //                                         </div>
    //                                         {shouldConvertForDisplay && taxFields.adjustment_amount && (
    //                                             <small className="text-muted d-block mt-1">
    //                                                 Original: {formatAmount(taxFields.adjustment_amount, "AED")}
    //                                             </small>
    //                                         )}
    //                                     </div>
    //                                     <div className="detail-item">
    //                                         <small className="text-muted">Total Amount</small>
    //                                         <div className="fw-semibold text-success fs-5">
    //                                             {formatAmount(displayTaxInfo.total_amount?.amount, displayTaxInfo.total_amount?.currency)}
    //                                         </div>
    //                                         {shouldConvertForDisplay && taxFields.total_amount && (
    //                                             <small className="text-muted d-block mt-1">
    //                                                 Original: {formatAmount(taxFields.total_amount, "AED")}
    //                                             </small>
    //                                         )}
    //                                     </div>
    //                                 </div>
    //                             </div>

    //                             {/* Additional numeric display without currency symbol */}
    //                             <div className="row mt-3 pt-3 border-top">
    //                                 <div className="col-12">
    //                                     <small className="text-muted d-block mb-2">Numeric Values:</small>
    //                                     <div className="d-flex flex-wrap gap-4">
    //                                         <div>
    //                                             <small className="text-muted">Amount w/o VAT:</small>
    //                                             <div className="fw-semibold">
    //                                                 {formatAmountNumber(displayTaxInfo.amount_without_tax?.amount)}
    //                                             </div>
    //                                         </div>
    //                                         <div>
    //                                             <small className="text-muted">VAT Amount:</small>
    //                                             <div className="fw-semibold">
    //                                                 {(() => {
    //                                                     const amount = parseFloat(displayTaxInfo.amount_without_tax?.amount || 0);
    //                                                     const taxRate = parseFloat(taxFields.tax || 0);
    //                                                     const vatAmount = amount * (taxRate / 100);
    //                                                     return formatAmountNumber(vatAmount);
    //                                                 })()}
    //                                             </div>
    //                                         </div>
    //                                         <div>
    //                                             <small className="text-muted">Adjustment:</small>
    //                                             <div className="fw-semibold">
    //                                                 {formatAmountNumber(displayTaxInfo.adjustment_amount?.amount)}
    //                                             </div>
    //                                         </div>
    //                                         <div>
    //                                             <small className="text-muted">Total:</small>
    //                                             <div className="fw-semibold text-success">
    //                                                 {formatAmountNumber(displayTaxInfo.total_amount?.amount)}
    //                                             </div>
    //                                         </div>
    //                                     </div>

    //                                     {/* Show calculation breakdown for advance */}
    //                                     {isAdvanceApplied && (
    //                                         <div className="mt-3 p-3 bg-light rounded">
    //                                             <small className="text-muted d-block mb-2">
    //                                                 <strong>Calculation with Advance:</strong>
    //                                             </small>
    //                                             <div className="d-flex flex-wrap gap-4">
    //                                                 <div>
    //                                                     <small className="text-muted">Original Base:</small>
    //                                                     <div className="fw-semibold">
    //                                                         {formatAmountNumber(parseFloat(taxFields.amount_without_tax || 0) + advanceApplied)}
    //                                                     </div>
    //                                                 </div>
    //                                                 <div>
    //                                                     <small className="text-muted">Advance Applied:</small>
    //                                                     <div className="fw-semibold text-danger">
    //                                                         -{formatAmountNumber(advanceApplied)}
    //                                                     </div>
    //                                                 </div>
    //                                                 <div>
    //                                                     <small className="text-muted">Net Base (for VAT):</small>
    //                                                     <div className="fw-semibold">
    //                                                         {formatAmountNumber(taxFields.amount_without_tax || 0)}
    //                                                     </div>
    //                                                 </div>
    //                                                 <div>
    //                                                     <small className="text-muted">VAT on Net Base:</small>
    //                                                     <div className="fw-semibold">
    //                                                         {(() => {
    //                                                             const netBase = parseFloat(taxFields.amount_without_tax || 0);
    //                                                             const taxRate = parseFloat(taxFields.tax || 0);
    //                                                             const vatAmount = netBase * (taxRate / 100);
    //                                                             return formatAmountNumber(vatAmount);
    //                                                         })()}
    //                                                     </div>
    //                                                 </div>
    //                                             </div>
    //                                         </div>
    //                                     )}
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             )}

    //             {/* Vendor & Employee Section */}
    //             <div className="mt-4">
    //                 <div className="card border-0 shadow-sm">
    //                     <div className="card-header bg-light">
    //                         <h6 className="mb-0">
    //                             <i className="mdi mdi-account-group-outline me-2"></i>
    //                             Vendor & Employee
    //                         </h6>
    //                     </div>
    //                     <div className="card-body">
    //                         <div className="row">
    //                             <div className="col-md-6">
    //                                 <div className="detail-item">
    //                                     <small className="text-muted">Supplier</small>
    //                                     <div className="fw-semibold">
    //                                         {selectedVendorObj?.name || ""}
    //                                     </div>
    //                                 </div>
    //                             </div>
    //                             {formData.user_id && (
    //                                 <div className="col-md-6">
    //                                     <div className="detail-item">
    //                                         <small className="text-muted">Employee</small>
    //                                         <div className="fw-semibold">
    //                                             {users.find(u => u.id === formData.user_id)?.name || ""}
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             )}
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>

    //             {/* Vendor & Employee Section */}
    //             <div className="mt-4">
    //                 <div className="card border-0 shadow-sm">
    //                     <div className="card-header bg-light">
    //                         <h6 className="mb-0">
    //                             <i className="mdi mdi-account-group-outline me-2"></i>
    //                             Vendor & Employee
    //                         </h6>
    //                     </div>
    //                     <div className="card-body">
    //                         <div className="row">
    //                             <div className="col-md-6">
    //                                 <div className="detail-item">
    //                                     <small className="text-muted">Supplier</small>
    //                                     <div className="fw-semibold">
    //                                         {selectedVendorObj?.name || ""}

    //                                     </div>
    //                                 </div>
    //                             </div>
    //                             {formData.user_id && (
    //                                 <div className="col-md-6">
    //                                     <div className="detail-item">
    //                                         <small className="text-muted">Employee</small>
    //                                         <div className="fw-semibold">
    //                                             {users.find(u => u.id === formData.user_id)?.name || ""}
    //                                         </div>
    //                                     </div>
    //                                 </div>
    //                             )}
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //             {(formData.client_id || formData.project_id) && paymentType === 'direct' && (
    //                 <div className="mt-4">
    //                     <div className="card border-0 shadow-sm">
    //                         <div className="card-header bg-light">
    //                             <h6 className="mb-0">
    //                                 <i className="mdi mdi-briefcase-outline me-2"></i>
    //                                 Project & Client
    //                             </h6>
    //                         </div>
    //                         <div className="card-body">
    //                             <div className="row">
    //                                 {formData.client_id && (
    //                                     <div className="col-md-6">
    //                                         <div className="detail-item">
    //                                             <small className="text-muted">Client</small>
    //                                             <div className="fw-semibold">
    //                                                 {clients.find(c => c.id === formData.client_id)?.name || ""}
    //                                             </div>
    //                                         </div>
    //                                     </div>
    //                                 )}
    //                                 {formData.project_id && (
    //                                     <div className="col-md-6">
    //                                         <div className="detail-item">
    //                                             <small className="text-muted">Project</small>
    //                                             <div className="fw-semibold">
    //                                                 {projects.find(p => p.id === formData.project_id)?.name || ""}
    //                                             </div>
    //                                         </div>
    //                                     </div>
    //                                 )}
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             )}


    //             {/* Attachment Section */}
    //             {(formData.attatchment || formData.previewUrl) ? (
    //                 <div style={{ textAlign: "center", position: "relative", marginBottom: "1rem" }}>
    //                     {(() => {
    //                         const file = formData.attatchment instanceof File ? formData.attatchment : null;
    //                         const backendUrl = process.env.REACT_APP_BACKEND_URL;

    //                         const fileUrl = file
    //                             ? URL.createObjectURL(file)
    //                             : `${backendUrl}/storage/${formData.previewUrl}`;

    //                         const fileName = file ? file.name : formData.previewUrl;
    //                         const extension = fileName?.split(".").pop().toLowerCase();

    //                         // IMAGE PREVIEW
    //                         if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension)) {
    //                             return (
    //                                 <img
    //                                     src={fileUrl}
    //                                     alt="Preview"
    //                                     style={{
    //                                         width: "100%",
    //                                         maxHeight: "400px",
    //                                         cursor: formData.previewUrl ? "pointer" : "default",
    //                                         borderRadius: "10px",
    //                                     }}
    //                                     onClick={() => {
    //                                         if (formData.previewUrl) {
    //                                             const filename = formData.previewUrl.split('/').pop();
    //                                             const fileDownloadUrl = `${backendUrl}/api/expenses/download/${encodeURIComponent(filename)}`;
    //                                             const userInfo = JSON.parse(localStorage.getItem("user-info"));
    //                                             const origin = localStorage.getItem("user-origin");
    //                                             const token = userInfo?.token;

    //                                             axios.get(fileDownloadUrl, {
    //                                                 responseType: "blob",
    //                                                 headers: {
    //                                                     Authorization: `Bearer ${token}`,
    //                                                     Accept: "application/json",
    //                                                     "Tenant-Origin": origin,
    //                                                 },
    //                                             })
    //                                                 .then((response) => {
    //                                                     const blob = new Blob([response.data]);
    //                                                     const link = document.createElement("a");
    //                                                     link.href = URL.createObjectURL(blob);
    //                                                     link.download = filename;
    //                                                     document.body.appendChild(link);
    //                                                     link.click();
    //                                                     document.body.removeChild(link);
    //                                                 })
    //                                                 .catch((error) => console.error("Error downloading file:", error));
    //                                         }
    //                                     }}
    //                                 />
    //                             );
    //                         }

    //                         // PDF PREVIEW
    //                         if (extension === "pdf") {
    //                             return (
    //                                 <iframe
    //                                     src={fileUrl}
    //                                     style={{ width: "100%", height: "300px", border: "none" }}
    //                                     title="PDF Preview"
    //                                 />
    //                             );
    //                         }

    //                         // OTHER FILE TYPES
    //                         return (
    //                             <a href={fileUrl} target="_blank" rel="noopener noreferrer">
    //                                 View Attachment ({extension.toUpperCase()})
    //                             </a>
    //                         );
    //                     })()}
    //                 </div>
    //             ) : null}
    //         </div>
    //     );
    // };

    // Add this to see what's happening
    console.log('Debug - Modal State:', {
        showModal,
        expenseId,
        expenseData,
        loggedInUser,
        isAdmin,
        formDataType: formData.type,
        formDataUserId: formData.user_id,
        shouldAutoFill: showModal && !expenseId && !expenseData && loggedInUser && !isAdmin
    });
    const renderViewMode = () => {
        // Get vendor details
        const selectedVendorObj = vendors.find(v => v.id?.toString() === formData.vendor_id?.toString());

        // Determine the vendor's original currency
        const vendorOriginalCurrency = selectedVendorObj?.currency || "AED";

        // Get the currency that was selected when creating/editing the expense
        const vendorCurrencyUsed = formData.vendor_currency || vendorOriginalCurrency;

        // Check if advance was applied
        const advanceApplied = parseFloat(formData.advance_applied || 0);
        const isAdvanceApplied = formData.apply_advance && advanceApplied > 0;

        // Get available advance balance
        const vendorAdvanceBalance = parseFloat(formData.vendor_advance_balance || 0);

        // Function to convert amount based on currency
        const convertAmountForDisplay = (amount, fromCurrency, toCurrency) => {
            if (!amount || parseFloat(amount) === 0) return { amount: "0", currency: toCurrency };

            const amountNum = parseFloat(amount);

            // If fromCurrency is AED and we want to display in USD (vendor is USD)
            if (fromCurrency === "AED" && toCurrency === "USD") {
                // You should implement dynamic exchange rate here
                // For now, using a fixed rate
                const exchangeRate = 1 / 3.692; // 1 AED = 0.27 USD
                return {
                    amount: (amountNum * exchangeRate).toFixed(2),
                    currency: "USD"
                };
            }

            // If currencies are same or no conversion needed
            return {
                amount: amountNum.toFixed(2),
                currency: fromCurrency
            };
        };

        // Determine if we need to convert for display
        const shouldConvertForDisplay = vendorCurrencyUsed === "AED" && vendorOriginalCurrency === "USD";

        // Convert main amount
        const rawAmount = formData.amount || formData.amount_without_tax || "0";
        const displayAmountInfo = shouldConvertForDisplay ?
            convertAmountForDisplay(rawAmount, "AED", "USD") :
            { amount: rawAmount, currency: vendorCurrencyUsed };

        // Convert advance amounts
        let displayAdvanceInfo = {};
        let displayAdvanceBalanceInfo = {};
        const remainingAdvanceBalance = Math.max(0, vendorAdvanceBalance - advanceApplied);

        if (isAdvanceApplied) {
            displayAdvanceInfo = shouldConvertForDisplay ?
                convertAmountForDisplay(advanceApplied, "AED", "USD") :
                { amount: advanceApplied.toFixed(2), currency: vendorCurrencyUsed };

            // Show remaining balance after applying advance
            displayAdvanceBalanceInfo = shouldConvertForDisplay ?
                convertAmountForDisplay(remainingAdvanceBalance, "AED", "USD") :
                { amount: remainingAdvanceBalance.toFixed(2), currency: vendorCurrencyUsed };
        } else if (vendorAdvanceBalance > 0) {
            // No advance applied, show full available balance
            displayAdvanceBalanceInfo = shouldConvertForDisplay ?
                convertAmountForDisplay(vendorAdvanceBalance, "AED", "USD") :
                { amount: vendorAdvanceBalance.toFixed(2), currency: vendorCurrencyUsed };
        }

        // Convert tax-related amounts
        let displayTaxInfo = {};
        const fieldsToConvert = ['amount_without_tax', 'adjustment_amount', 'total_amount', 'vat_amount'];
        fieldsToConvert.forEach(field => {
            const converted = shouldConvertForDisplay ?
                convertAmountForDisplay(taxFields[field] || "0", "AED", "USD") :
                { amount: taxFields[field] || "0", currency: vendorCurrencyUsed };
            displayTaxInfo[field] = converted;
        });

        // Format date to dd-mm-yyyy
        const formatDate = (dateString) => {
            if (!dateString) return "";

            try {
                const date = new Date(dateString);
                if (isNaN(date.getTime())) return dateString; // Return original if invalid

                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();

                return `${day}-${month}-${year}`;
            } catch (error) {
                console.error("Date formatting error:", error);
                return dateString;
            }
        };

        // Format amount with commas (US format) and currency symbol
        const formatAmount = (amount, currency) => {
            if (!amount || parseFloat(amount) === 0) return "";

            const currencySymbols = {
                'AED': 'AED ',
                'USD': '$',
                'EUR': '€',
                'GBP': '£'
            };

            const symbol = currencySymbols[currency] || currency + ' ';

            // Convert to number and format with commas
            const numAmount = parseFloat(amount);
            const formattedAmount = numAmount.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            return `${symbol}${formattedAmount}`;
        };

        // Format amount without currency symbol (just the number with commas)
        const formatAmountNumber = (amount) => {
            if (!amount || parseFloat(amount) === 0) return "0.00";

            const numAmount = parseFloat(amount);
            return numAmount.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        };

        const paymentStatusBadge = expensePaymentSummary.status === 'fully_paid'
            ? { className: 'bg-success', label: 'Fully Paid', icon: 'mdi-check-circle' }
            : expensePaymentSummary.status === 'partially_paid'
                ? { className: 'bg-info', label: 'Partially Paid', icon: 'mdi-progress-check' }
                : { className: 'bg-warning', label: 'Payment Pending', icon: 'mdi-clock-outline' };

        return (
            <div className="d-flex flex-column h-100">
                {/* Tab Navigation */}
                <ul className="nav nav-tabs nav-tabs-custom mb-3 px-3">
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'details' ? 'active' : ''}`}
                            onClick={() => setActiveTab('details')}
                            href="#"
                            style={{ cursor: 'pointer' }}
                        >
                            Details
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className={`nav-link ${activeTab === 'preview' ? 'active' : ''}`}
                            onClick={() => setActiveTab('preview')}
                            href="#"
                            style={{ cursor: 'pointer' }}
                        >
                            Attachment Preview
                        </a>
                    </li>
                </ul>

                <div className="tab-content flex-grow-1 px-3 pb-3" style={{ overflowY: 'auto' }}>
                    {activeTab === 'details' ? (
                        <div className="animate__animated animate__fadeIn">
                            {/* Header */}
                            <div className="text-center mb-4">
                                <h5 className="text-primary mb-2">Expense Details</h5>
                                <div className="d-flex justify-content-center align-items-center gap-3">
                                    <span className="badge bg-secondary">
                                        {formData.type === "external" ? "Direct" :
                                            formData.type === "salary" ? "Salary" : "Petty Cash"}
                                    </span>
                                    {formData.tax_type && (
                                        <span className={`badge ${formData.tax_type === "taxable" ? "bg-success" : "bg-warning"}`}>
                                            {formData.tax_type}
                                        </span>
                                    )}
                                    {/* Display currency info */}
                                    <span className="badge bg-info">
                                        {displayAmountInfo.currency}
                                    </span>
                                    {shouldConvertForDisplay && (
                                        <span className="badge bg-warning">
                                            Converted
                                        </span>
                                    )}
                                    {/* Advance Applied Badge */}
                                    {isAdvanceApplied && (
                                        <span className="badge bg-success">
                                            <i className="mdi mdi-cash-check me-1"></i>
                                            Advance Applied
                                        </span>
                                    )}
                                    <span className={`badge ${paymentStatusBadge.className}`}>
                                        <i className={`mdi ${paymentStatusBadge.icon} me-1`}></i>
                                        {paymentStatusBadge.label}
                                    </span>
                                </div>
                            </div>

                            {/* Narration Section */}
                            <div className="mb-4">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-gradient-primary text-white">
                                        <h6 className="mb-0">
                                            <i className="mdi mdi-text-box-outline me-2"></i>
                                            Narration
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <p className="card-text fs-6 mb-0 text-muted">
                                            {formData.narration || "No narration provided"}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Main Details Grid */}
                            <div className="row">
                                {/* Left Column - Basic Information */}
                                <div className="col-md-6">
                                    <div className="card h-100 border-0 shadow-sm">
                                        <div className="card-header bg-light">
                                            <h6 className="mb-0">
                                                <i className="mdi mdi-information-outline me-2"></i>
                                                Basic Information
                                            </h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="detail-item mb-3">
                                                <small className="text-muted">Date</small>
                                                <div className="fw-semibold">{formatDate(formData.date)}</div>
                                            </div>
                                            <div className="detail-item mb-3">
                                                <small className="text-muted">Expense Type</small>
                                                <div className="fw-semibold">
                                                    {expenseTypes.find(et => et.id === formData.expense_type_id)?.name || ""}
                                                </div>
                                            </div>
                                            <div className="detail-item mb-3">
                                                <small className="text-muted">VAT Type</small>
                                                <div className="fw-semibold">{formData.tax_type || ""}</div>
                                            </div>
                                            <div className="detail-item">
                                                <small className="text-muted">Journal ID</small>
                                                <div className="fw-semibold">
                                                    {formData.journal_id ? (
                                                        <span className="badge bg-soft-primary text-primary">#{formData.journal_id}</span>
                                                    ) : (
                                                        <span className="badge bg-soft-danger text-danger">Missing Entry</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Column - Payment & Status */}
                                <div className="col-md-6">
                                    <div className="card h-100 border-0 shadow-sm">
                                        <div className="card-header bg-light">
                                            <h6 className="mb-0">
                                                <i className="mdi mdi-credit-card-outline me-2"></i>
                                                Payment & Status
                                            </h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="detail-item mb-3">
                                                <small className="text-muted">Payment Method</small>
                                                <div className="fw-semibold">
                                                    {formData.type === "external" ? (
                                                        <span className="badge bg-info">Direct</span>
                                                    ) : formData.type === "salary" ? (
                                                        <span className="badge bg-warning">Salary</span>
                                                    ) : (
                                                        <span className="badge bg-secondary">Petty Cash</span>
                                                    )}
                                                </div>
                                            </div>
                                            {/* Purchase Order Info if exists */}
                                            {formData.purchase_order_id && (
                                                <div className="detail-item mb-3">
                                                    <small className="text-muted">Purchase Order</small>
                                                    <div className="fw-semibold">
                                                        <span className="badge bg-primary">
                                                            PO: {formData.purchase_order?.ref_no || formData.purchase_order_id}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="detail-item">
                                                <small className="text-muted">Payment Status</small>
                                                <div className="fw-semibold">
                                                    <span className={`badge ${paymentStatusBadge.className}`}>
                                                        <i className={`mdi ${paymentStatusBadge.icon} me-1`}></i>
                                                        {paymentStatusBadge.label}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="detail-item mt-3">
                                                <small className="text-muted">Total Paid</small>
                                                <div className="fw-semibold">
                                                    {formatAmount(expensePaymentSummary.totalPaid, displayAmountInfo.currency)}
                                                </div>
                                            </div>

                                            <div className="detail-item mt-3">
                                                <small className="text-muted">Remaining Balance</small>
                                                <div className="fw-semibold text-danger">
                                                    {formatAmount(expensePaymentSummary.remainingBalance, displayAmountInfo.currency) || `${displayAmountInfo.currency} 0.00`}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Financial Summary Card */}
                            <div className="card mt-4 mb-4 border-0 shadow-sm">
                                <div className="card-header bg-light">
                                    <h6 className="mb-0">
                                        <i className="mdi mdi-calculator me-2"></i>
                                        Financial Summary ({displayAmountInfo.currency})
                                    </h6>
                                </div>
                                <div className="card-body">
                                    {/* Current Expense Amount */}
                                    <div className="detail-item mb-3">
                                        <small className="text-muted">
                                            {isAdvanceApplied ? "Net Amount Payable" : "Expense Amount"}
                                        </small>
                                        <div className="fw-bold text-dark fs-4">
                                            {formatAmount(displayAmountInfo.amount, displayAmountInfo.currency)}
                                        </div>
                                        {shouldConvertForDisplay && rawAmount && parseFloat(rawAmount) > 0 && (
                                            <small className="text-muted d-block mt-1">
                                                Original: {formatAmount(rawAmount, "AED")}
                                            </small>
                                        )}
                                    </div>

                                    {/* Adjustment Amount Display */}
                                    {parseFloat(displayTaxInfo.adjustment_amount?.amount || 0) !== 0 && (
                                        <div className="detail-item mb-3">
                                            <small className="text-muted">Adjustment Amount</small>
                                            <div className="fw-semibold text-dark">
                                                {formatAmount(displayTaxInfo.adjustment_amount?.amount, displayTaxInfo.adjustment_amount?.currency)}
                                            </div>
                                            {shouldConvertForDisplay && taxFields.adjustment_amount && parseFloat(taxFields.adjustment_amount) !== 0 && (
                                                <small className="text-muted d-block mt-1">
                                                    Original: {formatAmount(taxFields.adjustment_amount, "AED")}
                                                </small>
                                            )}
                                        </div>
                                    )}

                                    {/* VAT Amount Display */}
                                    {formData.tax_type === "taxable" && (
                                        <div className="detail-item mb-3">
                                            <small className="text-muted">
                                                {selectedVendorObj?.rcm_eligible ? `RCM VAT (${taxFields.tax || 5}%)` : `VAT Amount (${taxFields.tax || 5}%)`}
                                                {selectedVendorObj?.rcm_eligible && (
                                                    <span className="badge bg-soft-info text-info ms-2" style={{ fontSize: '10px' }}>Reverse Charge</span>
                                                )}
                                            </small>
                                            <div className="fw-semibold text-dark">
                                                {(() => {
                                                    const savedVat = displayTaxInfo.vat_amount?.amount;
                                                    if (savedVat !== '' && savedVat !== undefined && savedVat !== "0" && savedVat !== "0.00") {
                                                        return formatAmount(savedVat, displayTaxInfo.vat_amount.currency);
                                                    }

                                                    const baseAmount = parseFloat(displayTaxInfo.amount_without_tax?.amount || 0);
                                                    const taxPercentage = parseFloat(taxFields.tax || 5);
                                                    const calculatedVat = baseAmount * (taxPercentage / 100);
                                                    const finalCalculatedVat = isAdvanceApplied
                                                        ? calculatedVat - (parseFloat(displayAdvanceInfo.amount || 0) * (taxPercentage / 100))
                                                        : calculatedVat;
                                                    return formatAmount(Math.max(0, finalCalculatedVat).toFixed(2), displayAmountInfo.currency);
                                                })()}
                                            </div>
                                            {shouldConvertForDisplay && taxFields.vat_amount && parseFloat(taxFields.vat_amount) !== 0 && (
                                                <small className="text-muted d-block mt-1">
                                                    Original: {formatAmount(taxFields.vat_amount, "AED")}
                                                </small>
                                            )}
                                        </div>
                                    )}

                                    {/* Advance Details */}
                                    <div className="mb-4">
                                        {isAdvanceApplied ? (
                                            <div className="alert alert-light">
                                                <div className="d-flex align-items-center mb-2">
                                                    <i className="mdi mdi-cash-check me-2 fs-4"></i>
                                                    <div>
                                                        <div className="fw-bold">Advance Applied</div>
                                                        <small className="text-muted">This amount was already paid as advance</small>
                                                    </div>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span>Advance Amount</span>
                                                    <span className="fw-bold">{formatAmount(displayAdvanceInfo.amount, displayAdvanceInfo.currency)}</span>
                                                </div>
                                            </div>
                                        ) : vendorAdvanceBalance > 0 ? (
                                            <div className="alert alert-light border">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <small className="text-muted d-block">Available Vendor Advance</small>
                                                        <div className="fw-semibold">{formatAmount(displayAdvanceBalanceInfo.amount, displayAdvanceBalanceInfo.currency)}</div>
                                                    </div>
                                                    <small className="text-muted">No advance applied</small>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>

                                    {/* Total Payable */}
                                    <div className="detail-item">
                                        <small className="text-muted">Final Payment to Vendor</small>
                                        <div className="fw-bold text-success fs-3">
                                            {formData.tax_type === "taxable" ? (
                                                (() => {
                                                    if (selectedVendorObj?.rcm_eligible) {
                                                        // For RCM, total payable to vendor doesn't include VAT
                                                        const amount = parseFloat(displayTaxInfo.amount_without_tax?.amount || 0);
                                                        const adjustment = parseFloat(displayTaxInfo.adjustment_amount?.amount || 0);
                                                        // Advance already deducted from base in logic above, but safer to follow the tax details logic
                                                        return formatAmount((amount + adjustment).toFixed(2), displayTaxInfo.total_amount?.currency);
                                                    }
                                                    return formatAmount(displayTaxInfo.total_amount?.amount, displayTaxInfo.total_amount?.currency);
                                                })()
                                            ) : (
                                                formatAmount(displayAmountInfo.amount, displayAmountInfo.currency)
                                            )}
                                        </div>

                                        {/* Simple breakdown when advance applied */}
                                        {isAdvanceApplied && (
                                            <div className="mt-2">
                                                <small className="text-muted d-block">Breakdown:</small>
                                                <div className="d-flex align-items-center">
                                                    <span className="me-2">Total Expense:</span>
                                                    <span className="fw-semibold">
                                                        {(() => {
                                                            const original = parseFloat(displayTaxInfo.total_amount?.amount) + parseFloat(displayAdvanceInfo.amount);
                                                            return formatAmount(original.toString(), displayAmountInfo.currency);
                                                        })()}
                                                    </span>
                                                </div>
                                                <div className="d-flex align-items-center text-success">
                                                    <i className="mdi mdi-minus-circle me-1"></i>
                                                    <span>Advance already paid:</span>
                                                    <span className="fw-semibold ms-2">{formatAmount(displayAdvanceInfo.amount, displayAdvanceInfo.currency)}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Tax Details Section - Updated with converted amounts */}
                            {formData.tax_type === "taxable" && (
                                <div className="mt-4">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-header bg-light">
                                            <h6 className="mb-0">
                                                <i className="mdi mdi-calculator me-2"></i>
                                                Tax Details ({displayAmountInfo.currency})
                                                {isAdvanceApplied && (
                                                    <span className="badge bg-success ms-2">
                                                        After Advance
                                                    </span>
                                                )}
                                            </h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="detail-item mb-3">
                                                        <small className="text-muted">Invoice No</small>
                                                        <div className="fw-semibold">{taxFields.invoice_no || ""}</div>
                                                    </div>
                                                    <div className="detail-item mb-3">
                                                        <small className="text-muted">Invoice Date</small>
                                                        <div className="fw-semibold">{formatDate(taxFields.invoice_date) || ""}</div>
                                                    </div>
                                                    <div className="detail-item">
                                                        <small className="text-muted">Amount (Excl. VAT)</small>
                                                        <div className="fw-semibold">
                                                            {formatAmount(displayTaxInfo.amount_without_tax?.amount, displayTaxInfo.amount_without_tax?.currency)}
                                                        </div>
                                                        {/* Show original amount if converted */}
                                                        {shouldConvertForDisplay && taxFields.amount_without_tax && (
                                                            <small className="text-muted d-block mt-1">
                                                                Original: {formatAmount(taxFields.amount_without_tax, "AED")}
                                                            </small>
                                                        )}

                                                        {/* Show advance note if applied */}
                                                        {isAdvanceApplied && taxFields.amount_without_tax && (
                                                            <small className="text-success d-block mt-1">
                                                                <i className="mdi mdi-information-outline me-1"></i>
                                                                This amount is after deducting advance of {formatAmount(displayAdvanceInfo.amount, displayAdvanceInfo.currency)}
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">

                                                    <div className="detail-item mb-3">
                                                        <small className="text-muted">
                                                            {selectedVendorObj?.rcm_eligible ? `RCM VAT (${taxFields.tax || 5}%)` : `VAT Amount (${taxFields.tax || 5}%)`}
                                                            {selectedVendorObj?.rcm_eligible && (
                                                                <Badge bg="info" className="ms-2">RCM</Badge>
                                                            )}
                                                        </small>
                                                        <div className="fw-semibold text-primary">
                                                            {(() => {
                                                                // Use saved VAT amount if available
                                                                const savedVat = displayTaxInfo.vat_amount?.amount;

                                                                // Calculate VAT for comparison/fallback
                                                                const baseAmount = parseFloat(displayTaxInfo.amount_without_tax?.amount || 0);
                                                                const taxPercentage = parseFloat(taxFields.tax || 5);
                                                                const calculatedVat = baseAmount * (taxPercentage / 100);

                                                                // Apply advance deduction if applicable for calculated value
                                                                const finalCalculatedVat = isAdvanceApplied
                                                                    ? calculatedVat - (parseFloat(displayAdvanceInfo.amount || 0) * (taxPercentage / 100))
                                                                    : calculatedVat;

                                                                // If we have a saved VAT amount, use it
                                                                if (savedVat !== '' && savedVat !== undefined && savedVat !== "0" && savedVat !== "0.00") {
                                                                    const isManual = Math.abs(parseFloat(savedVat) - calculatedVat) > 0.01;
                                                                    return (
                                                                        <div className="d-flex align-items-center">
                                                                            {formatAmount(savedVat, displayTaxInfo.vat_amount.currency)}
                                                                        </div>
                                                                    );
                                                                }

                                                                return formatAmount(Math.max(0, finalCalculatedVat).toFixed(2), displayAmountInfo.currency);
                                                            })()}
                                                        </div>
                                                        <small className="text-muted">
                                                            Calculated on: {formatAmountNumber(parseFloat(displayTaxInfo.amount_without_tax?.amount || 0))} × {taxFields.tax || 5}%
                                                        </small>
                                                    </div>
                                                    <div className="detail-item mb-3">
                                                        <small className="text-muted">Adjustment Amount</small>
                                                        <div className="fw-semibold">
                                                            {formatAmount(displayTaxInfo.adjustment_amount?.amount, displayTaxInfo.adjustment_amount?.currency)}
                                                        </div>
                                                        {shouldConvertForDisplay && taxFields.adjustment_amount && (
                                                            <small className="text-muted d-block mt-1">
                                                                Original: {formatAmount(taxFields.adjustment_amount, "AED")}
                                                            </small>
                                                        )}
                                                    </div>
                                                    <div className="detail-item">
                                                        <small className="text-muted">
                                                            {selectedVendorObj?.rcm_eligible ? "Total Charge (incl. Adjustment)" : "Total Amount"}
                                                        </small>
                                                        <div className="fw-semibold text-success">
                                                            {(() => {
                                                                if (selectedVendorObj?.rcm_eligible) {
                                                                    // For RCM, total payable to vendor doesn't include VAT
                                                                    const amount = parseFloat(displayTaxInfo.amount_without_tax?.amount || 0);
                                                                    const adjustment = parseFloat(displayTaxInfo.adjustment_amount?.amount || 0);
                                                                    return formatAmount((amount + adjustment).toFixed(2), displayTaxInfo.total_amount?.currency);
                                                                }
                                                                return formatAmount(displayTaxInfo.total_amount?.amount, displayTaxInfo.total_amount?.currency);
                                                            })()}
                                                        </div>
                                                        {shouldConvertForDisplay && taxFields.total_amount && (
                                                            <small className="text-muted d-block mt-1">
                                                                Original: {formatAmount(taxFields.total_amount, "AED")}
                                                            </small>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {formData.type === 'deferred' && (
                                <div className="mt-4">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-header bg-light">
                                            <h6 className="mb-0">
                                                <i className="mdi mdi-calendar-range me-2"></i>
                                                Recognition Schedule
                                            </h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="detail-item mb-3">
                                                        <small className="text-muted">Recognition Period</small>
                                                        <div className="fw-semibold text-capitalize">{formData.recognition_period || "Monthly"}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="detail-item mb-3">
                                                        <small className="text-muted">Start Date</small>
                                                        <div className="fw-semibold">{formatDate(formData.deferred_start_date)}</div>
                                                    </div>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="detail-item mb-3">
                                                        <small className="text-muted">End Date</small>
                                                        <div className="fw-semibold">{formatDate(formData.deferred_end_date)}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="alert alert-info mb-0 py-2">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <span><strong>Total Periods:</strong> {formData.total_periods}</span>
                                                    <span><strong>Amount per Period:</strong> {formData.amount_per_period} AED</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Vendor & Employee Section */}
                            <div className="mt-4">
                                <div className="card border-0 shadow-sm">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0">
                                            <i className="mdi mdi-account-group-outline me-2"></i>
                                            Vendor & Employee
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            {formData.type !== 'salary' && (
                                                <div className="col-md-6">
                                                    <div className="detail-item">
                                                        <small className="text-muted">Supplier</small>
                                                        <div className="fw-semibold d-flex align-items-center">
                                                            {selectedVendorObj?.name || ""}
                                                            {selectedVendorObj?.rcm_eligible && (
                                                                <Badge bg="info" className="ms-2" style={{ fontSize: '10px' }}>RCM Eligible</Badge>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {formData.user_id && (
                                                <div className="col-md-6">
                                                    <div className="detail-item">
                                                        <small className="text-muted">Employee</small>
                                                        <div className="fw-semibold">
                                                            {(Array.isArray(users) ? users : []).find(u => u.id === formData.user_id)?.name || ""}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {(formData.client_id || formData.project_id) && (
                                <div className="mt-4">
                                    <div className="card border-0 shadow-sm">
                                        <div className="card-header bg-light">
                                            <h6 className="mb-0">
                                                <i className="mdi mdi-briefcase-outline me-2"></i>
                                                Project & Client
                                            </h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                {formData.client_id && (
                                                    <div className="col-md-6">
                                                        <div className="detail-item">
                                                            <small className="text-muted">Client</small>
                                                            <div className="fw-semibold">
                                                                {clients.find(c => c.id === formData.client_id)?.name || ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {formData.project_id && (
                                                    <div className="col-md-6">
                                                        <div className="detail-item">
                                                            <small className="text-muted">Project</small>
                                                            <div className="fw-semibold">
                                                                {projects.find(p => p.id === formData.project_id)?.name || ""}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="card mt-4 border-0 shadow-sm">
                                <div className="card-header bg-light">
                                    <h6 className="mb-0">
                                        <i className="mdi mdi-file-document-outline me-2"></i>
                                        Payment Details
                                    </h6>
                                </div>
                                <div className="card-body">
                                    {expensePaymentHistory.length > 0 ? (
                                        expensePaymentHistory.map((payment) => (
                                            <div key={payment.key} className="border rounded p-3 mb-3">
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div>
                                                        <div className="fw-semibold text-dark">
                                                            Voucher: {payment.voucherId}
                                                        </div>
                                                        <div className="text-muted small mt-1">
                                                            Date: {formatDate(payment.date)}
                                                        </div>
                                                        {payment.accountName && (
                                                            <div className="text-muted small">
                                                                Account: {payment.accountName}
                                                            </div>
                                                        )}
                                                        <div className="text-muted small">
                                                            Balance: {formatAmount(payment.remainingBalance, displayAmountInfo.currency) || `${displayAmountInfo.currency} 0.00`}
                                                        </div>
                                                        {payment.totalTransactionAmount > 0 && (
                                                            <div className="text-muted small mt-1">
                                                                Total Transaction: <span className="fw-semibold text-dark">{formatAmount(payment.totalTransactionAmount, payment.currency)}</span>
                                                            </div>
                                                        )}
                                                        {payment.otherAllocations?.length > 0 && (
                                                            <div className="mt-2 border-top pt-2">
                                                                <small className="text-muted d-block mb-2 fw-medium text-uppercase" style={{ fontSize: '0.65rem', letterSpacing: '0.5px' }}>Combined Transaction Breakdown:</small>
                                                                <div className="d-flex justify-content-between align-items-center mb-1 bg-light p-1 px-2 rounded">
                                                                    <span className="small text-dark fw-medium">Payment for this Bill:</span>
                                                                    <span className="small fw-bold text-success">{formatAmount(payment.amount, formData.vendor_currency || 'USD')}</span>
                                                                </div>
                                                                {payment.otherAllocations.map((alloc, idx) => (
                                                                    <div key={idx} className="d-flex justify-content-between align-items-center mb-1 ps-2 ms-1 border-start">
                                                                        <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                                                                            {alloc.label} {alloc.poRef ? ` (${alloc.poRef})` : ''}
                                                                        </span>
                                                                        <span className="text-muted fw-medium" style={{ fontSize: '0.75rem' }}>
                                                                            {formatAmount(alloc.amount, formData.vendor_currency || 'USD')}
                                                                        </span>
                                                                    </div>
                                                                ))}
                                                                <div className="d-flex justify-content-between align-items-center mt-2 pt-1 border-top border-dotted">
                                                                    <span className="small text-muted fw-medium">Total Distributed:</span>
                                                                    <span className="small fw-bold text-dark">
                                                                        {formatAmount(payment.amount + payment.otherAllocations.reduce((s, a) => s + a.amount, 0), formData.vendor_currency || 'USD')}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className="text-end">
                                                        <div className="fw-bold text-success">
                                                            {formatAmount(payment.transactionAmount || payment.amount, payment.currency)}
                                                        </div>
                                                        {(payment.exchangeRate && parseFloat(payment.exchangeRate) !== 1) && (
                                                            <div className="text-muted small">
                                                                {formatAmount(payment.amount, formData.vendor_currency || 'USD')}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="text-muted">
                                            No payment details found for this expense yet.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="h-100 d-flex flex-column bg-light rounded border animate__animated animate__fadeIn" style={{ minHeight: '800px' }}>
                            {formData.previewUrl ? (
                                <div className={`flex-grow-1 h-100 d-flex flex-column ${formData.previewUrl.match(/\.(pdf)$/i) ? 'p-0' : 'p-3'}`}>
                                    <div className={`flex-grow-1 position-relative shadow-sm ${formData.previewUrl.match(/\.(pdf)$/i) ? '' : 'bg-white border rounded overflow-hidden'}`}
                                        style={{ height: '800px' }}>  {/* Fixed height container */}
                                        {formData.previewUrl.match(/\.(jpg|jpeg|png|gif|webp)$/i) ? (
                                            <img
                                                src={`${process.env.REACT_APP_BACKEND_URL}/storage/${formData.previewUrl}`}
                                                className="w-100 h-100"
                                                style={{ objectFit: 'contain' }}
                                                alt="Attachment"
                                            />
                                        ) : (
                                            <iframe
                                                src={`${process.env.REACT_APP_BACKEND_URL}/storage/${formData.previewUrl}#toolbar=0&navpanes=0&scrollbar=0&view=FitV`}
                                                className="w-100 h-100"
                                                style={{
                                                    border: 'none',
                                                    display: 'block',
                                                    margin: 0,
                                                    padding: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    minHeight: '800px'
                                                }}
                                                title="Document Preview"
                                                allow="fullscreen"
                                            />
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted p-5">
                                    <i className="mdi mdi-paperclip fs-1 mb-2 opacity-25"></i>
                                    <p className="fw-medium">No Attachment Found</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    };
    const shouldShowPurchaseOrderDropdown = () => {
        // Must be in edit mode with vendor selected
        if (!isEditMode || !formData.vendor_id) {
            return false;
        }

        const expenseType = formData.type; // "external" or "internal"

        if (expenseType === "external") {
            if (paymentType === 'direct' && !formData.project_id) {
                // For direct expenses without project, don't show PO dropdown
                return false;
            }
            // For external expenses (bank): Show all POs for vendor
            return true;
        } else if (expenseType === "internal") {
            // For internal expenses (petty cash): Show only if project is selected
            return !!formData.project_id;
        }

        return false;
    };
    const renderEditMode = () => {
        // Your existing edit mode step rendering logic
        switch (currentStep) {
            case 1:
                return (
                    <>

                        {lockError && (
                            <div className="alert alert-danger m-2 mb-0">
                                <i className="mdi mdi-alert-circle-outline me-3"></i>
                                {lockError}
                            </div>
                        )}
                        <div className="mb-3">
                            <label className="form-font">Payment Date</label>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    views={["year", "month", "day"]}
                                    density="compact"
                                    format="DD-MM-YYYY"
                                    value={
                                        formData.date && dayjs(formData.date).isValid()
                                            ? dayjs(formData.date)
                                            : null
                                    }
                                    onChange={(newValue) => {
                                        setFormData((prev) => ({
                                            ...prev,
                                            date: newValue ? newValue.format("YYYY-MM-DD") : "",
                                        }));
                                    }}
                                    slotProps={{
                                        textField: {
                                            size: "small",
                                            fullWidth: true,
                                            className: "form-feild",
                                        },
                                        popper: {
                                            disablePortal: true,   // ✅ KEY LINE
                                            sx: {
                                                zIndex: 2000,        // ✅ ensure above offcanvas content
                                            },
                                        },
                                    }}
                                />

                            </LocalizationProvider>
                        </div>



                        <HierarchicalExpenseTypeDropdown
                            label="Expense Type"
                            value={formData.expense_type_id}
                            onChange={(e) => {
                                const expenseTypeId = e.target.value;
                                const selected = expenseTypes.find(et => et.id.toString() === expenseTypeId.toString());
                                const determinedPaymentType = e.target.paymentType || decidePaymentType(selected);

                                setPaymentType(determinedPaymentType);
                                setSelectedExpenseType(selected);

                                setFormData(prev => ({
                                    ...prev,
                                    expense_type_id: expenseTypeId,
                                    group_id: selected?.group_id || selected?.category?.group_id || "",
                                    category_type: selected?.category?.category_type || "",
                                    payment_type: determinedPaymentType,
                                    // Also save the matching ledger ID if available
                                    office_ledger_id: e.target.ledger_id || ""
                                }));
                            }}
                            error={errors.expense_type_id}
                            disabled={!isEditMode}
                        />

                        <Form.Group controlId="paymentMethod" className="mb-3">
                            <Form.Label className='form-font'>Payment Method</Form.Label>
                            <Form.Select
                                className={`form-feild ${errors?.payment_method ? 'is-invalid' : ''}`}
                                name="type"
                                value={formData.type}
                                onChange={handleChange}
                                disabled={!isEditMode}
                            >
                                <option value="">Select Payment Method</option>
                                <option value="external">Direct</option>
                                <option value="internal">Petty Cash</option>
                                <option value="salary">Payroll</option>
                                <option value="deferred">Deferred</option>

                            </Form.Select>
                            {errors.payment_method && <div className="invalid-feedback d-block font-size-12">*{errors.payment_method}</div>}
                        </Form.Group>

                        {formData.type === 'deferred' && (
                            <>
                                <Form.Group className="mb-3">
                                    <Form.Label className="form-font">Recognition Period</Form.Label>
                                    <Form.Select
                                        value={deferredFields.recognition_period}
                                        onChange={(e) => handleDeferredFieldChange('recognition_period', e.target.value)}
                                        disabled={!isEditMode}
                                    >
                                        <option value="monthly">Monthly</option>
                                        <option value="quarterly">Quarterly</option>
                                        <option value="yearly">Yearly</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="form-font">Start Date</Form.Label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={["year", "month", "day"]}
                                            format="DD-MM-YYYY"
                                            value={deferredFields.deferred_start_date && dayjs(deferredFields.deferred_start_date).isValid() ? dayjs(deferredFields.deferred_start_date) : null}
                                            onChange={(newValue) => handleDeferredFieldChange('deferred_start_date', newValue ? newValue.format("YYYY-MM-DD") : "")}
                                            disabled={!isEditMode}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    className: "form-feild",
                                                },
                                                popper: {
                                                    disablePortal: true,
                                                    sx: { zIndex: 2000 },
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="form-font">End Date</Form.Label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={["year", "month", "day"]}
                                            format="DD-MM-YYYY"
                                            value={deferredFields.deferred_end_date && dayjs(deferredFields.deferred_end_date).isValid() ? dayjs(deferredFields.deferred_end_date) : null}
                                            onChange={(newValue) => handleDeferredFieldChange('deferred_end_date', newValue ? newValue.format("YYYY-MM-DD") : "")}
                                            disabled={!isEditMode}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    className: "form-feild",
                                                },
                                                popper: {
                                                    disablePortal: true,
                                                    sx: { zIndex: 2000 },
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Form.Group>
                                {deferredFields.total_periods > 0 && (
                                    <div className="alert alert-info mt-2 mb-0 py-2">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span><strong>Total Periods:</strong> {deferredFields.total_periods}</span>
                                            <span><strong>Amount per Period:</strong> {deferredFields.amount_per_period} AED</span>
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </>
                );

            case 2:
                return (
                    <>
                        {lockError && (
                            <div className="alert alert-danger m-3 mb-0">
                                <i className="mdi mdi-alert-circle-outline me-2"></i>
                                {lockError}
                            </div>
                        )}
                        <h6 className="mb-3">
                            {formData.type === 'salary' ? 'Salary Details' :
                                paymentType === 'direct' ? 'Direct Expense Details' :
                                    paymentType === 'indirect' ? 'Indirect Expense Details' :
                                        paymentType === 'asset' ? 'Asset Purchase Details' : 'Select Expense Type First'}
                        </h6>

                        <>
                            {formData.type === 'salary' && (
                                <>


                                    <Form.Group className="mb-3">
                                        <Form.Label className="form-font">Salary Amount (AED)</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="amount"
                                            value={formData.amount}
                                            onChange={handleChange}
                                            className="form-feild"
                                            disabled={!isEditMode}
                                        />
                                    </Form.Group>



                                    <Form.Group className="mb-3">
                                        <Form.Label className='form-font'>Narration</Form.Label>
                                        <Form.Control
                                            className='form-control form-feild'
                                            type="text"
                                            name="narration"
                                            value={formData.narration}
                                            onChange={handleChange}
                                            disabled={!isEditMode}
                                            placeholder="Enter description"
                                        />
                                    </Form.Group>

                                    {/* Attachment field for salary type */}
                                    {isEditMode && (
                                        <>
                                            {(formData.attatchment || formData.previewUrl) ? (
                                                <div style={{ textAlign: "center", position: "relative", marginBottom: "1rem" }}>
                                                    {(() => {
                                                        const file = formData.attatchment instanceof File ? formData.attatchment : null;
                                                        const backendUrl = process.env.REACT_APP_BACKEND_URL;

                                                        const fileUrl = file
                                                            ? URL.createObjectURL(file)
                                                            : `${backendUrl}/storage/${formData.previewUrl}`;

                                                        const fileName = file ? file.name : formData.previewUrl;
                                                        const extension = fileName?.split(".").pop().toLowerCase();

                                                        if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension)) {
                                                            return (
                                                                <img
                                                                    src={fileUrl}
                                                                    alt="Preview"
                                                                    style={{
                                                                        width: "100%",
                                                                        maxHeight: "400px",
                                                                        cursor: formData.previewUrl ? "pointer" : "default",
                                                                        borderRadius: "10px",
                                                                    }}
                                                                    onClick={() => {
                                                                        if (formData.previewUrl) {
                                                                            const filename = formData.previewUrl.split('/').pop();
                                                                            const fileDownloadUrl = `${backendUrl}/api/expenses/download/${encodeURIComponent(filename)}`;
                                                                            const userInfo = JSON.parse(localStorage.getItem("user-info"));
                                                                            const origin = localStorage.getItem("user-origin");
                                                                            const token = userInfo?.token;

                                                                            axios.get(fileDownloadUrl, {
                                                                                responseType: "blob",
                                                                                headers: {
                                                                                    Authorization: `Bearer ${token}`,
                                                                                    Accept: "application/json",
                                                                                    "Tenant-Origin": origin,
                                                                                },
                                                                            })
                                                                                .then((response) => {
                                                                                    const blob = new Blob([response.data]);
                                                                                    const link = document.createElement("a");
                                                                                    link.href = URL.createObjectURL(blob);
                                                                                    link.download = filename;
                                                                                    document.body.appendChild(link);
                                                                                    link.click();
                                                                                    document.body.removeChild(link);
                                                                                })
                                                                                .catch((error) => console.error("Error downloading file:", error));
                                                                        }
                                                                    }}
                                                                />
                                                            );
                                                        }

                                                        if (extension === "pdf") {
                                                            return (
                                                                <iframe
                                                                    src={fileUrl}
                                                                    style={{ width: "100%", height: "300px", border: "none" }}
                                                                    title="PDF Preview"
                                                                />
                                                            );
                                                        }

                                                        return (
                                                            <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                View Attachment ({extension.toUpperCase()})
                                                            </a>
                                                        );
                                                    })()}

                                                    <CloseButton
                                                        onClick={() => {
                                                            setFormData(prev => ({ 
                                                                ...prev, 
                                                                attatchment: null, 
                                                                previewUrl: null,
                                                                amount: "",
                                                                amount_without_tax: "",
                                                                total_amount: ""
                                                            }));
                                                            setTaxFields(prev => ({
                                                                ...prev,
                                                                amount_without_tax: "",
                                                                vat_amount: "",
                                                                total_amount: ""
                                                            }));
                                                        }}
                                                        className="custom-close"
                                                    />
                                                </div>
                                            ) : (
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='form-font'>Attachment</Form.Label>
                                                    <Form.Control
                                                        className='form-control form-feild'
                                                        type="file"
                                                        name="attatchment"
                                                        onChange={handleChange}
                                                        disabled={!isEditMode}
                                                    />
                                                </Form.Group>
                                            )}
                                        </>
                                    )}
                                </>
                            )}
                            {formData.type !== 'salary' && (
                                <>

                                    {paymentType === 'direct' && (
                                        <>
                                            <Form.Group controlId="client" className="mb-3">
                                                <Form.Label className='form-font'>Client</Form.Label>
                                                <Form.Select
                                                    name='client_id'
                                                    value={formData.client_id}
                                                    onChange={handleClientChange}
                                                    className={`form-feild ${errors?.client_id ? 'is-invalid' : ''}`}
                                                    disabled={!isEditMode}
                                                >
                                                    <option value="">Select Client</option>
                                                    {clients.map(client => (
                                                        <option key={client.id} value={client.id}>
                                                            {client.name}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.client_id && <div className="invalid-feedback d-block font-size-12">*{errors.client_id}</div>}
                                            </Form.Group>


                                            <Form.Group controlId="project" className="mb-3">
                                                <Form.Label className='form-font'>Project</Form.Label>
                                                <Form.Select
                                                    className={`form-feild ${errors?.project_id ? 'is-invalid' : ''}`}
                                                    name="project_id"
                                                    value={formData.project_id}
                                                    onChange={handleProjectChange}  // CHANGE THIS LINE
                                                    disabled={!isEditMode}
                                                >
                                                    <option value="">Select Project</option>
                                                    {projects.map(project => (
                                                        <option key={project.id} value={project.id}>
                                                            {project.name}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.project_id && <div className="invalid-feedback d-block font-size-12">*{errors.project_id}</div>}
                                            </Form.Group>
                                        </>
                                    )}
                                </>
                            )}

                            {/* COMMON FIELDS FOR ALL TYPES - Except Salary */}
                            {formData.type !== 'salary' && (
                                <Form.Group controlId="vendor" className="mb-3">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <Form.Label className='form-font mb-0'>Supplier</Form.Label>
                                        {selectedVendorObj?.rcm_eligible && (
                                            <Badge bg="info" style={{ fontSize: '10px' }}>RCM Eligible</Badge>
                                        )}
                                    </div>
                                    <Form.Select
                                        name='vendor_id'
                                        value={formData.vendor_id}
                                        onChange={handleVendorChange}
                                        className={`form-feild ${errors?.vendor_id ? 'is-invalid' : ''}`}
                                        disabled={!isEditMode}
                                    >
                                        <option value="">Select Vendor</option>
                                        {vendors.map(vendor => (
                                            <option key={vendor.id} value={vendor.id}>
                                                {vendor.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    {errors.vendor_id && <div className="invalid-feedback d-block font-size-12">*{errors.vendor_id}</div>}
                                </Form.Group>
                            )}

                            {/* {formData.type === 'internal' && (

                                <Form.Group controlId="pettyCashEmployee" className="mb-3">
                                    <Form.Label className='form-font'>Employee</Form.Label>
                                    <Form.Select
                                        name='user_id'
                                        value={formData.user_id}
                                        onChange={handleChange}
                                        className={`form-feild ${errors?.user_id ? 'is-invalid' : ''}`}
                                        disabled={!isEditMode}
                                    >
                                        <option value="">Select Employee</option>
                                        {[...users]?.sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(user => (
                                            <option key={user.id} value={user.id}>
                                                {user.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    {errors.user_id && <div className="invalid-feedback d-block font-size-12">*{errors.user_id}</div>}
                                </Form.Group>

                            )} */}
                            {formData.type === 'internal' && (
                                <Form.Group controlId="user" className="mb-3">
                                    <Form.Label className='form-font'>Employee</Form.Label>

                                    {isAdmin ? (
                                        // Admin sees dropdown
                                        <Form.Select
                                            name="user_id"
                                            value={formData.user_id}
                                            onChange={handleChange}
                                            className={`form-feild ${errors?.user_id ? 'is-invalid' : ''}`}
                                            disabled={!isEditMode}
                                        >
                                            <option value="">Select</option>
                                            {[...users]?.sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(user => (
                                                <option key={user.id} value={user.id}>
                                                    {user.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        // Non-admin sees read-only field
                                        <Form.Control
                                            type="text"
                                            value={loggedInUser?.name || 'Current User'}
                                            className="form-feild"
                                            disabled
                                            readOnly
                                        />
                                    )}

                                    {errors.user_id && <div className="invalid-feedback font-size-12" >*{errors.user_id}</div>}
                                </Form.Group>
                            )}
                            {formData.type !== 'salary' && (
                                <Form.Group className="mb-3">
                                    <Form.Label className="form-font">VAT Type</Form.Label>
                                    <Form.Select
                                        className={`form-feild ${errors?.tax_type ? 'is-invalid' : ''}`}
                                        value={formData.tax_type}
                                        onChange={handleTaxTypeChange}
                                        name='tax_type'
                                        disabled={!isEditMode}
                                    >
                                        <option value="">Select VAT Type</option>
                                        <option value="taxable">Taxable</option>
                                        <option value="non-taxable">Non-Taxable</option>
                                    </Form.Select>
                                    {errors.tax_type && <div className="invalid-feedback d-block font-size-12">*{errors.tax_type}</div>}
                                </Form.Group>
                            )}

                            {formData.type !== 'salary' && (
                                <>
                                    {
                                        isEditMode && (
                                            <>
                                                {(formData.attatchment || formData.previewUrl) ? (
                                                    <div style={{ textAlign: "center", position: "relative", marginBottom: "1rem" }}>
                                                        {(() => {
                                                            const file = formData.attatchment instanceof File ? formData.attatchment : null;
                                                            const backendUrl = process.env.REACT_APP_BACKEND_URL;

                                                            const fileUrl = file
                                                                ? URL.createObjectURL(file)
                                                                : `${backendUrl}/storage/${formData.previewUrl}`;

                                                            const fileName = file ? file.name : formData.previewUrl;
                                                            const extension = fileName?.split(".").pop().toLowerCase();

                                                            // ─────────────────────────── IMAGE PREVIEW ───────────────────────────
                                                            if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(extension)) {
                                                                return (
                                                                    <img
                                                                        src={fileUrl}
                                                                        alt="Preview"
                                                                        style={{
                                                                            width: "100%",
                                                                            maxHeight: "400px",
                                                                            cursor: formData.previewUrl ? "pointer" : "default",
                                                                            borderRadius: "10px",
                                                                        }}
                                                                        onClick={() => {
                                                                            if (formData.previewUrl) {
                                                                                const filename = formData.previewUrl.split('/').pop();
                                                                                const fileDownloadUrl = `${backendUrl}/api/expenses/download/${encodeURIComponent(filename)}`;
                                                                                const userInfo = JSON.parse(localStorage.getItem("user-info"));
                                                                                const origin = localStorage.getItem("user-origin");
                                                                                const token = userInfo?.token;

                                                                                axios.get(fileDownloadUrl, {
                                                                                    responseType: "blob",
                                                                                    headers: {
                                                                                        Authorization: `Bearer ${token}`,
                                                                                        Accept: "application/json",
                                                                                        "Tenant-Origin": origin,
                                                                                    },
                                                                                })
                                                                                    .then((response) => {
                                                                                        const blob = new Blob([response.data]);
                                                                                        const link = document.createElement("a");
                                                                                        link.href = URL.createObjectURL(blob);
                                                                                        link.download = filename;
                                                                                        document.body.appendChild(link);
                                                                                        link.click();
                                                                                        document.body.removeChild(link);
                                                                                    })
                                                                                    .catch((error) => console.error("Error downloading file:", error));
                                                                            }
                                                                        }}
                                                                    />
                                                                );
                                                            }

                                                            // ─────────────────────────── PDF PREVIEW ───────────────────────────
                                                            if (extension === "pdf") {
                                                                return (
                                                                    <iframe
                                                                        src={fileUrl}
                                                                        style={{ width: "100%", height: "300px", border: "none" }}
                                                                        title="PDF Preview"
                                                                    />
                                                                );
                                                            }

                                                            // ─────────────────────────── OTHER FILE TYPES ───────────────────────────
                                                            return (
                                                                <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                    View Attachment ({extension.toUpperCase()})
                                                                </a>
                                                            );
                                                        })()}

                                                        <CloseButton
                                                            onClick={() => {
                                                                const today = new Date().toISOString().split('T')[0];
                                                                setFormData(prev => ({ 
                                                                    ...prev, 
                                                                    attatchment: null, 
                                                                    previewUrl: null,
                                                                    amount: "",
                                                                    amount_without_tax: "",
                                                                    total_amount: "",
                                                                    date: today,
                                                                    invoice_no: "",
                                                                    invoice_date: ""
                                                                }));
                                                                setTaxFields(prev => ({
                                                                    ...prev,
                                                                    amount_without_tax: "",
                                                                    vat_amount: "",
                                                                    total_amount: "",
                                                                    invoice_no: "",
                                                                    invoice_date: ""
                                                                }));
                                                            }}
                                                            className="custom-close"
                                                        />
                                                        {errors.attatchment && <div className="invalid-feedback d-block font-size-12 mt-2">*{errors.attatchment}</div>}
                                                    </div>
                                                ) : (
                                                    /* If no file exists → show upload input */
                                                    <Form.Group className="mb-3">
                                                        <Form.Label className='form-font'>Attachment</Form.Label>
                                                        <Form.Control
                                                            className='form-control form-feild'
                                                            type="file"
                                                            name="attatchment"
                                                            value={formData.attatchment}
                                                            onChange={handleChange}
                                                            disabled={!isEditMode}
                                                            placeholder="Enter description"
                                                        />
                                                        {errors.attatchment && <div className="invalid-feedback d-block font-size-12">*{errors.attatchment}</div>}
                                                    </Form.Group>
                                                )}
                                            </>
                                        )
                                    }
                                </>
                            )}

                            {shouldShowPurchaseOrderDropdown() && (
                                <Form.Group controlId="purchaseOrder" className="mb-3">
                                    <Form.Label className='form-font'>
                                        Purchase Order
                                    </Form.Label>

                                    <Form.Select
                                        name='purchase_order_id'
                                        value={formData.purchase_order_id || ''}
                                        onChange={handleChange}
                                        className={`form-feild ${errors?.purchase_order_id ? 'is-invalid' : ''}`}
                                        disabled={!isEditMode}
                                    >
                                        <option value="">Select Purchase Order</option>

                                        {/* Show ALL POs including the selected one */}
                                        {purchaseOrders
                                            .filter(po => {
                                                // When creating: only show POs with balance > 0
                                                if (!expenseId) {
                                                    return (po.converted_remaining_amount || 0) > 0;
                                                }
                                                // When editing: always show selected PO + others with balance > 0
                                                return po.isSelected || (po.converted_remaining_amount || 0) > 0;
                                            })
                                            .map(po => (
                                                <option
                                                    key={po.id}
                                                    value={po.id}
                                                    style={po.isSelected ? { backgroundColor: '#e8f5e8', fontWeight: 'bold' } : {}}
                                                >
                                                    {po.ref_no || `PO-${po.id}`}

                                                </option>
                                            ))
                                        }

                                        {/* Show message if no POs available */}
                                        {purchaseOrders.filter(po => (po.converted_remaining_amount || 0) > 0).length === 0 &&
                                            !formData.purchase_order_id && (
                                                <option value="" disabled>
                                                    No purchase orders with available balance
                                                </option>
                                            )}
                                    </Form.Select>

                                    {errors.purchase_order_id && (
                                        <div className="invalid-feedback d-block font-size-12">*{errors.purchase_order_id}</div>
                                    )}
                                </Form.Group>
                            )}



                            {/* {formData.purchase_order_id && formData.vendor_advance_balance > 0 && (
                                <div className="card border mb-3">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0">
                                            <i className="mdi mdi-cash-check me-2"></i>
                                            Vendor Advance
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <small className="text-muted">Available Advance:</small>
                                                <div className="fw-bold text-success">
                                                    {formData.vendor_advance_balance.toFixed(2)} 
                                                </div>
                                            </div>
                                        </div>

                                        <Form.Check
                                            type="switch"
                                            id="apply-advance-switch"
                                            label="Apply vendor advance"
                                            checked={formData.apply_advance || false}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                if (checked) {
                                                    // Calculate how much advance can be applied
                                                    const expenseAmount = formData.tax_type === "taxable"
                                                        ? parseFloat(taxFields.amount_without_tax || 0)
                                                        : parseFloat(formData.amount || 0);

                                                    const maxAdvance = Math.min(formData.vendor_advance_balance, expenseAmount);

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        apply_advance: true,
                                                        advance_applied: maxAdvance
                                                    }));

                                                    // Reduce the amount field
                                                    if (formData.tax_type === "taxable") {
                                                        setTaxFields(prev => ({
                                                            ...prev,
                                                            amount_without_tax: Math.max(0, expenseAmount - maxAdvance).toFixed(2)
                                                        }));
                                                    } else {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            amount: Math.max(0, expenseAmount - maxAdvance).toFixed(2)
                                                        }));
                                                    }
                                                } else {
                                                    // Restore the original amount
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        apply_advance: false,
                                                        advance_applied: 0
                                                    }));

                                                    // Don't restore amount here - let user enter it fresh
                                                }
                                            }}
                                            disabled={!isEditMode}
                                        />

                                        {formData.apply_advance && (
                                            <Form.Group className="mt-3">
                                                <Form.Label className="form-font">Advance Amount to Apply</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="advance_applied"
                                                    value={formData.advance_applied || 0}
                                                    onChange={(e) => {
                                                        const value = parseFloat(e.target.value) || 0;
                                                        const maxAllowed = Math.min(
                                                            formData.vendor_advance_balance,
                                                            formData.tax_type === "taxable"
                                                                ? parseFloat(taxFields.amount_without_tax || 0)
                                                                : parseFloat(formData.amount || 0)
                                                        );

                                                        const advanceToApply = Math.min(value, maxAllowed);

                                                        setFormData(prev => ({
                                                            ...prev,
                                                            advance_applied: advanceToApply
                                                        }));

                                                        // Update the amount field
                                                        if (formData.tax_type === "taxable") {
                                                            const currentAmount = parseFloat(taxFields.amount_without_tax || 0);
                                                            const newAmount = Math.max(0, currentAmount - advanceToApply);
                                                            setTaxFields(prev => ({
                                                                ...prev,
                                                                amount_without_tax: newAmount.toFixed(2)
                                                            }));
                                                        } else {
                                                            const currentAmount = parseFloat(formData.amount || 0);
                                                            const newAmount = Math.max(0, currentAmount - advanceToApply);
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                amount: newAmount.toFixed(2)
                                                            }));
                                                        }
                                                    }}
                                                    disabled={!isEditMode}
                                                    max={formData.vendor_advance_balance}
                                                    min="0"
                                                    step="0.01"
                                                />
                                                <small className="text-muted">
                                                    Max: {Math.min(formData.vendor_advance_balance,
                                                        formData.tax_type === "taxable"
                                                            ? parseFloat(taxFields.amount_without_tax || 0)
                                                            : parseFloat(formData.amount || 0)).toFixed(2)} {selectedCurrency}
                                                </small>
                                            </Form.Group>
                                        )}
                                    </div>
                                </div>
                            )} */}
                            {/* {formData.purchase_order_id && formData.vendor_advance_balance > 0 && (
                                <div className="card border mb-3">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0">
                                            <i className="mdi mdi-cash-check me-2"></i>
                                            Vendor Advance
                                        </h6>
                                    </div>
                                    <div className="card-body">
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <small className="text-muted">Available Advance:</small>
                                                <div className="fw-bold text-success">
                                                    {(() => {
                                                        const vendorCurrency = selectedVendor?.currency || "AED";
                            let advanceInSelectedCurrency = parseFloat(formData.vendor_advance_balance) || 0;

                                                        // If vendor currency is different from selected currency, convert
                                                         if (vendorCurrency !== selectedCurrency) {
                                advanceInSelectedCurrency = convertCurrency(
                                    parseFloat(formData.vendor_advance_balance) || 0,
                                    vendorCurrency,
                                    selectedCurrency
                                );
                            }
                                                        return `${advanceInSelectedCurrency.toFixed(2)} ${selectedCurrency}`;
                                                    })()}

                                                    <small className="text-muted d-block">
                                                        Original: {formData.vendor_advance_balance.toFixed(2)} {selectedVendor?.currency || "AED"}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>

                                        <Form.Check
                                            type="switch"
                                            id="apply-advance-switch"
                                            label="Apply vendor advance"
                                            checked={formData.apply_advance || false}
                                            // onChange={async (e) => {
                                            //     const checked = e.target.checked;
                                            //     const vendorCurrency = selectedVendor?.currency || "AED";

                                            //     if (checked) {
                                            //         // Calculate expense amount in selected currency
                                            //         const expenseAmount = formData.tax_type === "taxable"
                                            //             ? parseFloat(taxFields.amount_without_tax || 0)
                                            //             : parseFloat(formData.amount || 0);

                                            //         // Get advance balance in selected currency
                                            //         let advanceBalanceInSelectedCurrency = formData.vendor_advance_balance || 0;
                                            //         if (vendorCurrency !== selectedCurrency) {
                                            //             advanceBalanceInSelectedCurrency = convertCurrency(
                                            //                 formData.vendor_advance_balance || 0,
                                            //                 vendorCurrency,
                                            //                 selectedCurrency
                                            //             );
                                            //         }

                                            //         // Maximum advance to apply (min of advance balance or expense amount)
                                            //         const maxAdvance = Math.min(advanceBalanceInSelectedCurrency, expenseAmount);

                                            //         setFormData(prev => ({
                                            //             ...prev,
                                            //             apply_advance: true,
                                            //             advance_applied: maxAdvance,
                                            //             // Store original vendor currency advance for backend
                                            //             original_vendor_advance_currency: vendorCurrency,
                                            //             original_advance_amount: formData.vendor_advance_balance
                                            //         }));

                                            //         // Reduce the amount field by advance (in selected currency)
                                            //         if (formData.tax_type === "taxable") {
                                            //             setTaxFields(prev => ({
                                            //                 ...prev,
                                            //                 amount_without_tax: Math.max(0, expenseAmount - maxAdvance).toFixed(2)
                                            //             }));
                                            //         } else {
                                            //             setFormData(prev => ({
                                            //                 ...prev,
                                            //                 amount: Math.max(0, expenseAmount - maxAdvance).toFixed(2)
                                            //             }));
                                            //         }

                                            //         // Update tax calculation
                                            //         if (formData.tax_type === "taxable") {
                                            //             const base = Math.max(0, expenseAmount - maxAdvance);
                                            //             const tax = (base * (taxFields.tax || 5)) / 100;
                                            //             const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                                            //             const total = base + tax + adjustment;

                                            //             setTaxFields(prev => ({
                                            //                 ...prev,
                                            //                 total_amount: total.toFixed(2)
                                            //             }));
                                            //         }
                                            //     } else {
                                            //         // Restore the original amount
                                            //         setFormData(prev => ({
                                            //             ...prev,
                                            //             apply_advance: false,
                                            //             advance_applied: 0
                                            //         }));

                                            //         // Don't restore amount here - let user enter it fresh
                                            //     }
                                            // }}
                                            onChange={async (e) => {
                                                const checked = e.target.checked;
                                                const vendorCurrency = selectedVendor?.currency || "AED";

                                                if (checked) {
                                                    // Get the current base amount in selected currency
                                                    const expenseAmount = formData.tax_type === "taxable"
                                                        ? parseFloat(taxFields.amount_without_tax || 0)
                                                        : parseFloat(formData.amount || 0);

                                                    // Get advance balance - convert from vendor's currency to selected currency
                                                     let advanceBalanceInSelectedCurrency = parseFloat(formData.vendor_advance_balance) || 0;
                        if (vendorCurrency !== selectedCurrency) {
                            advanceBalanceInSelectedCurrency = convertCurrency(
                                parseFloat(formData.vendor_advance_balance) || 0,
                                vendorCurrency,
                                selectedCurrency
                            );
                        }

                                                    // Maximum advance to apply (min of advance balance or expense amount)
                                                    const maxAdvance = Math.min(advanceBalanceInSelectedCurrency, expenseAmount);

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        apply_advance: true,
                                                        advance_applied: maxAdvance,
                                                        original_vendor_advance_currency: vendorCurrency,
                                                        original_advance_amount: formData.vendor_advance_balance
                                                    }));

                                                    // Calculate net amount after advance
                                                    const netAmount = Math.max(0, expenseAmount - maxAdvance);

                                                    if (formData.tax_type === "taxable") {
                                                        setTaxFields(prev => ({
                                                            ...prev,
                                                            amount_without_tax: netAmount.toFixed(2)
                                                        }));

                                                        // Recalculate total
                                                        const taxRate = parseFloat(taxFields.tax) || 5;
                                                        const tax = (netAmount * taxRate) / 100;
                                                        const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                                                        const total = netAmount + tax + adjustment;

                                                        setTaxFields(prev => ({
                                                            ...prev,
                                                            total_amount: total.toFixed(2)
                                                        }));
                                                    } else {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            amount: netAmount.toFixed(2)
                                                        }));
                                                    }
                                                } else {
                                                    // When turning off advance, restore the original amount
                                                    const originalAmount = formData.tax_type === "taxable"
                                                        ? parseFloat(taxFields.amount_without_tax || 0) + parseFloat(formData.advance_applied || 0)
                                                        : parseFloat(formData.amount || 0) + parseFloat(formData.advance_applied || 0);

                                                    if (formData.tax_type === "taxable") {
                                                        setTaxFields(prev => ({
                                                            ...prev,
                                                            amount_without_tax: originalAmount.toFixed(2)
                                                        }));

                                                        // Recalculate total
                                                        const taxRate = parseFloat(taxFields.tax) || 5;
                                                        const tax = (originalAmount * taxRate) / 100;
                                                        const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                                                        const total = originalAmount + tax + adjustment;

                                                        setTaxFields(prev => ({
                                                            ...prev,
                                                            total_amount: total.toFixed(2)
                                                        }));
                                                    } else {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            amount: originalAmount.toFixed(2)
                                                        }));
                                                    }

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        apply_advance: false,
                                                        advance_applied: 0
                                                    }));
                                                }
                                            }}
                                            disabled={!isEditMode}
                                        />

                                        {formData.apply_advance && (
                                            <Form.Group className="mt-3">
                                                <Form.Label className="form-font">
                                                    Advance Amount to Apply ({selectedCurrency})
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="advance_applied"
                                                    value={formData.advance_applied || 0}
                                                    onChange={(e) => {
                                                        const newAdvance = parseFloat(e.target.value) || 0;
                                                        const vendorCurrency = selectedVendor?.currency || "AED";

                                                        // Get the ORIGINAL base amount (before any advance was applied)
                                                        // We need to calculate what the original base amount was
                                                        const originalBase = formData.tax_type === "taxable"
                                                            ? parseFloat(taxFields.amount_without_tax || 0) + parseFloat(formData.advance_applied || 0)
                                                            : parseFloat(formData.amount || 0) + parseFloat(formData.advance_applied || 0);

                                                        // Get advance balance in selected currency
                                                         let advanceBalanceInSelectedCurrency = parseFloat(formData.vendor_advance_balance) || 0;
                            if (vendorCurrency !== selectedCurrency) {
                                advanceBalanceInSelectedCurrency = convertCurrency(
                                    parseFloat(formData.vendor_advance_balance) || 0,
                                    vendorCurrency,
                                    selectedCurrency
                                );
                            }

                                                        // Calculate max allowed advance
                                                        const maxAllowed = Math.min(advanceBalanceInSelectedCurrency, originalBase);
                                                        const advanceToApply = Math.min(newAdvance, maxAllowed);

                                                        // Calculate new net amount (original base minus new advance)
                                                        const netAmount = Math.max(0, originalBase - advanceToApply);

                                                        // Update formData with new advance
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            advance_applied: advanceToApply
                                                        }));

                                                        // Update the amount field (in selected currency)
                                                        if (formData.tax_type === "taxable") {
                                                            setTaxFields(prev => ({
                                                                ...prev,
                                                                amount_without_tax: netAmount.toFixed(2)
                                                            }));

                                                            // Update tax calculation
                                                            const taxRate = parseFloat(taxFields.tax) || 5;
                                                            const tax = (netAmount * taxRate) / 100;
                                                            const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                                                            const total = netAmount + tax + adjustment;

                                                            setTaxFields(prev => ({
                                                                ...prev,
                                                                total_amount: total.toFixed(2)
                                                            }));
                                                        } else {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                amount: netAmount.toFixed(2)
                                                            }));
                                                        }
                                                    }}
                                                    disabled={!isEditMode}
                                                    max={(() => {
                                                        const vendorCurrency = selectedVendor?.currency || "AED";
                            let advanceBalanceInSelectedCurrency = parseFloat(formData.vendor_advance_balance) || 0;

                            if (vendorCurrency !== selectedCurrency) {
                                advanceBalanceInSelectedCurrency = convertCurrency(
                                    parseFloat(formData.vendor_advance_balance) || 0,
                                    vendorCurrency,
                                    selectedCurrency
                                );
                            }

                            // Calculate original base amount
                            const originalBase = formData.tax_type === "taxable"
                                ? (parseFloat(taxFields.amount_without_tax || 0) + parseFloat(formData.advance_applied || 0))
                                : (parseFloat(formData.amount || 0) + parseFloat(formData.advance_applied || 0));

                            return Math.min(advanceBalanceInSelectedCurrency, originalBase);
                        })()}
                        min="0"
                        step="0.01"
                                                />
                                                <small className="text-muted">
                                                    Max: {(() => {
                                                        const vendorCurrency = selectedVendor?.currency || "AED";
                            let advanceBalanceInSelectedCurrency = parseFloat(formData.vendor_advance_balance) || 0;

                            if (vendorCurrency !== selectedCurrency) {
                                advanceBalanceInSelectedCurrency = convertCurrency(
                                    parseFloat(formData.vendor_advance_balance) || 0,
                                    vendorCurrency,
                                    selectedCurrency
                                );
                            }

                            const expenseAmount = formData.tax_type === "taxable"
                                ? parseFloat(taxFields.amount_without_tax || 0)
                                : parseFloat(formData.amount || 0);

                            return Math.min(advanceBalanceInSelectedCurrency, expenseAmount).toFixed(2);
                        })()} {selectedCurrency}

                                                    {selectedCurrency !== selectedVendor?.currency && (
                            <span className="ms-2">
                                ({parseFloat(formData.vendor_advance_balance || 0).toFixed(2)} {selectedVendor?.currency || "AED"})
                            </span>
                        )}
                                                </small>
                                            </Form.Group>
                                        )}
                                    </div>
                                </div>
                            )} */}



                            {formData.type !== 'salary' && (
                                <>
                                    {/* TAXABLE FIELDS FOR NON-SALARY EXPENSES */}
                                    {(() => {
                                        console.log("DEBUG: Render Parent Checks", {
                                            type: formData.type,
                                            tax_type: formData.tax_type,
                                            isCheckPassed: formData.tax_type === "taxable"
                                        });
                                        return null;
                                    })()}
                                    {formData.tax_type === "taxable" ? (
                                        <>
                                            {/* <Form.Group className="mb-3">
                                                <Form.Label className="form-font">Invoice Date</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="invoice_date"
                                                    value={taxFields.invoice_date}
                                                    onChange={handleTaxFieldChange}
                                                    className="form-feild"
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Group> */}
                                            <Form.Group className="mb-3">
                                                <Form.Label className="form-font">Invoice Date</Form.Label>

                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        views={["year", "month", "day"]}
                                                        format="DD-MM-YYYY"
                                                        density="compact"
                                                        className="form-feild form-control"
                                                        value={
                                                            taxFields.invoice_date && dayjs(taxFields.invoice_date).isValid()
                                                                ? dayjs(taxFields.invoice_date)
                                                                : null
                                                        }
                                                        onChange={(newValue) => {
                                                            setTaxFields((prev) => ({
                                                                ...prev,
                                                                invoice_date: newValue
                                                                    ? newValue.format("YYYY-MM-DD")
                                                                    : "",
                                                            }));
                                                        }}
                                                        disabled={!isEditMode}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                                className: "form-feild",
                                                            },
                                                            popper: {
                                                                disablePortal: true, // ✅ Fix for Offcanvas / Modal
                                                                sx: {
                                                                    zIndex: 2000,
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label className="form-font">Bill No.</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="invoice_no"
                                                    value={taxFields.invoice_no}
                                                    onChange={handleTaxFieldChange}
                                                    className={`form-feild  ${errors?.invoice_no ? 'is-invalid' : ''}`}
                                                    disabled={!isEditMode}
                                                    placeholder="Enter bill number"
                                                />
                                                {errors.invoice_no && <div className="invalid-feedback font-size-12">*{errors.invoice_no}</div>}
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="form-font">
                                                    Amount (Excl. VAT) ({selectedCurrency})
                                                </Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        type="number"
                                                        name="amount_without_tax"
                                                        value={taxFields.amount_without_tax}
                                                        onChange={handleTaxFieldChange}
                                                        className={`form-feild ${errors?.amount_without_tax ? 'is-invalid' : ''}`}
                                                        disabled={!isEditMode}
                                                    />
                                                    {isEditMode && (formData.vendor_id || formData.type === "internal") && (
                                                        <div className="position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                                            <div className="dropdown">
                                                                <button
                                                                    className="btn btn-sm btn-outline-secondary dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => setShowCurrencyDropdown(!showCurrencyDropdown)}
                                                                    style={{ padding: '2px 8px', fontSize: '12px' }}
                                                                >
                                                                    {selectedCurrency}
                                                                </button>
                                                                {showCurrencyDropdown && (
                                                                    <div className="dropdown-menu show" style={{ minWidth: '80px' }}>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            type="button"
                                                                            onClick={() => handleCurrencyChange("AED")}
                                                                        >
                                                                            AED
                                                                        </button>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            type="button"
                                                                            onClick={() => handleCurrencyChange("USD")}
                                                                        >
                                                                            USD
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                {errors.amount_without_tax && <div className="invalid-feedback d-block font-size-12">*{errors.amount_without_tax}</div>}

                                                {parseFloat(taxFields.amount_without_tax || 0) > 0 && (
                                                    <div className="mt-1">
                                                        <small className="text-muted">
                                                            VAT: {(() => {
                                                                const calcVat = (parseFloat(taxFields.amount_without_tax || 0) * (parseFloat(taxFields.tax) || 5) / 100).toFixed(2);
                                                                return (taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined)
                                                                    ? `${taxFields.vat_amount} ${selectedCurrency}${parseFloat(taxFields.vat_amount) !== parseFloat(calcVat) ? ' (manual)' : ''}`
                                                                    : `${calcVat} ${selectedCurrency} (${parseFloat(taxFields.tax) || 5}%)`;
                                                            })()}
                                                            {parseFloat(taxFields.adjustment_amount || 0) > 0 && (
                                                                <span> + Adjustment: {parseFloat(taxFields.adjustment_amount || 0).toFixed(2)} {selectedCurrency}</span>
                                                            )}
                                                        </small>
                                                    </div>
                                                )}
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="form-font">
                                                    VAT Amount

                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="vat_amount"
                                                    value={taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined
                                                        ? taxFields.vat_amount
                                                        : ((parseFloat(taxFields.amount_without_tax || 0) * (parseFloat(taxFields.tax) || 5)) / 100).toFixed(2)
                                                    }
                                                    onChange={handleTaxFieldChange}
                                                    className="form-feild"
                                                    disabled={!isEditMode}
                                                    placeholder="VAT amount"
                                                />
                                                <small className="text-muted">
                                                    Auto: {((parseFloat(taxFields.amount_without_tax || 0) * (parseFloat(taxFields.tax) || 5)) / 100).toFixed(2)} ({parseFloat(taxFields.tax) || 5}% of {parseFloat(taxFields.amount_without_tax || 0).toFixed(2)})
                                                </small>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="form-font">Adjustment Amount</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="adjustment_amount"
                                                    value={taxFields.adjustment_amount}
                                                    onChange={handleTaxFieldChange}
                                                    className="form-feild"
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Group>

                                            {/* VENDOR ADVANCE SECTION FOR NON-SALARY TAXABLE */}
                                            {(() => {
                                                const vendorAdvanceBalance = parseFloat(formData.vendor_advance_balance);
                                                const isValidAdvance = !isNaN(vendorAdvanceBalance) && vendorAdvanceBalance > 0;
                                                console.log("DEBUG: Render Vendor Advance Card", {
                                                    vendorAdvanceBalance,
                                                    isValidAdvance,
                                                    poId: formData.purchase_order_id,
                                                    formDataValues: formData
                                                });

                                                if (!isValidAdvance) return null;

                                                return (
                                                    <div className="card border mb-3">
                                                        <div className="card-header bg-light">
                                                            <h6 className="mb-0">
                                                                <i className="mdi mdi-cash-check me-2"></i>
                                                                Vendor Advance
                                                            </h6>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row mb-3">
                                                                <div className="col-md-6">
                                                                    <small className="text-muted">Available Advance:</small>
                                                                    <div className="fw-bold text-success">
                                                                        {(() => {
                                                                            const vendorCurrency = selectedVendor?.currency || "AED";
                                                                            let advanceInSelectedCurrency = vendorAdvanceBalance;

                                                                            if (vendorCurrency && selectedCurrency && vendorCurrency !== selectedCurrency) {
                                                                                const converted = convertCurrency(
                                                                                    vendorAdvanceBalance,
                                                                                    vendorCurrency,
                                                                                    selectedCurrency
                                                                                );
                                                                                advanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                            }

                                                                            const numericAdvance = parseFloat(advanceInSelectedCurrency);
                                                                            const formattedAdvance = !isNaN(numericAdvance) ? numericAdvance.toFixed(2) : "0.00";

                                                                            return `${formattedAdvance} ${selectedCurrency}`;
                                                                        })()}

                                                                        <small className="text-muted d-block">
                                                                            Original: {vendorAdvanceBalance.toFixed(2)} {selectedVendor?.currency || "AED"}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <Form.Check
                                                                type="switch"
                                                                id="apply-advance-switch"
                                                                label="Apply vendor advance"
                                                                checked={formData.apply_advance || false}
                                                                onChange={async (e) => {
                                                                    const checked = e.target.checked;
                                                                    const vendorCurrency = selectedVendor?.currency || "AED";

                                                                    if (checked) {
                                                                        const expenseAmount = parseFloat(taxFields.amount_without_tax || 0);

                                                                        let advanceBalanceInSelectedCurrency = vendorAdvanceBalance;
                                                                        if (vendorCurrency !== selectedCurrency) {
                                                                            const converted = convertCurrency(
                                                                                vendorAdvanceBalance,
                                                                                vendorCurrency,
                                                                                selectedCurrency
                                                                            );
                                                                            advanceBalanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                        }

                                                                        const maxAdvance = Math.min(advanceBalanceInSelectedCurrency, expenseAmount);

                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            apply_advance: true,
                                                                            advance_applied: maxAdvance,
                                                                            original_vendor_advance_currency: vendorCurrency,
                                                                            original_advance_amount: vendorAdvanceBalance
                                                                        }));

                                                                        // Recalculate total_amount with advance deduction
                                                                        const originalBase = parseFloat(taxFields.amount_without_tax || 0);
                                                                        const taxRate = parseFloat(taxFields.tax) || 5;
                                                                        const calculatedVat = (originalBase * taxRate) / 100;
                                                                        const effectiveVat = (taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined)
                                                                            ? parseFloat(taxFields.vat_amount) || 0
                                                                            : calculatedVat;
                                                                        const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                                                                        const totalBeforeAdvance = originalBase + effectiveVat + adjustment;
                                                                        const totalAfterAdvance = Math.max(0, totalBeforeAdvance - maxAdvance);

                                                                        setTaxFields(prev => ({
                                                                            ...prev,
                                                                            total_amount: totalAfterAdvance.toFixed(2)
                                                                        }));
                                                                    } else {
                                                                        // When turning OFF advance
                                                                        const originalBase = parseFloat(taxFields.amount_without_tax || 0);
                                                                        const taxRate = parseFloat(taxFields.tax) || 5;
                                                                        const calculatedVat = (originalBase * taxRate) / 100;
                                                                        const effectiveVat = (taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined)
                                                                            ? parseFloat(taxFields.vat_amount) || 0
                                                                            : calculatedVat;
                                                                        const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                                                                        const total = originalBase + effectiveVat + adjustment;

                                                                        setTaxFields(prev => ({
                                                                            ...prev,
                                                                            total_amount: total.toFixed(2)
                                                                        }));

                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            apply_advance: false,
                                                                            advance_applied: 0
                                                                        }));
                                                                    }
                                                                }}
                                                                disabled={!isEditMode}
                                                            />

                                                            {formData.apply_advance && (
                                                                <Form.Group className="mt-3">
                                                                    <Form.Label className="form-font">
                                                                        Advance Amount to Apply ({selectedCurrency})
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        name="advance_applied"
                                                                        value={parseFloat(formData.advance_applied || 0)}
                                                                        onChange={(e) => {
                                                                            const newAdvance = parseFloat(e.target.value) || 0;
                                                                            const vendorCurrency = selectedVendor?.currency || "AED";

                                                                            const originalBase = parseFloat(taxFields.amount_without_tax || 0);

                                                                            let advanceBalanceInSelectedCurrency = vendorAdvanceBalance;
                                                                            if (vendorCurrency !== selectedCurrency) {
                                                                                const converted = convertCurrency(
                                                                                    vendorAdvanceBalance,
                                                                                    vendorCurrency,
                                                                                    selectedCurrency
                                                                                );
                                                                                advanceBalanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                            }

                                                                            const maxAllowed = Math.min(advanceBalanceInSelectedCurrency, originalBase);
                                                                            const advanceToApply = Math.min(newAdvance, maxAllowed);

                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                advance_applied: advanceToApply
                                                                            }));

                                                                            const taxRate = parseFloat(taxFields.tax) || 5;
                                                                            const calculatedVat = (originalBase * taxRate) / 100;
                                                                            const effectiveVat = (taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined)
                                                                                ? parseFloat(taxFields.vat_amount) || 0
                                                                                : calculatedVat;
                                                                            const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                                                                            const totalBeforeAdvance = originalBase + effectiveVat + adjustment;
                                                                            const totalAfterAdvance = Math.max(0, totalBeforeAdvance - advanceToApply);

                                                                            setTaxFields(prev => ({
                                                                                ...prev,
                                                                                total_amount: totalAfterAdvance.toFixed(2)
                                                                            }));
                                                                        }}
                                                                        disabled={!isEditMode}
                                                                        max={(() => {
                                                                            const vendorCurrency = selectedVendor?.currency || "AED";
                                                                            let advanceBalanceInSelectedCurrency = vendorAdvanceBalance;

                                                                            if (vendorCurrency !== selectedCurrency) {
                                                                                const converted = convertCurrency(
                                                                                    vendorAdvanceBalance,
                                                                                    vendorCurrency,
                                                                                    selectedCurrency
                                                                                );
                                                                                advanceBalanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                            }

                                                                            const originalBase = parseFloat(taxFields.amount_without_tax || 0);
                                                                            return Math.min(advanceBalanceInSelectedCurrency, originalBase);
                                                                        })()}
                                                                        min="0"
                                                                        step="0.01"
                                                                    />
                                                                    <small className="text-muted">
                                                                        Max: {(() => {
                                                                            const vendorCurrency = selectedVendor?.currency || "AED";
                                                                            let advanceBalanceInSelectedCurrency = vendorAdvanceBalance;

                                                                            if (vendorCurrency !== selectedCurrency) {
                                                                                const converted = convertCurrency(
                                                                                    vendorAdvanceBalance,
                                                                                    vendorCurrency,
                                                                                    selectedCurrency
                                                                                );
                                                                                advanceBalanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                            }

                                                                            const expenseAmount = parseFloat(taxFields.amount_without_tax || 0);
                                                                            const maxAmount = Math.min(advanceBalanceInSelectedCurrency, expenseAmount);
                                                                            return !isNaN(maxAmount) ? maxAmount.toFixed(2) : "0.00";
                                                                        })()} {selectedCurrency}

                                                                        {selectedCurrency !== selectedVendor?.currency && (
                                                                            <span className="ms-2">
                                                                                ({vendorAdvanceBalance.toFixed(2)} {selectedVendor?.currency || "AED"})
                                                                            </span>
                                                                        )}
                                                                    </small>
                                                                </Form.Group>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })()}

                                            <Form.Group className="mb-3">
                                                <Form.Label className="form-font">
                                                    Total Payable ({selectedCurrency})
                                                    {formData.apply_advance && formData.advance_applied > 0 && (
                                                        <span className="text-success ms-2">
                                                            After Advance
                                                        </span>
                                                    )}
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="total_amount"
                                                    value={(() => {
                                                        const originalBase = parseFloat(taxFields.amount_without_tax || 0);
                                                        const calculatedVat = (originalBase * (parseFloat(taxFields.tax) || 5)) / 100;
                                                        const effectiveVat = (taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined)
                                                            ? parseFloat(taxFields.vat_amount) || 0
                                                            : calculatedVat;
                                                        const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                                                        const totalBeforeAdvance = originalBase + effectiveVat + adjustment;

                                                        const advanceApplied = parseFloat(formData.advance_applied || 0);
                                                        const finalPayable = totalBeforeAdvance - advanceApplied;

                                                        return Math.max(0, finalPayable).toFixed(2);
                                                    })()}
                                                    readOnly
                                                    className="form-feild"
                                                    disabled={!isEditMode}
                                                />

                                                {parseFloat(taxFields.amount_without_tax || 0) > 0 && (
                                                    <div className="mt-1">
                                                        <small className="text-muted">
                                                            Breakdown: {parseFloat(taxFields.amount_without_tax || 0).toFixed(2)} (Base)
                                                            + {(() => {
                                                                const calcVat = (parseFloat(taxFields.amount_without_tax || 0) * (parseFloat(taxFields.tax) || 5) / 100).toFixed(2);
                                                                const effVat = (taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined)
                                                                    ? parseFloat(taxFields.vat_amount).toFixed(2)
                                                                    : calcVat;
                                                                return effVat;
                                                            })()} (VAT{taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined && parseFloat(taxFields.vat_amount) !== parseFloat(((parseFloat(taxFields.amount_without_tax || 0) * (parseFloat(taxFields.tax) || 5)) / 100).toFixed(2)) ? ' - manual' : ''})
                                                            {parseFloat(taxFields.adjustment_amount || 0) > 0 ? ` + ${parseFloat(taxFields.adjustment_amount || 0).toFixed(2)} (Adjustment)` : ''}
                                                            {formData.apply_advance && parseFloat(formData.advance_applied || 0) > 0 ? ` - ${parseFloat(formData.advance_applied || 0).toFixed(2)} (Advance)` : ''}
                                                            = {(() => {
                                                                const originalBase = parseFloat(taxFields.amount_without_tax || 0);
                                                                const calcVat2 = (originalBase * (parseFloat(taxFields.tax) || 5)) / 100;
                                                                const effVat2 = (taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined)
                                                                    ? parseFloat(taxFields.vat_amount) || 0
                                                                    : calcVat2;
                                                                const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                                                                const advance = parseFloat(formData.advance_applied || 0);
                                                                return Math.max(0, originalBase + effVat2 + adjustment - advance).toFixed(2);
                                                            })()}
                                                        </small>
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </>
                                    ) : formData.tax_type === "non-taxable" ? (
                                        // NON-TAXABLE FIELDS FOR NON-SALARY EXPENSES
                                        <>
                                            <Form.Group className="mb-3">
                                                <Form.Label className="form-font">Invoice Date</Form.Label>
                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                    <DatePicker
                                                        views={["year", "month", "day"]}
                                                        format="DD-MM-YYYY"
                                                        density="compact"
                                                        className="form-feild form-control"
                                                        value={
                                                            taxFields.invoice_date && dayjs(taxFields.invoice_date).isValid()
                                                                ? dayjs(taxFields.invoice_date)
                                                                : null
                                                        }
                                                        onChange={(newValue) => {
                                                            const formatted = newValue ? newValue.format("YYYY-MM-DD") : "";
                                                            setTaxFields((prev) => ({
                                                                ...prev,
                                                                invoice_date: formatted,
                                                            }));
                                                            setFormData(p => ({
                                                                ...p,
                                                                invoice_date: formatted
                                                            }));
                                                        }}
                                                        disabled={!isEditMode}
                                                        slotProps={{
                                                            textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                                className: "form-feild",
                                                            },
                                                            popper: {
                                                                disablePortal: true,
                                                                sx: {
                                                                    zIndex: 2000,
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label className="form-font">Bill No.</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="invoice_no"
                                                    value={taxFields.invoice_no}
                                                    onChange={handleTaxFieldChange}
                                                    className={`form-feild  ${errors?.invoice_no ? 'is-invalid' : ''}`}
                                                    disabled={!isEditMode}
                                                    placeholder="Enter bill number"
                                                />
                                                {errors.invoice_no && <div className="invalid-feedback font-size-12">*{errors.invoice_no}</div>}
                                            </Form.Group>

                                            {/* VENDOR ADVANCE SECTION FOR NON-SALARY NON-TAXABLE */}
                                            {(() => {
                                                const vendorAdvanceBalance = parseFloat(formData.vendor_advance_balance);
                                                const isValidAdvance = !isNaN(vendorAdvanceBalance) && vendorAdvanceBalance > 0;
                                                console.log("DEBUG: Render Non-Taxable Vendor Advance", {
                                                    vendorAdvanceBalance,
                                                    isValidAdvance,
                                                    poId: formData.purchase_order_id,
                                                    formDataValues: formData
                                                });

                                                if (!isValidAdvance) return null;

                                                return (
                                                    <div className="card border mb-3">
                                                        <div className="card-header bg-light">
                                                            <h6 className="mb-0">
                                                                <i className="mdi mdi-cash-check me-2"></i>
                                                                Vendor Advance
                                                            </h6>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row mb-3">
                                                                <div className="col-md-6">
                                                                    <small className="text-muted">Available Advance:</small>
                                                                    <div className="fw-bold text-success">
                                                                        {(() => {
                                                                            const vendorCurrency = selectedVendor?.currency || "AED";
                                                                            let advanceInSelectedCurrency = vendorAdvanceBalance;

                                                                            if (vendorCurrency && selectedCurrency && vendorCurrency !== selectedCurrency) {
                                                                                const converted = convertCurrency(
                                                                                    vendorAdvanceBalance,
                                                                                    vendorCurrency,
                                                                                    selectedCurrency
                                                                                );
                                                                                advanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                            }

                                                                            const numericAdvance = parseFloat(advanceInSelectedCurrency);
                                                                            const formattedAdvance = !isNaN(numericAdvance) ? numericAdvance.toFixed(2) : "0.00";

                                                                            return `${formattedAdvance} ${selectedCurrency}`;
                                                                        })()}

                                                                        <small className="text-muted d-block">
                                                                            Original: {vendorAdvanceBalance.toFixed(2)} {selectedVendor?.currency || "AED"}
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <Form.Check
                                                                type="switch"
                                                                id="apply-advance-switch-nontaxable"
                                                                label="Apply vendor advance"
                                                                checked={formData.apply_advance || false}
                                                                onChange={async (e) => {
                                                                    const checked = e.target.checked;
                                                                    const vendorCurrency = selectedVendor?.currency || "AED";

                                                                    if (checked) {
                                                                        const expenseAmount = parseFloat(formData.amount || 0);

                                                                        let advanceBalanceInSelectedCurrency = vendorAdvanceBalance;
                                                                        if (vendorCurrency !== selectedCurrency) {
                                                                            const converted = convertCurrency(
                                                                                vendorAdvanceBalance,
                                                                                vendorCurrency,
                                                                                selectedCurrency
                                                                            );
                                                                            advanceBalanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                        }

                                                                        const maxAdvance = Math.min(advanceBalanceInSelectedCurrency, expenseAmount);

                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            apply_advance: true,
                                                                            advance_applied: maxAdvance,
                                                                            original_vendor_advance_currency: vendorCurrency,
                                                                            original_advance_amount: vendorAdvanceBalance
                                                                        }));

                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            amount: Math.max(0, expenseAmount - maxAdvance).toFixed(2)
                                                                        }));
                                                                    } else {
                                                                        const originalAmount = parseFloat(formData.amount || 0) + parseFloat(formData.advance_applied || 0);
                                                                        setFormData(prev => ({
                                                                            ...prev,
                                                                            amount: originalAmount.toFixed(2),
                                                                            apply_advance: false,
                                                                            advance_applied: 0
                                                                        }));
                                                                    }
                                                                }}
                                                                disabled={!isEditMode}
                                                            />

                                                            {formData.apply_advance && (
                                                                <Form.Group className="mt-3">
                                                                    <Form.Label className="form-font">
                                                                        Advance Amount to Apply ({selectedCurrency})
                                                                    </Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        name="advance_applied"
                                                                        value={parseFloat(formData.advance_applied || 0)}
                                                                        onChange={(e) => {
                                                                            const newAdvance = parseFloat(e.target.value) || 0;
                                                                            const vendorCurrency = selectedVendor?.currency || "AED";

                                                                            const originalBase = parseFloat(formData.amount || 0) + parseFloat(formData.advance_applied || 0);

                                                                            let advanceBalanceInSelectedCurrency = vendorAdvanceBalance;
                                                                            if (vendorCurrency !== selectedCurrency) {
                                                                                const converted = convertCurrency(
                                                                                    vendorAdvanceBalance,
                                                                                    vendorCurrency,
                                                                                    selectedCurrency
                                                                                );
                                                                                advanceBalanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                            }

                                                                            const maxAllowed = Math.min(advanceBalanceInSelectedCurrency, originalBase);
                                                                            const advanceToApply = Math.min(newAdvance, maxAllowed);

                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                advance_applied: advanceToApply
                                                                            }));

                                                                            const netAmount = Math.max(0, originalBase - advanceToApply);
                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                amount: netAmount.toFixed(2)
                                                                            }));
                                                                        }}
                                                                        disabled={!isEditMode}
                                                                        max={(() => {
                                                                            const vendorCurrency = selectedVendor?.currency || "AED";
                                                                            let advanceBalanceInSelectedCurrency = vendorAdvanceBalance;

                                                                            if (vendorCurrency !== selectedCurrency) {
                                                                                const converted = convertCurrency(
                                                                                    vendorAdvanceBalance,
                                                                                    vendorCurrency,
                                                                                    selectedCurrency
                                                                                );
                                                                                advanceBalanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                            }

                                                                            const originalBase = parseFloat(formData.amount || 0) + parseFloat(formData.advance_applied || 0);
                                                                            return Math.min(advanceBalanceInSelectedCurrency, originalBase);
                                                                        })()}
                                                                        min="0"
                                                                        step="0.01"
                                                                    />
                                                                    <small className="text-muted">
                                                                        Max: {(() => {
                                                                            const vendorCurrency = selectedVendor?.currency || "AED";
                                                                            let advanceBalanceInSelectedCurrency = vendorAdvanceBalance;

                                                                            if (vendorCurrency !== selectedCurrency) {
                                                                                const converted = convertCurrency(
                                                                                    vendorAdvanceBalance,
                                                                                    vendorCurrency,
                                                                                    selectedCurrency
                                                                                );
                                                                                advanceBalanceInSelectedCurrency = parseFloat(converted) || vendorAdvanceBalance;
                                                                            }

                                                                            const expenseAmount = parseFloat(formData.amount || 0) + parseFloat(formData.advance_applied || 0);
                                                                            const maxAmount = Math.min(advanceBalanceInSelectedCurrency, expenseAmount);
                                                                            return !isNaN(maxAmount) ? maxAmount.toFixed(2) : "0.00";
                                                                        })()} {selectedCurrency}

                                                                        {selectedCurrency !== selectedVendor?.currency && (
                                                                            <span className="ms-2">
                                                                                ({vendorAdvanceBalance.toFixed(2)} {selectedVendor?.currency || "AED"})
                                                                            </span>
                                                                        )}
                                                                    </small>
                                                                </Form.Group>
                                                            )}
                                                        </div>
                                                    </div>
                                                );
                                            })()}

                                            <Form.Group controlId="amount" className="mb-3">
                                                <Form.Label className='form-font'>
                                                    Amount ({selectedCurrency})
                                                    {formData.apply_advance && parseFloat(formData.advance_applied || 0) > 0 && (
                                                        <span className="text-danger ms-2">
                                                            - {(parseFloat(formData.advance_applied) || 0).toFixed(2)} Advance
                                                        </span>
                                                    )}
                                                </Form.Label>
                                                <div className="position-relative">
                                                    <Form.Control
                                                        className={`form-feild ${errors?.amount ? 'is-invalid' : ''}`}
                                                        type="number"
                                                        name="amount"
                                                        value={formData.amount}
                                                        onChange={handleChange}
                                                        disabled={!isEditMode}
                                                    />
                                                    {isEditMode && (formData.vendor_id || formData.type === "internal") && (
                                                        <div className="position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                                            <div className="dropdown">
                                                                <button
                                                                    className="btn btn-sm btn-outline-secondary dropdown-toggle"
                                                                    type="button"
                                                                    onClick={() => setShowCurrencyDropdown(!showCurrencyDropdown)}
                                                                    style={{ padding: '2px 8px', fontSize: '12px' }}
                                                                >
                                                                    {selectedCurrency}
                                                                </button>
                                                                {showCurrencyDropdown && (
                                                                    <div className="dropdown-menu show" style={{ minWidth: '80px' }}>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            type="button"
                                                                            onClick={() => handleCurrencyChange("AED")}
                                                                        >
                                                                            AED
                                                                        </button>
                                                                        <button
                                                                            className="dropdown-item"
                                                                            type="button"
                                                                            onClick={() => handleCurrencyChange("USD")}
                                                                        >
                                                                            USD
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                {errors.amount && <div className="invalid-feedback d-block font-size-12">*{errors.amount}</div>}
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <Form.Label className="form-font">Adjustment Amount</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="adjustment_amount"
                                                    value={taxFields.adjustment_amount}
                                                    onChange={handleTaxFieldChange}
                                                    className="form-feild"
                                                    disabled={!isEditMode}
                                                />
                                            </Form.Group>
                                        </>
                                    ) : null}
                                </>
                            )}

                        </>

                        {formData.type !== 'salary' && (
                            <Form.Group className="mb-3">
                                <Form.Label className='form-font'>Narration</Form.Label>
                                <Form.Control
                                    className='form-control form-feild'
                                    type="text"
                                    name="narration"
                                    value={formData.narration}
                                    onChange={handleChange}
                                    disabled={!isEditMode}
                                    placeholder="Enter description"
                                />
                            </Form.Group>
                        )}


                    </>
                );


            default:
                return null;
        }
    };
    const fetchClients = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=client&issales=false`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            const sortedData = (response.data.Data || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setClients(sortedData);
        } catch (error) {
            console.error('Error fetching clients:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to fetch clients. Please try again.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
            });
        }
    };

    const fetchVendors = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/contacts?type=vendor`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });
            const sortedData = (response.data.Data || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setVendors(sortedData);
        } catch (error) {
            console.error('Error fetching vendor:', error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to fetch vendors. Please try again.',
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
            });
        }
    };


    const fetchProjects = async (clientId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem("user-origin");
            const token = userInfo?.token;

            // ALWAYS fetch projects only for the specific client_id
            if (clientId) {
                const response = await axios.get(`${backendUrl}/api/projects?all=true&client_id=${clientId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    skipLoader: true,
                });

                // Set all projects for this client (no is_client_based filter)
                const sortedData = (response.data.Data || []).sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                setProjects(sortedData);
            } else {
                setProjects([]);
            }
        } catch (error) {
            console.error("Error fetching projects:", error);
            setProjects([]);
        }
    };

    const [isClientBasedProject, setIsClientBasedProject] = useState(false);


    useEffect(() => {
        if (showModal && isExpensePage) {
            fetchClients();
            if (formData.type === "external") {
                fetchProjects();
            }
        }
    }, [showModal, isExpensePage, formData.type]);

    useEffect(() => {
        if (showModal) {
            fetchVendors();
            fetchWebzashBulkData();
        }
    }, [showModal]);
    useEffect(() => {
        // Only create hierarchical structure when ALL data is available
        if (allLedgers.length > 0 && accountGroups.length > 0 && expenseTypes.length > 0) {
            console.log('Creating hierarchical structure with:', {
                ledgers: allLedgers.length,
                groups: accountGroups.length,
                expenseTypes: expenseTypes.length
            });

            const hierarchical = createHierarchicalExpenseTypeStructure(allLedgers, accountGroups, expenseTypes);
            console.log('Hierarchical structure created:', hierarchical);
            setFilteredLedgers(hierarchical);
        }
    }, [allLedgers, accountGroups, expenseTypes]);

    useEffect(() => {
        if (allLedgers.length > 0 && accountGroups.length > 0 && expenseTypes.length > 0) {
            const hierarchical = createHierarchicalExpenseTypeStructure(allLedgers, accountGroups, expenseTypes);
            const filtered = filterHierarchicalExpenseTypes(hierarchical, ledgerSearch);
            setFilteredLedgers(filtered);
        }
    }, [ledgerSearch, allLedgers, accountGroups, expenseTypes]);


    // --- State ---


    // --- Fetch Webzash Data (Bulk) ---
    const fetchWebzashBulkData = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const resp = await axios.get(`${backendUrl}/api/webzash/bulk_all`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    Accept: 'application/json'
                },
                skipLoader: true,
            });

            if (resp.data && resp.data.status === 'success') {
                const fetchedGroups = resp.data.groups?.data || resp.data.groups || [];
                const sortedGroups = fetchedGroups.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                setAccountGroups(sortedGroups);

                const fetchedLedgers = resp.data.ledgers?.data || resp.data.ledgers || [];
                const sortedLedgers = fetchedLedgers.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
                setAllLedgers(sortedLedgers);
                
                console.log('Fetched Webzash bulk data:', { groups: sortedGroups.length, ledgers: sortedLedgers.length });
            }
        } catch (err) {
            console.error('Failed to fetch Webzash bulk data', err);
        }
    };


    // --- Expense Type select handler ---
    const handleExpenseTypeChange = (expenseTypeId) => {
        const selected = expenseTypes.find(et => et.id === expenseTypeId) || null;
        setSelectedExpenseType(selected);

        const type = decidePaymentType(selected);
        setPaymentType(type);
    };


    // --- Ledger Matching ---
    const getMatchingLedger = () => {
        if (!selectedExpenseType) return null;
        return allLedgers.find(l => l.name === selectedExpenseType.name && l.Group?.id === selectedExpenseType.group_id) || null;
    };

    const decidePaymentType = (expenseType) => {

        if (!expenseType) {
            console.log("No expense type provided");
            return "indirect";
        }

        console.log("=== START decidePaymentType ===");
        console.log("Expense Type:", expenseType);
        console.log("Category:", expenseType.category);

        // -------------------------------
        // 1. ASSET CATEGORY CHECK
        // -------------------------------
        if (expenseType.category?.category_type === "asset") {
            console.log("Category type = asset → ASSET");
            return "asset";
        }

        // Normalize group name
        const getGroupName = (group) => {
            const name = (group?.Group?.name || group?.name || "")
                .toLowerCase()
                .trim();

            console.log("CATEGORY GROUP NAME:", name);
            return name;
        };

        // -------------------------------
        // FALLBACK using group_id
        // -------------------------------
        const checkByGroupId = (id) => {
            const groupId = Number(id);

            console.log("Fallback check groupId:", groupId);

            if (groupId === 12) return "direct";
            if (groupId === 14) return "indirect";
            if ([5, 6, 7].includes(groupId)) return "asset";

            return null;
        };

        // -------------------------------
        // 2. CATEGORY GROUP NAME CHECK
        // -------------------------------
        if (expenseType.category?.group_id) {
            const categoryGroup = accountGroups.find(
                g =>
                    g?.Group?.id == expenseType.category.group_id ||
                    g?.id == expenseType.category.group_id
            );

            if (categoryGroup) {
                const name = getGroupName(categoryGroup);

                // Whole-word matching (SAFE)
                const isDirect = /\bdirect expenses?\b/.test(name);
                const isIndirect = /\bindirect expenses?\b/.test(name);

                console.log("isDirect:", isDirect, "isIndirect:", isIndirect);

                if (isDirect) return "direct";
                if (isIndirect) return "indirect";

                // Only fallback if name is empty
                if (!name) {
                    const fb = checkByGroupId(expenseType.category.group_id);
                    if (fb) return fb;
                }

            } else {
                console.log("Category group NOT FOUND → fallback");
                const fb = checkByGroupId(expenseType.category.group_id);
                if (fb) return fb;
            }
        }

        // -------------------------------
        // 3. DEFAULT
        // -------------------------------
        console.log("No match → DEFAULT INDIRECT");
        return "indirect";
    };



    const nextStep = () => {
        setCurrentStep(prev => prev + 1);
    };

    const prevStep = () => {
        setCurrentStep(prev => prev - 1);
    };

    const handlePaymentTypeChange = (e) => {
        const value = e.target.value;
        setPaymentType(value);
        setFormData(prev => ({ ...prev, payment_type: value }));
        nextStep();
    };

    const handlePaymentMethodChange = (e) => {
        const value = e.target.value;
        setPaymentMethod(value);
        setFormData(prev => ({
            ...prev, payment_method: value,
            purchase_order_id: value === "internal" ? "" : prev.purchase_order_id

        }));
        nextStep();
    };

    const handleClientChange = (e) => {
        const clientId = e.target.value;
        setFormData({ ...formData, client_id: clientId, project_id: "" });
        setSelectedClient(clientId);
        fetchProjects(clientId);
    };

    useEffect(() => {
        if (showModal && expenseId && formData.vendor_id) {
            console.log('🔄 Fetching POs for edit mode with selected PO:', {
                vendorId: formData.vendor_id,
                projectId: formData.project_id,
                type: formData.type,
                selectedPO: formData.purchase_order_id,
                isEditMode: true
            });

            const timer = setTimeout(() => {
                const expenseType = formData.type === "external" ? "external" : "internal";
                fetchPurchaseOrders(
                    formData.vendor_id,
                    formData.project_id,
                    expenseType,
                    true, // isEditMode flag
                    formData.purchase_order_id // Pass selected PO ID
                );
            }, 300); // Increased delay to ensure form data is loaded

            return () => clearTimeout(timer);
        }
    }, [showModal, expenseId, formData.vendor_id, formData.type, formData.purchase_order_id]);
    const handlePurchaseOrderSelect = (purchaseOrderId) => {
        const selectedPO = purchaseOrders.find(po => po.id.toString() === purchaseOrderId.toString());

        setSelectedPurchaseOrder(selectedPO);
        setFormData(prev => ({ ...prev, purchase_order_id: purchaseOrderId }));
        if (purchaseOrderId && formData.vendor_id) {
            fetchVendorAdvances(formData.vendor_id, purchaseOrderId);
        }

        if (selectedPO) {
            // Store original values in PO's currency
            let poAmountToUse;

            if (formData.tax_type === "taxable") {
                // For taxable: Use basic_amount (amount without VAT)
                poAmountToUse = selectedPO.base_amount || selectedPO.remaining_amount || 0;
            } else {
                // For non-taxable: Use remaining_amount (full amount, no VAT separation needed)
                poAmountToUse = selectedPO.remaining_amount || 0;
            }
            poAmountToUse = Number(poAmountToUse) || 0;

            setOriginalPOAmount(poAmountToUse);
            // setOriginalPOAmount(selectedPO.remaining_amount); // Store in PO's currency
            setOriginalPOCurrency(selectedPO.vendor_currency);

            // IMPORTANT: If PO currency matches selected currency, use it directly
            // If not, convert from PO currency to selected currency
            // let displayAmount = selectedPO.remaining_amount;
            let displayAmount = poAmountToUse;


            if (selectedPO.vendor_currency !== selectedCurrency) {
                // Convert from PO currency to selected currency
                displayAmount = convertCurrency(
                    selectedPO.remaining_amount,
                    selectedPO.vendor_currency,
                    selectedCurrency
                );
            }

            // Update the appropriate field based on tax type
            if (formData.tax_type === "taxable") {
                const base = parseFloat(displayAmount) || 0;
                const taxRate = parseFloat(taxFields.tax) || 5;
                const vat = (base * taxRate) / 100;
                const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                const advance = parseFloat(formData.advance_applied || 0);
                const total = Math.max(0, base + vat + adjustment - advance);

                setTaxFields(prev => ({
                    ...prev,
                    amount_without_tax: base.toFixed(2),
                    vat_amount: vat.toFixed(2),
                    total_amount: total.toFixed(2)
                }));
                setFormData(prev => ({
                    ...prev,
                    amount_without_tax: base.toFixed(2),
                    total_amount: total.toFixed(2)
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    amount: displayAmount.toFixed(2)
                }));
            }

            // Show success message
            // Swal.fire({
            //     toast: true,
            //     position: 'top-end',
            //     icon: 'success',
            //     title: `PO Balance: ${selectedPO.vendor_currency} ${selectedPO.remaining_amount.toFixed(2)} = ${selectedCurrency} ${displayAmount.toFixed(2)}`,
            //     timer: 3000,
            //     timerProgressBar: true,
            //     showConfirmButton: false,
            // });
        } else {
            // Clear amounts if no PO selected
            setOriginalPOAmount(0);
            setOriginalPOCurrency("AED");

            if (formData.tax_type === "taxable") {
                setTaxFields(prev => ({
                    ...prev,
                    amount_without_tax: ""
                }));
            } else {
                setFormData(prev => ({
                    ...prev,
                    amount: ""
                }));
            }
        }
    };

    const handleOCR = async (file) => {
        if (!file || !formData.tax_type) return;

        setLoading(true);
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const origin = localStorage.getItem('user-origin');
        const token = userInfo?.token;

        const ocrFormData = new FormData();
        ocrFormData.append('image', file);

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const response = await axios.post(`${backendUrl}/api/ocr/read-expense`, ocrFormData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                    'Content-Type': 'multipart/form-data'
                },
                skipLoader: true
            });

            if (response.data && (response.data.data || response.data.amounts)) {
                const ocrData = response.data.data || response.data.amounts;
                const { exclude_amount, vat_amount, total_amount, bill_no, date } = ocrData;

                // Simple date normalizer to handle DD/MM/YYYY or DD.MM.YYYY to YYYY-MM-DD
                const normalizeOCRDate = (d) => {
                    if (!d) return null;
                    const parts = d.split(/[-/.]/);
                    if (parts.length === 3) {
                        if (parts[0].length === 4) return `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`; // YYYY-MM-DD
                        if (parts[2].length === 4) return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`; // DD-MM-YYYY -> YYYY-MM-DD
                    }
                    return d;
                };

                const cleanDate = normalizeOCRDate(date);

                if (formData.tax_type === 'taxable') {
                    const base = parseFloat(exclude_amount || 0);
                    const vat = parseFloat(vat_amount || 0);
                    const total = parseFloat(total_amount || 0);

                    setTaxFields(prev => ({
                        ...prev,
                        amount_without_tax: base > 0 ? base.toFixed(2) : prev.amount_without_tax,
                        vat_amount: vat > 0 ? vat.toFixed(2) : prev.vat_amount,
                        total_amount: total > 0 ? total.toFixed(2) : prev.total_amount,
                        invoice_no: bill_no || prev.invoice_no,
                        invoice_date: cleanDate || prev.invoice_date
                    }));

                    setFormData(prev => ({
                        ...prev,
                        amount_without_tax: base > 0 ? base.toFixed(2) : prev.amount_without_tax,
                        total_amount: total > 0 ? total.toFixed(2) : prev.total_amount,
                        date: cleanDate || prev.date,
                        invoice_no: bill_no || prev.invoice_no,
                        invoice_date: cleanDate || prev.invoice_date
                    }));
                } else {
                    const amount = parseFloat(total_amount || exclude_amount || 0);
                    setFormData(prev => ({
                        ...prev,
                        amount: amount > 0 ? amount.toFixed(2) : prev.amount,
                        date: cleanDate || prev.date,
                        invoice_no: bill_no || prev.invoice_no,
                        invoice_date: cleanDate || prev.invoice_date
                    }));
                    setTaxFields(prev => ({
                        ...prev,
                        invoice_no: bill_no || prev.invoice_no,
                        invoice_date: cleanDate || prev.invoice_date
                    }));
                }

                // Swal.fire({
                //     toast: true,
                //     position: 'top-end',
                //     icon: 'success',
                //     title: 'Data extracted from document',
                //     timer: 3000,
                //     showConfirmButton: false,
                // });
            }
        } catch (error) {
            console.error("OCR Error:", error);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Failed to read document data',
                timer: 3000,
                showConfirmButton: false,
            });
        } finally {
            setLoading(false);
        }
    };

    // Also modify the handleChange function to call handlePurchaseOrderSelect when PO is selected
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === "attatchment") {
            if (files.length > 0) {
                const file = files[0];
                const maxSize = 5 * 1024 * 1024; // 5MB limit

                if (file.size > maxSize) {
                    setErrors(prev => ({
                        ...prev,
                        attatchment: "File size must be less than 5MB"
                    }));
                } else {
                    setErrors(prev => ({ ...prev, attatchment: undefined }));
                }
                setFormData({ ...formData, attatchment: file });
                
                // Trigger OCR if tax type is already selected
                if (formData.tax_type) {
                    const hasManuallyEnteredAmount = formData.tax_type === 'taxable' 
                        ? (parseFloat(taxFields.amount_without_tax) > 0 || parseFloat(taxFields.total_amount) > 0 || parseFloat(formData.amount) > 0)
                        : (parseFloat(formData.amount) > 0);

                    if (!hasManuallyEnteredAmount) {
                        handleOCR(file);
                    }
                }
            } else {
                const today = new Date().toISOString().split('T')[0];
                // If attachment is cleared, clear amounts
                setFormData(prev => ({
                    ...prev,
                    attatchment: null,
                    amount: "",
                    amount_without_tax: "",
                    total_amount: "",
                    date: today,
                    invoice_no: "",
                    invoice_date: ""
                }));
                setTaxFields(prev => ({
                    ...prev,
                    amount_without_tax: "",
                    vat_amount: "",
                    total_amount: "",
                    invoice_no: "",
                    invoice_date: ""
                }));
            }
        } else if (name === "purchase_order_id") {
            handlePurchaseOrderSelect(value); // Call the function when PO is selected
        } else if (name === "amount") {
            // If user manually edits amount, update original PO amount
            const amountValue = parseFloat(value || 0);
            const adjustment = parseFloat(taxFields.adjustment_amount || 0);
            const total = amountValue + adjustment;

            setFormData({
                ...formData,
                [name]: value,
                total_amount: total.toFixed(2)
            });
            setTaxFields(prev => ({
                ...prev,
                total_amount: total.toFixed(2)
            }));

            if (formData.purchase_order_id) {
                setOriginalPOAmount(amountValue);
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
        // In handleChange function
        if (name === "type") {
            const newPaymentType = value;
            setFormData({ ...formData, [name]: value, purchase_order_id: "" });

            // Reset PO when payment method changes
            setSelectedPurchaseOrder(null);
            setPurchaseOrders([]);

            // Fetch POs for the new payment type if vendor is selected
            if (formData.vendor_id) {
                const expenseType = newPaymentType === "external" ? "external" : "internal";
                fetchPurchaseOrders(formData.vendor_id, formData.project_id, expenseType, paymentType);
            }
        }

        if (name === "type" && value === "internal") {
            setErrors(prevErrors => ({ ...prevErrors, vendor_id: undefined }));
        }

        if (errors[name]) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
        }
    };

    // Also update the handleTaxFieldChange for taxable expenses
    // const handleTaxFieldChange = (e) => {
    //     const { name, value } = e.target;
    //     const updated = { ...taxFields, [name]: value };

    //     // if (name === "amount_without_tax" || name === "adjustment_amount") {
    //     //     const base = parseFloat(updated.amount_without_tax || 0);
    //     //     const tax = (base * (updated.tax || 0)) / 100;
    //     //     const total = base + tax + parseFloat(updated.adjustment_amount || 0);
    //     //     updated.total_amount = total.toFixed(2);

    //     //     // If user manually edits amount, update original PO amount
    //     //     if (name === "amount_without_tax" && formData.purchase_order_id) {
    //     //         setOriginalPOAmount(base);
    //     //     }
    //     // }
    //     if (name === "amount_without_tax" || name === "adjustment_amount") {
    //         const base = parseFloat(updated.amount_without_tax || 0);
    //         const advanceApplied = parseFloat(formData.advance_applied || 0);
    //         const tax = ((base - advanceApplied) * (updated.tax || 0)) / 100; // Calculate tax AFTER advance deduction
    //         const adjustment = parseFloat(updated.adjustment_amount || 0);

    //         // Total = (Base - Advance) + Tax + Adjustment
    //         const total = Math.max(0, (base - advanceApplied) + tax + adjustment);
    //         updated.total_amount = total.toFixed(2);

    //         // If user manually edits amount, update original PO amount
    //         if (name === "amount_without_tax" && formData.purchase_order_id) {
    //             setOriginalPOAmount(base);
    //         }
    //     }

    //     setTaxFields(updated);
    //     setFormData(prev => ({
    //         ...prev,
    //         [name]: value,
    //         total_amount: updated.total_amount
    //     }));

    //     if (errors[name] && value) {
    //         setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    //     }
    // };

    // const handleTaxFieldChange = (e) => {
    //     const { name, value } = e.target;
    //     const updated = { ...taxFields, [name]: value };

    //     if (name === "amount_without_tax" || name === "adjustment_amount" || name === "tax") {
    //         const base = parseFloat(updated.amount_without_tax || 0);
    //         const advanceApplied = parseFloat(formData.advance_applied || 0);

    //         // Calculate taxable base AFTER deducting advance
    //         const taxableBase = Math.max(0, base - advanceApplied);

    //         // Calculate tax on the reduced amount
    //         const tax = (taxableBase * (updated.tax || 0)) / 100;
    //         const adjustment = parseFloat(updated.adjustment_amount || 0);

    //         // Total = (Base - Advance) + Tax + Adjustment
    //         const total = taxableBase + tax + adjustment;
    //         updated.total_amount = total.toFixed(2);

    //         // If user manually edits amount, update original PO amount
    //         if (name === "amount_without_tax" && formData.purchase_order_id) {
    //             setOriginalPOAmount(base);
    //         }
    //     }

    //     setTaxFields(updated);
    //     setFormData(prev => ({
    //         ...prev,
    //         [name]: value,
    //         total_amount: updated.total_amount
    //     }));

    //     if (errors[name] && value) {
    //         setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    //     }
    // };
    const handleTaxFieldChange = (e) => {
        const { name, value } = e.target;
        const updated = { ...taxFields, [name]: value };

        if (name === "amount_without_tax" || name === "adjustment_amount" || name === "tax" || name === "vat_amount") {
            const base = formData.tax_type === "taxable"
                ? parseFloat(updated.amount_without_tax || 0)
                : parseFloat(formData.amount || 0);

            const advanceApplied = parseFloat(formData.advance_applied || 0);

            // Calculate tax on the original amount (NOT reduced by advance)
            const taxRate = parseFloat(updated.tax) || 5;
            const vatAmt = (base * taxRate) / 100;
            const adjustment = parseFloat(updated.adjustment_amount || 0);

            // When base amount or tax rate changes, reset vat_amount to the calculated value
            if (name === "amount_without_tax" || name === "tax") {
                updated.vat_amount = vatAmt.toFixed(2);
            }

            // Use manually-entered vat_amount if it exists, otherwise use calculated
            const effectiveVat = parseFloat(updated.vat_amount !== '' && updated.vat_amount !== undefined ? updated.vat_amount : vatAmt);

            // Total = (Original Base) + VAT + Adjustment - Advance
            const totalBeforeAdvance = base + effectiveVat + adjustment;
            const total = Math.max(0, totalBeforeAdvance - advanceApplied);

            updated.total_amount = total.toFixed(2);
            updated.tax = taxRate; // Ensure it's a number

            // If user manually edits amount, update original PO amount
            if (name === "amount_without_tax" && formData.purchase_order_id) {
                setOriginalPOAmount(base);
            }
        }

        // In your frontend, modify the calculation logic for salary expenses
        if (formData.type === 'salary') {
            const salaryAmount = parseFloat(formData.amount || 0);

            const total = salaryAmount;

            // Update the total_amount field
            setFormData(prev => ({
                ...prev,
                total_amount: total.toFixed(2)
            }));

            // Also update taxFields if needed
            setTaxFields(prev => ({
                ...prev,
                total_amount: total.toFixed(2)
            }));
        }
        setTaxFields(updated);
        setFormData(prev => ({
            ...prev,
            [name]: value,
            total_amount: updated.total_amount
        }));

        if (errors[name] && value) {
            setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
        }
    };
    const handleTaxTypeChange = (e) => {
        const value = e.target.value;
        setTaxType(value);
        setFormData(prev => ({ ...prev, tax_type: value }));

        if (value === "taxable") {
            setTaxFields(prev => {
                const currentTax = parseFloat(prev.tax);
                // Default to 5% if current tax is missing, NaN, or 0 (common when switching from non-taxable)
                const newTax = (!prev.tax || isNaN(currentTax) || currentTax === 0) ? 5 : currentTax;

                // Move existing amount to amount_without_tax if it's currently empty
                const baseAmount = prev.amount_without_tax || formData.amount || "";

                const updated = {
                    ...prev,
                    tax: newTax,
                    amount_without_tax: baseAmount
                };

                // Recalculate total_amount immediately
                const base = parseFloat(baseAmount || 0);
                const taxAmt = (base * newTax) / 100;
                const adjustment = parseFloat(prev.adjustment_amount || 0);
                const advance = parseFloat(formData.advance_applied || 0);
                updated.total_amount = (base + taxAmt + adjustment - advance).toFixed(2);

                return updated;
            });
        }

        if (errors.tax_type) {
            setErrors(prevErrors => ({ ...prevErrors, tax_type: undefined }));
        }

        // Trigger OCR if attachment already exists
        if (formData.attatchment instanceof File) {
            const hasManuallyEnteredAmount = value === 'taxable' 
                ? (parseFloat(taxFields.amount_without_tax) > 0 || parseFloat(formData.amount) > 0)
                : (parseFloat(formData.amount) > 0);

            if (!hasManuallyEnteredAmount) {
                handleOCR(formData.attatchment);
            }
        }
    };


    const validateForm = () => {
        const newErrors = {};

        // Basic validation
        if (!formData.date) newErrors.date = "Date is required";

        if (formData.attatchment instanceof File) {
            const maxSize = 5 * 1024 * 1024; // 5MB limit
            if (formData.attatchment.size > maxSize) {
                newErrors.attatchment = "File size must be less than 5MB";
            }
        }

        return newErrors;
    };

    const validateMultipleBills = async () => {
        const newErrors = {};

        if (!formData.date) newErrors.date = "Payment Date is required";
        if (!formData.expense_type_id) newErrors.expense_type_id = "Expense Type is required";
        if (!formData.type) newErrors.payment_method = "Payment Method is required";
        if (formData.type !== 'internal' && !formData.vendor_id) newErrors.vendor_id = "Supplier is required";
        if (!formData.tax_type) newErrors.tax_type = "VAT Type is required";
        if (formData.type === 'internal' && !formData.user_id && isAdmin) {
            newErrors.user_id = "Petty Cash Employee is required";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            const firstErr = Object.values(newErrors)[0];
            return { error: firstErr };
        }

        if (!multipleBills || multipleBills.length === 0) {
            return { error: "Please add at least one bill." };
        }

        const seenBillNos = new Set();
        let hasBillError = false;
        let firstBillErrorMessage = "";

        const updatedBills = multipleBills.map((bill, idx) => {
            const billErrors = {};
            const billNum = (bill.bill_no || bill.invoice_no || '').trim();

            if (!billNum) {
                billErrors.bill_no = "Bill Number is required";
                hasBillError = true;
                if (!firstBillErrorMessage) firstBillErrorMessage = `Bill #${idx + 1}: Bill Number is required`;
            } else {
                const norm = billNum.toLowerCase();
                if (seenBillNos.has(norm)) {
                    billErrors.bill_no = `Duplicate: '${billNum}' used more than once`;
                    hasBillError = true;
                    if (!firstBillErrorMessage) firstBillErrorMessage = `Duplicate Bill Number '${billNum}' used in Bill #${idx + 1}`;
                } else {
                    seenBillNos.add(norm);
                }
            }

            const billDate = bill.bill_date || bill.invoice_date || commonBillDate;
            if (!billDate) {
                billErrors.bill_date = "Bill Date is required";
                hasBillError = true;
                if (!firstBillErrorMessage) firstBillErrorMessage = `Bill #${idx + 1}: Bill Date is required`;
            }

            if (formData.tax_type === 'taxable') {
                const base = parseFloat(bill.amount_without_tax);
                if (isNaN(base) || base <= 0) {
                    billErrors.amount_without_tax = "Base Amount must be greater than 0";
                    hasBillError = true;
                    if (!firstBillErrorMessage) firstBillErrorMessage = `Bill #${idx + 1}: Base Amount must be greater than 0`;
                }
            } else {
                const amt = parseFloat(bill.amount);
                if (isNaN(amt) || amt <= 0) {
                    billErrors.amount = "Amount must be greater than 0";
                    hasBillError = true;
                    if (!firstBillErrorMessage) firstBillErrorMessage = `Bill #${idx + 1}: Amount must be greater than 0`;
                }
            }

            if (bill.attatchment instanceof File && bill.attatchment.size > 5 * 1024 * 1024) {
                billErrors.attatchment = "File size must be less than 5MB";
                hasBillError = true;
                if (!firstBillErrorMessage) firstBillErrorMessage = `Bill #${idx + 1}: Attachment exceeds 5MB`;
            }

            return { ...bill, error: billErrors };
        });

        if (hasBillError) {
            setMultipleBills(updatedBills);
            return { error: firstBillErrorMessage || "Please correct the highlighted bill details" };
        }

        // Duplicate check against backend for this supplier
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const token = userInfo?.token;
            const origin = localStorage.getItem('user-origin');

            const response = await axios.get(`${backendUrl}/api/expense`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    vendor_id: formData.vendor_id,
                },
                skipLoader: true,
            });

            const existingExpenses = response.data?.data?.data || response.data?.data || [];
            for (const bill of multipleBills) {
                const billNum = (bill.bill_no || bill.invoice_no || '').trim().toLowerCase();
                const duplicate = existingExpenses.find(exp =>
                    String(exp.vendor_id) === String(formData.vendor_id) &&
                    String(exp.invoice_no || '').trim().toLowerCase() === billNum
                );

                if (duplicate) {
                    return { error: `Bill number '${bill.bill_no || bill.invoice_no}' already exists for this supplier in the system.` };
                }
            }
        } catch (err) {
            console.error("Error checking duplicate bills:", err);
        }

        // Check locked periods for each bill's date
        for (const bill of multipleBills) {
            const billDateToCheck = bill.bill_date || bill.invoice_date || formData.date;
            const isDateLocked = await checkIfDateLocked(billDateToCheck);
            if (isDateLocked) {
                return { error: `Date ${billDateToCheck} falls within a locked financial period.` };
            }
        }

        return { success: true };
    };

    const handleMultipleBillsSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        setLoading(true);
        setLockError('');

        const valResult = await validateMultipleBills();
        if (valResult && valResult.error) {
            setLoading(false);
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: valResult.error,
                timer: 4000,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    if (container) container.style.top = '50px';
                },
            });
            return;
        }

        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const userInfo = JSON.parse(localStorage.getItem('user-info'));
        const token = userInfo?.token;
        const origin = localStorage.getItem('user-origin');

        const createdExpenses = [];
        let failedIndex = -1;
        let failErrorMessage = '';

        for (let i = 0; i < multipleBills.length; i++) {
            const bill = multipleBills[i];
            const billFormDataObj = new FormData();

            // Append common data (date is Payment Date)
            billFormDataObj.append('date', formData.date);
            billFormDataObj.append('expense_type_id', formData.expense_type_id || '');
            if (formData.group_id) billFormDataObj.append('group_id', formData.group_id);
            if (formData.category_type) billFormDataObj.append('category_type', formData.category_type);
            if (formData.payment_type) billFormDataObj.append('payment_type', formData.payment_type);
            if (formData.office_ledger_id) billFormDataObj.append('office_ledger_id', formData.office_ledger_id);
            billFormDataObj.append('type', formData.type || '');
            if (formData.vendor_id) billFormDataObj.append('vendor_id', formData.vendor_id);
            if (formData.user_id) billFormDataObj.append('user_id', formData.user_id);
            if (formData.client_id) billFormDataObj.append('client_id', formData.client_id);
            if (formData.project_id) billFormDataObj.append('project_id', formData.project_id);
            billFormDataObj.append('tax_type', formData.tax_type || '');
            billFormDataObj.append('vendor_currency', selectedCurrency || 'AED');
            billFormDataObj.append('narration', bill.narration || formData.narration || '');

            // Bill specific numbers & dates (Bill Date maps to invoice_date)
            const billNoVal = bill.bill_no || bill.invoice_no;
            const billDateVal = bill.bill_date || bill.invoice_date || commonBillDate || formData.date;
            billFormDataObj.set('invoice_no', billNoVal);
            billFormDataObj.set('invoice_date', billDateVal);
            billFormDataObj.set('bill_no', billNoVal);
            billFormDataObj.set('bill_date', billDateVal);

            if (formData.tax_type === 'taxable') {
                const base = parseFloat(bill.amount_without_tax || 0);
                const taxRate = parseFloat(bill.tax) || 5;
                const calcVat = (base * taxRate) / 100;
                const effVat = (bill.vat_amount !== '' && bill.vat_amount !== undefined)
                    ? bill.vat_amount
                    : calcVat.toFixed(2);

                const adj = parseFloat(bill.adjustment_amount || 0);
                const finalizedTotal = (base + parseFloat(effVat) + adj).toFixed(2);

                billFormDataObj.set('amount_without_tax', bill.amount_without_tax);
                billFormDataObj.set('tax', taxRate);
                billFormDataObj.set('vat_amount', effVat);
                billFormDataObj.set('adjustment_amount', adj);
                billFormDataObj.set('total_amount', finalizedTotal);
                billFormDataObj.set('amount', finalizedTotal);
            } else {
                const amt = parseFloat(bill.amount || 0).toFixed(2);
                billFormDataObj.set('amount', amt);
                billFormDataObj.set('total_amount', amt);
                billFormDataObj.set('tax', bill.tax || 0);
                billFormDataObj.set('adjustment_amount', bill.adjustment_amount || 0);
            }

            if (bill.attatchment instanceof File) {
                billFormDataObj.append('attatchment', bill.attatchment);
            }

            try {
                const response = await axios.post(`${backendUrl}/api/expense`, billFormDataObj, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data',
                        'Tenant-Origin': origin,
                    },
                });

                if (response.data?.data) {
                    createdExpenses.push(response.data.data);
                }
            } catch (err) {
                console.error(`Error saving bill #${i + 1}:`, err);
                failedIndex = i;
                failErrorMessage = err.response?.data?.message || err.message || 'Server error';
                break;
            }
        }

        setLoading(false);

        if (createdExpenses.length > 0) {
            window.dispatchEvent(new CustomEvent('expenseAdded', { detail: createdExpenses }));
        }

        if (failedIndex !== -1) {
            Swal.fire({
                icon: 'error',
                title: `Error Saving Bill #${failedIndex + 1}`,
                text: `${failErrorMessage}. ${createdExpenses.length} of ${multipleBills.length} bills were saved successfully.`,
            });
            if (createdExpenses.length > 0) {
                setMultipleBills(prev => prev.slice(failedIndex));
            }
        } else {
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: `All ${multipleBills.length} bills saved successfully!`,
                timer: 3000,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    if (container) container.style.top = '50px';
                },
            });
            setMultipleBills([createNewBillItem()]);
            setCommonBillDate('');
            setActiveCurrencyDropdownBillId(null);
            handleClose();
        }
    };

    const renderMultipleBillsMode = () => {
        return (
            <div className="multiple-bills-container">
                {lockError && (
                    <div className="alert alert-danger mb-3">
                        <i className="mdi mdi-alert-circle-outline me-2"></i>
                        {lockError}
                    </div>
                )}

                {/* Card 1: Shared Expense Details */}
                <div className="card border mb-4 shadow-sm" style={{ borderRadius: '10px' }}>
                    <div className="card-header bg-light py-2 px-3 d-flex align-items-center">
                        <i className="mdi mdi-information-outline me-2 text-primary font-size-18"></i>
                        <h6 className="mb-0 font-weight-bold">Shared Expense Details</h6>
                    </div>
                    <div className="card-body p-3">
                        <div className="row g-3 mb-3">
                            <div className="col-md-6">
                                <label className="form-font">Payment Date <span className="text-danger">*</span></label>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        views={["year", "month", "day"]}
                                        density="compact"
                                        format="DD-MM-YYYY"
                                        value={formData.date && dayjs(formData.date).isValid() ? dayjs(formData.date) : null}
                                        onChange={(newValue) => {
                                            const formattedDate = newValue ? newValue.format("YYYY-MM-DD") : "";
                                            setFormData(prev => ({ ...prev, date: formattedDate }));
                                        }}
                                        slotProps={{
                                            textField: {
                                                size: "small",
                                                fullWidth: true,
                                                className: "form-feild",
                                                error: !!errors.date
                                            },
                                            popper: {
                                                sx: { zIndex: 9999 }
                                            }
                                        }}
                                    />
                                </LocalizationProvider>
                                {errors.date && <div className="invalid-feedback d-block font-size-12">*{errors.date}</div>}
                            </div>

                            <div className="col-md-6">
                                <Form.Group controlId="mbPaymentMethod">
                                    <Form.Label className="form-font">Payment Method <span className="text-danger">*</span></Form.Label>
                                    <Form.Select
                                        className={`form-feild ${errors?.payment_method ? 'is-invalid' : ''}`}
                                        name="type"
                                        value={formData.type}
                                        onChange={handleChange}
                                    >
                                        <option value="">Select Payment Method</option>
                                        <option value="external">Direct</option>
                                        <option value="internal">Petty Cash</option>
                                    </Form.Select>
                                    {errors.payment_method && <div className="invalid-feedback d-block font-size-12">*{errors.payment_method}</div>}
                                </Form.Group>
                            </div>
                        </div>

                        <div className="mb-3">
                            <HierarchicalExpenseTypeDropdown
                                label="Expense Type"
                                value={formData.expense_type_id}
                                onChange={(e) => {
                                    const expenseTypeId = e.target.value;
                                    const selected = expenseTypes.find(et => et.id.toString() === expenseTypeId.toString());
                                    const determinedPaymentType = e.target.paymentType || decidePaymentType(selected);

                                    setPaymentType(determinedPaymentType);
                                    setSelectedExpenseType(selected);

                                    setFormData(prev => ({
                                        ...prev,
                                        expense_type_id: expenseTypeId,
                                        group_id: selected?.group_id || selected?.category?.group_id || "",
                                        category_type: selected?.category?.category_type || "",
                                        payment_type: determinedPaymentType,
                                        office_ledger_id: e.target.ledger_id || ""
                                    }));
                                }}
                                error={errors.expense_type_id}
                            />
                        </div>

                        <div className="row g-3 mb-3">
                            <div className="col-md-6">
                                <Form.Group controlId="mbVendor">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <Form.Label className='form-font mb-0'>Supplier {formData.type !== 'internal' && <span className="text-danger">*</span>}</Form.Label>
                                        {selectedVendorObj?.rcm_eligible && (
                                            <Badge bg="info" style={{ fontSize: '10px' }}>RCM Eligible</Badge>
                                        )}
                                    </div>
                                    <Form.Select
                                        name='vendor_id'
                                        value={formData.vendor_id}
                                        onChange={handleVendorChange}
                                        className={`form-feild ${errors?.vendor_id ? 'is-invalid' : ''}`}
                                    >
                                        <option value="">Select Vendor</option>
                                        {vendors.map(vendor => (
                                            <option key={vendor.id} value={vendor.id}>
                                                {vendor.name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    {errors.vendor_id && <div className="invalid-feedback d-block font-size-12">*{errors.vendor_id}</div>}
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group controlId="mbTaxType">
                                    <Form.Label className="form-font">VAT Type <span className="text-danger">*</span></Form.Label>
                                    <Form.Select
                                        className={`form-feild ${errors?.tax_type ? 'is-invalid' : ''}`}
                                        value={formData.tax_type}
                                        onChange={handleTaxTypeChange}
                                        name='tax_type'
                                    >
                                        <option value="">Select VAT Type</option>
                                        <option value="taxable">Taxable</option>
                                        <option value="non-taxable">Non-Taxable</option>
                                    </Form.Select>
                                    {errors.tax_type && <div className="invalid-feedback d-block font-size-12">*{errors.tax_type}</div>}
                                </Form.Group>
                            </div>
                        </div>

                        {formData.type === 'internal' && (
                            <div className="mb-3">
                                <Form.Group controlId="mbUser">
                                    <Form.Label className='form-font'>Petty Cash Employee <span className="text-danger">*</span></Form.Label>
                                    {isAdmin ? (
                                        <Form.Select
                                            name="user_id"
                                            value={formData.user_id}
                                            onChange={handleChange}
                                            className={`form-feild ${errors?.user_id ? 'is-invalid' : ''}`}
                                        >
                                            <option value="">Select Employee</option>
                                            {[...users]?.sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(user => (
                                                <option key={user.id} value={user.id}>
                                                    {user.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            value={loggedInUser?.name || 'Current User'}
                                            className="form-feild"
                                            disabled
                                            readOnly
                                        />
                                    )}
                                    {errors.user_id && <div className="invalid-feedback font-size-12">*{errors.user_id}</div>}
                                </Form.Group>
                            </div>
                        )}

                        {paymentType === 'direct' && (
                            <div className="row g-3 mb-3">
                                <div className="col-md-6">
                                    <Form.Group controlId="mbClient">
                                        <Form.Label className='form-font'>Client</Form.Label>
                                        <Form.Select
                                            name='client_id'
                                            value={formData.client_id}
                                            onChange={handleClientChange}
                                            className={`form-feild ${errors?.client_id ? 'is-invalid' : ''}`}
                                        >
                                            <option value="">Select Client</option>
                                            {clients.map(client => (
                                                <option key={client.id} value={client.id}>
                                                    {client.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.client_id && <div className="invalid-feedback d-block font-size-12">*{errors.client_id}</div>}
                                    </Form.Group>
                                </div>
                                <div className="col-md-6">
                                    <Form.Group controlId="mbProject">
                                        <Form.Label className='form-font'>Project</Form.Label>
                                        <Form.Select
                                            className={`form-feild ${errors?.project_id ? 'is-invalid' : ''}`}
                                            name="project_id"
                                            value={formData.project_id}
                                            onChange={handleProjectChange}
                                        >
                                            <option value="">Select Project</option>
                                            {projects.map(project => (
                                                <option key={project.id} value={project.id}>
                                                    {project.name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.project_id && <div className="invalid-feedback d-block font-size-12">*{errors.project_id}</div>}
                                    </Form.Group>
                                </div>
                            </div>
                        )}

                        <div className="row g-3">
                            <div className="col-md-6">
                                <Form.Group className="mb-0">
                                    <Form.Label className='form-font'>
                                        Common Bill Date
                                        <small className="text-muted ms-2">(applies to all bills)</small>
                                    </Form.Label>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={['year', 'month', 'day']}
                                            density="compact"
                                            format="DD-MM-YYYY"
                                            value={commonBillDate && dayjs(commonBillDate).isValid() ? dayjs(commonBillDate) : null}
                                            onChange={(newValue) => {
                                                const formatted = newValue ? newValue.format('YYYY-MM-DD') : '';
                                                handleCommonBillDateChange(formatted);
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: 'small',
                                                    fullWidth: true,
                                                    className: 'form-feild',
                                                    placeholder: 'Same date for all bills'
                                                },
                                                popper: { sx: { zIndex: 9999 } }
                                            }}
                                        />
                                    </LocalizationProvider>
                                    {/* {commonBillDate && (
                                        <small className="text-info d-block mt-1">
                                            <i className="mdi mdi-information-outline me-1"></i>
                                            Applied to all bills without an individual date override.
                                        </small>
                                    )} */}
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-0">
                                    <Form.Label className='form-font'>Common Description / Narration</Form.Label>
                                    <Form.Control
                                        className='form-control form-feild'
                                        type="text"
                                        name="narration"
                                        value={formData.narration}
                                        onChange={handleChange}
                                        placeholder="Enter description for this expense batch (optional)"
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Card 2: Dynamic Bill Details */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <div>
                        <h6 className="mb-0 font-weight-bold d-flex align-items-center">
                            <i className="mdi mdi-receipt me-2 text-primary font-size-18"></i>
                            Bill Details
                            <Badge bg="primary" pill className="ms-2" style={{ fontSize: '11px' }}>
                                {multipleBills.length} {multipleBills.length === 1 ? 'Bill' : 'Bills'}
                            </Badge>
                        </h6>
                        <small className="text-muted">Each bill creates its own independent accounting entry and record.</small>
                    </div>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={addBillItem}
                    >
                        <i className="mdi mdi-plus-circle me-1"></i> Add Another Bill
                    </button>
                </div>

                {multipleBills.map((bill, index) => {
                    const isTaxable = formData.tax_type === 'taxable';
                    return (
                        <div key={bill.id} className="card border mb-3 shadow-sm" style={{ borderRadius: '10px', overflow: 'hidden' }}>
                            <div className="card-header bg-light py-2 px-3 d-flex justify-content-between align-items-center border-bottom">
                                <div className="d-flex align-items-center">
                                    <span className="badge bg-secondary me-2" style={{ fontSize: '12px' }}>#{index + 1}</span>
                                    <strong className="text-dark font-size-14">
                                        {bill.bill_no ? `Bill: ${bill.bill_no}` : `Bill #${index + 1}`}
                                    </strong>
                                    {bill.total_amount && parseFloat(bill.total_amount) > 0 && (
                                        <span className="badge bg-success-subtle text-success ms-2 font-weight-bold" style={{ fontSize: '12px' }}>
                                            {selectedCurrency || 'AED'} {bill.total_amount}
                                        </span>
                                    )}
                                </div>
                                {multipleBills.length > 1 && (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger py-0 px-2"
                                        style={{ fontSize: '12px' }}
                                        onClick={() => removeBillItem(bill.id)}
                                        title="Remove this bill"
                                    >
                                        <i className="mdi mdi-delete-outline me-1"></i> Remove
                                    </button>
                                )}
                            </div>
                            <div className="card-body p-3">
                                {/* Bill Number & Bill Date */}
                                <div className="row g-3 mb-3">
                                    <div className="col-md-6">
                                        <Form.Label className="form-font">Bill Number <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="e.g. INV-1001"
                                            value={bill.bill_no || ''}
                                            onChange={(e) => updateBillItem(bill.id, 'bill_no', e.target.value)}
                                            isInvalid={!!bill.error?.bill_no}
                                            className="form-feild"
                                        />
                                        {bill.error?.bill_no && (
                                            <div className="invalid-feedback d-block font-size-12">*{bill.error.bill_no}</div>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <Form.Label className="form-font d-flex justify-content-between align-items-center">
                                            <span>Bill Date <span className="text-danger">*</span></span>
                                            {bill._dateOverridden && (
                                                <span
                                                    className="badge bg-warning-subtle text-warning border border-warning font-size-10 cursor-pointer"
                                                    style={{ cursor: 'pointer' }}
                                                    title="Click to reset to common date"
                                                    onClick={() => {
                                                        updateBillItem(bill.id, 'bill_date', commonBillDate);
                                                        setMultipleBills(prev => prev.map(b =>
                                                            b.id === bill.id ? { ...b, bill_date: commonBillDate, invoice_date: commonBillDate, _dateOverridden: false } : b
                                                        ));
                                                    }}
                                                >
                                                    <i className="mdi mdi-rotate-left me-1"></i>Custom — reset
                                                </span>
                                            )}
                                            {!bill._dateOverridden && commonBillDate && (
                                                <span className="text-muted font-size-10">
                                                    <i className="mdi mdi-link-variant me-1"></i>From common
                                                </span>
                                            )}
                                        </Form.Label>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                views={["year", "month", "day"]}
                                                density="compact"
                                                format="DD-MM-YYYY"
                                                value={bill.bill_date && dayjs(bill.bill_date).isValid() ? dayjs(bill.bill_date) : null}
                                                onChange={(newValue) => {
                                                    updateBillItem(bill.id, 'bill_date', newValue ? newValue.format("YYYY-MM-DD") : "");
                                                }}
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        fullWidth: true,
                                                        className: `form-feild${bill._dateOverridden ? ' border-warning' : ''}`,
                                                        error: !!bill.error?.bill_date
                                                    },
                                                    popper: {
                                                        sx: { zIndex: 9999 }
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                        {bill.error?.bill_date && (
                                            <div className="invalid-feedback d-block font-size-12">*{bill.error.bill_date}</div>
                                        )}
                                    </div>
                                </div>

                                {/* Amounts */}
                                {isTaxable ? (
                                    <div className="row g-2 mb-3 bg-light p-2 rounded">
                                        <div className="col-md-4">
                                            <Form.Label className="form-font font-size-12 mb-1">
                                                Base Amount (Excl. VAT) ({selectedCurrency || 'AED'}) <span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    placeholder="0.00"
                                                    value={bill.amount_without_tax || ''}
                                                    onChange={(e) => updateBillItem(bill.id, 'amount_without_tax', e.target.value)}
                                                    isInvalid={!!bill.error?.amount_without_tax}
                                                    className="form-feild form-control-sm"
                                                    style={{ paddingRight: '62px' }}
                                                />
                                                <div className="position-absolute" style={{ right: '5px', top: '50%', transform: 'translateY(-50%)', zIndex: 5 }}>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn btn-sm btn-outline-secondary dropdown-toggle"
                                                            type="button"
                                                            onClick={() => setActiveCurrencyDropdownBillId(activeCurrencyDropdownBillId === bill.id ? null : bill.id)}
                                                            style={{ padding: '1px 6px', fontSize: '11px', lineHeight: 1.4 }}
                                                        >
                                                            {selectedCurrency || 'AED'}
                                                        </button>
                                                        {activeCurrencyDropdownBillId === bill.id && (
                                                            <div className="dropdown-menu show" style={{ minWidth: '70px', zIndex: 9999 }}>
                                                                <button
                                                                    className="dropdown-item py-1 px-2 font-size-12"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        handleCurrencyChange("AED");
                                                                        setActiveCurrencyDropdownBillId(null);
                                                                    }}
                                                                >
                                                                    AED
                                                                </button>
                                                                <button
                                                                    className="dropdown-item py-1 px-2 font-size-12"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        handleCurrencyChange("USD");
                                                                        setActiveCurrencyDropdownBillId(null);
                                                                    }}
                                                                >
                                                                    USD
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {bill.error?.amount_without_tax && (
                                                <div className="invalid-feedback d-block font-size-11">*{bill.error.amount_without_tax}</div>
                                            )}
                                        </div>
                                        <div className="col-md-2">
                                            <Form.Label className="form-font font-size-12 mb-1">Tax %</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.1"
                                                value={bill.tax !== undefined ? bill.tax : 5}
                                                onChange={(e) => updateBillItem(bill.id, 'tax', e.target.value)}
                                                className="form-feild form-control-sm"
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <Form.Label className="form-font font-size-12 mb-1">VAT Amount</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.01"
                                                placeholder="0.00"
                                                value={bill.vat_amount || ''}
                                                onChange={(e) => updateBillItem(bill.id, 'vat_amount', e.target.value)}
                                                className="form-feild form-control-sm"
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <Form.Label className="form-font font-size-12 mb-1">
                                                Total Amount ({selectedCurrency || 'AED'})
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                readOnly
                                                value={bill.total_amount || '0.00'}
                                                className="form-feild form-control-sm bg-white font-weight-bold"
                                            />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="row g-3 mb-3">
                                        <div className="col-md-6">
                                            <Form.Label className="form-font">
                                                Bill Amount ({selectedCurrency || 'AED'}) <span className="text-danger">*</span>
                                            </Form.Label>
                                            <div className="position-relative">
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    placeholder="0.00"
                                                    value={bill.amount || ''}
                                                    onChange={(e) => updateBillItem(bill.id, 'amount', e.target.value)}
                                                    isInvalid={!!bill.error?.amount}
                                                    className="form-feild"
                                                    style={{ paddingRight: '65px' }}
                                                />
                                                <div className="position-absolute" style={{ right: '8px', top: '50%', transform: 'translateY(-50%)', zIndex: 5 }}>
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn btn-sm btn-outline-secondary dropdown-toggle"
                                                            type="button"
                                                            onClick={() => setActiveCurrencyDropdownBillId(activeCurrencyDropdownBillId === bill.id ? null : bill.id)}
                                                            style={{ padding: '2px 8px', fontSize: '12px' }}
                                                        >
                                                            {selectedCurrency || 'AED'}
                                                        </button>
                                                        {activeCurrencyDropdownBillId === bill.id && (
                                                            <div className="dropdown-menu show" style={{ minWidth: '75px', zIndex: 9999 }}>
                                                                <button
                                                                    className="dropdown-item py-1 px-2 font-size-12"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        handleCurrencyChange("AED");
                                                                        setActiveCurrencyDropdownBillId(null);
                                                                    }}
                                                                >
                                                                    AED
                                                                </button>
                                                                <button
                                                                    className="dropdown-item py-1 px-2 font-size-12"
                                                                    type="button"
                                                                    onClick={() => {
                                                                        handleCurrencyChange("USD");
                                                                        setActiveCurrencyDropdownBillId(null);
                                                                    }}
                                                                >
                                                                    USD
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {bill.error?.amount && (
                                                <div className="invalid-feedback d-block font-size-12">*{bill.error.amount}</div>
                                            )}
                                        </div>
                                        <div className="col-md-6">
                                            <Form.Label className="form-font">
                                                Total Amount ({selectedCurrency || 'AED'})
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                readOnly
                                                value={bill.total_amount || bill.amount || '0.00'}
                                                className="form-feild bg-light font-weight-bold"
                                            />
                                        </div>
                                    </div>
                                )}

                                {/* Attachment */}
                                <div className="mb-2">
                                    <Form.Label className="form-font d-flex justify-content-between align-items-center mb-1">
                                        <span><i className="mdi mdi-paperclip me-1"></i> Bill Attachment</span>
                                        <small className="text-muted">Images or PDF (max 5MB)</small>
                                    </Form.Label>
                                    {bill.attatchment || bill.previewUrl ? (
                                        <div className="d-flex align-items-center justify-content-between p-2 border rounded bg-light">
                                            <div className="d-flex align-items-center text-truncate me-2">
                                                <i className="mdi mdi-file-check-outline text-success font-size-20 me-2"></i>
                                                <span className="text-truncate font-size-13">
                                                    {bill.attatchment?.name || 'Attached Document'}
                                                </span>
                                                {bill.previewUrl && (
                                                    <a
                                                        href={bill.previewUrl}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-link btn-sm py-0 ms-2"
                                                    >
                                                        View
                                                    </a>
                                                )}
                                            </div>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger py-0 px-2"
                                                onClick={() => removeBillAttachment(bill.id)}
                                                title="Remove attachment"
                                            >
                                                <i className="mdi mdi-close"></i>
                                            </button>
                                        </div>
                                    ) : (
                                        <Form.Control
                                            type="file"
                                            accept="image/*,.pdf"
                                            className="form-feild form-control-sm"
                                            onChange={(e) => handleBillAttachmentChange(bill.id, e.target.files[0])}
                                        />
                                    )}
                                </div>

                                {/* Optional individual bill narration */}
                                <div>
                                    <Form.Control
                                        type="text"
                                        placeholder={formData.narration
                                            ? `Override narration (common: "${formData.narration}")`
                                            : 'Bill specific note (optional)'}
                                        value={bill.narration || ''}
                                        onChange={(e) => updateBillItem(bill.id, 'narration', e.target.value)}
                                        className={`form-feild form-control-sm font-size-12${bill.narration ? ' text-dark' : ' text-muted'}`}
                                    />
                                    {bill.narration && formData.narration && (
                                        <small className="text-warning d-block mt-1 font-size-10">
                                            <i className="mdi mdi-pencil-circle me-1"></i>This bill uses its own narration (overrides common)
                                        </small>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}

                {/* Add Another Bill Button */}
                <div className="mb-4">
                    <button
                        type="button"
                        className="btn btn-outline-primary w-100 py-2 d-flex align-items-center justify-content-center"
                        style={{ borderStyle: 'dashed', borderWidth: '2px', fontWeight: 600 }}
                        onClick={addBillItem}
                    >
                        <i className="mdi mdi-plus-circle me-2 font-size-16"></i> Add Another Bill
                    </button>
                </div>

                {/* Summary Card */}
                <div className="card border-0 bg-primary-subtle text-primary p-3 rounded mb-3 shadow-sm">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="font-weight-medium">Total Bills:</span>
                        <span className="badge bg-primary font-size-13">{multipleBillsTotal.count}</span>
                    </div>
                    {formData.tax_type === 'taxable' && (
                        <>
                            <div className="d-flex justify-content-between align-items-center mb-1 font-size-13 text-secondary">
                                <span>Subtotal (Excl. VAT):</span>
                                <span>{selectedCurrency || 'AED'} {multipleBillsTotal.totalBase}</span>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-2 font-size-13 text-secondary">
                                <span>Total VAT:</span>
                                <span>{selectedCurrency || 'AED'} {multipleBillsTotal.totalVat}</span>
                            </div>
                            <hr className="my-1 border-secondary opacity-25" />
                        </>
                    )}
                    <div className="d-flex justify-content-between align-items-center pt-1">
                        <span className="h6 mb-0 font-weight-bold text-dark">Total Bill Amount:</span>
                        <span className="h5 mb-0 font-weight-bold text-primary">
                            {selectedCurrency || 'AED'} {multipleBillsTotal.grandTotal}
                        </span>
                    </div>
                </div>
            </div>
        );
    };

    const handleSubmit = async (e) => {

        e.preventDefault();
        setLoading(true);
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            const firstError = Object.values(validationErrors)[0];
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: firstError,
                timer: 3000,
                timerProgressBar: false,
                showConfirmButton: false,
                didOpen: () => {
                    const container = Swal.getContainer();
                    container.style.top = '50px';
                },
            });
            return;
        }

        if (formData.vendor_id && taxFields.invoice_no) {
            try {
                const backendUrl = process.env.REACT_APP_BACKEND_URL;
                const userInfo = JSON.parse(localStorage.getItem('user-info'));
                const token = userInfo?.token;
                const origin = localStorage.getItem('user-origin');
                
                const response = await axios.get(`${backendUrl}/api/expense`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    params: {
                        vendor_id: formData.vendor_id,
                        search: taxFields.invoice_no
                    },
                    skipLoader: true,
                });
                
                const expenses = response.data?.data?.data || response.data?.data || [];
                const duplicate = expenses.find(exp => 
                    String(exp.vendor_id) === String(formData.vendor_id) && 
                    String(exp.invoice_no).trim().toLowerCase() === String(taxFields.invoice_no).trim().toLowerCase() && 
                    String(exp.id) !== String(expenseId)
                );

                if (duplicate) {
                    setErrors(prev => ({ ...prev, invoice_no: "The billno is already existed" }));
                    setLoading(false);
                    // Swal.fire({
                    //     toast: true,
                    //     position: 'top-end',
                    //     icon: 'error',
                    //     title: 'the same billno existed',
                    //     timer: 3000,
                    //     timerProgressBar: false,
                    //     showConfirmButton: false,
                    //     didOpen: () => {
                    //         const container = Swal.getContainer();
                    //         container.style.top = '50px';
                    //     },
                    // });
                    return;
                }
            } catch (err) {
                console.error("Error checking duplicate invoice:", err);
            }
        }

        setLockError('');
        console.log('DEBUG - Form Data before submit:', {
            type: formData.type,
            salaryFields: {
                provider: formData.payroll_provider_id
            }
        });

        try {
            const isDateLocked = await checkIfDateLocked(formData.date);
            if (isDateLocked) {
                setLockError('This date is in a locked financial period. Expense cannot be created or modified.');
                setLoading(false);
                return; // Stop immediately
            }
            const formDataObj = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (value !== undefined && value !== null) {
                    formDataObj.append(key, value);
                }
            });
            if (formData.purchase_order_id) {
                formDataObj.append("purchase_order_id", formData.purchase_order_id);
            }
            formDataObj.append("vendor_currency", selectedCurrency);
            formDataObj.append('vendor_advance_balance', formData.vendor_advance_balance || 0);
            formDataObj.append('advance_applied', formData.advance_applied || 0);
            formDataObj.append('apply_advance', formData.apply_advance ? '1' : '0');

            if (formData.type === 'salary') {
                formDataObj.set("invoice_no", taxFields.invoice_no);
                
                // Forcefully clear WPS and tax-related fields for salary
                formDataObj.set("wps_charge", "0.00");
                formDataObj.set("wps_vat", "0.00");
                formDataObj.set("adjustment_amount", "0.00");
                formDataObj.set("total_amount", formData.amount);
            }
            if (formData.tax_type === "taxable") {
                formDataObj.set("invoice_no", taxFields.invoice_no);
                formDataObj.set("invoice_date", taxFields.invoice_date);
                formDataObj.set("amount_without_tax", taxFields.amount_without_tax);
                formDataObj.set("tax", taxFields.tax);

                // Send the effective VAT amount (manual override or calculated)
                const base = parseFloat(taxFields.amount_without_tax || 0);
                const taxRate = parseFloat(taxFields.tax) || 5;
                const calculatedVat = (base * taxRate) / 100;
                const effectiveVatAmount = (taxFields.vat_amount !== '' && taxFields.vat_amount !== undefined)
                    ? taxFields.vat_amount
                    : calculatedVat.toFixed(2);

                formDataObj.set("vat_amount", effectiveVatAmount);
                formDataObj.set("adjustment_amount", taxFields.adjustment_amount || 0);

                // IMPORTANT: Recalculate total_amount for the backend to ensure it matches the manual VAT
                const adjustment = parseFloat(taxFields.adjustment_amount || 0);
                const advance = parseFloat(formData.advance_applied || 0);
                const finalizedTotal = (base + parseFloat(effectiveVatAmount) + adjustment - advance).toFixed(2);

                formDataObj.set("total_amount", finalizedTotal);
            } else {
                // For non-taxable/salary, still send adjustment and tax if present
                if (taxFields.adjustment_amount) formDataObj.set("adjustment_amount", taxFields.adjustment_amount);
                if (taxFields.tax) formDataObj.set("tax", taxFields.tax);
                if (taxFields.total_amount) formDataObj.set("total_amount", taxFields.total_amount);
                if (taxFields.invoice_no) formDataObj.set("invoice_no", taxFields.invoice_no);
                if (taxFields.invoice_date) formDataObj.set("invoice_date", taxFields.invoice_date);
            }

            if (formData.type === 'deferred') {
                console.log('DEBUG - Sending Deferred Fields:', deferredFields);
                formDataObj.set("recognition_period", deferredFields.recognition_period);
                formDataObj.set("deferred_start_date", deferredFields.deferred_start_date);
                formDataObj.set("deferred_end_date", deferredFields.deferred_end_date);
                formDataObj.set("total_periods", deferredFields.total_periods);
                formDataObj.set("amount_per_period", deferredFields.amount_per_period);
            }

            if (formData.attatchment instanceof File) {
                formDataObj.append("attatchment", formData.attatchment);
            }

            let errors;
            if (expenseId != null) {
                errors = await editExpense(expenseId, formDataObj);
                if (errors && errors.lockError) {
                    setLockError('Financial year is locked. Expense cannot be updated.');
                    setLoading(false);
                    return; // Stop further execution
                }
            } else {
                errors = await addExpense(formDataObj);
                if (errors && errors.lockError) {
                    setLockError('Financial year is locked. Expense cannot be created.');
                    setLoading(false);
                    return; // Stop further execution
                }
            }

            if (errors && Object.keys(errors).length > 0 && !errors.lockError) {
                setErrors(errors);
                let errorMessage = typeof errors === 'string' ? errors : Object.values(errors).flat()[0];
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: errorMessage,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            } else {
                setErrors({});
                handleClose();
                setLockError('');
            }
        } catch (error) {
            console.error("An error occurred:", error); // Log full error
            console.log("Error Response Data:", error.response?.data);
            console.log("Error Status:", error.response?.status);

            const isTooLarge = error.response?.status === 413 ||
                error.response?.data?.message?.includes?.('too large') ||
                (typeof error.response?.data === 'string' && (error.response.data.includes('too large') || error.response.data.includes('exceeds the limit')));

            if (isTooLarge) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: error.response?.data?.message || 'File size is too large. Please upload up to 2MB.',
                    timer: 5000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            } else if (error.response?.data?.errors?.lockError) {
                setLockError(error.response.data.errors.lockError);
            } else {
                const apiErrors = error.response?.data?.errors;
                let errorMessage = error.response?.data?.message || 'An error occurred while saving the expense.';

                if (apiErrors && Object.keys(apiErrors).length > 0) {
                    errorMessage = Object.values(apiErrors).flat()[0];
                }

                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    icon: 'error',
                    title: errorMessage,
                    timer: 3000,
                    timerProgressBar: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        const container = Swal.getContainer();
                        container.style.top = '50px';
                    },
                });
            }
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            {showModal && (
                <div
                    className="custom-backdrop"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.25)', // light dim (Bootstrap style)
                        zIndex: 1059, // between parent & child offcanvas
                    }}
                    onClick={handleClose}
                />
            )}


            <Offcanvas
                show={showModal}
                onHide={handleClose}
                placement="end"
                style={{ width: isCreateMode && billMode === 'multiple' ? '760px' : '680px', zIndex: 1045 }}
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        {getModalTitle()}
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <hr style={{ margin: 0 }} /><br />

                <Offcanvas.Body>
                    {/* Toggle between Single Bill and Multiple Bills (only in Create Mode) */}
                    {isCreateMode && (
                        <div className="d-flex justify-content-center mb-3">
                            <div
                                className="btn-group p-1 bg-light rounded-pill border"
                                role="group"
                                style={{ maxWidth: '340px', width: '100%' }}
                            >
                                <button
                                    type="button"
                                    className={`btn btn-sm rounded-pill font-weight-medium ${billMode === 'single' ? 'btn-primary shadow-sm' : 'btn-light text-muted'}`}
                                    style={{ width: '50%', transition: 'all 0.2s ease', fontWeight: 600 }}
                                    onClick={() => setBillMode('single')}
                                >
                                    <i className="mdi mdi-file-document-outline me-1"></i> Single Bill
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-sm rounded-pill font-weight-medium ${billMode === 'multiple' ? 'btn-primary shadow-sm' : 'btn-light text-muted'}`}
                                    style={{ width: '50%', transition: 'all 0.2s ease', fontWeight: 600 }}
                                    onClick={() => setBillMode('multiple')}
                                >
                                    <i className="mdi mdi-file-multiple-outline me-1"></i> Multiple Bills
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Step progress indicator (only for Single Bill create/edit mode) */}
                    {(isCreateMode || isEditMode) && billMode === 'single' ? (
                        <div className="mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                {[1, 2].map(step => (
                                    <div key={step} className="d-flex flex-column align-items-center">
                                        <div
                                            className={`rounded-circle d-flex align-items-center justify-content-center ${step <= currentStep ? 'bg-primary text-white' : 'bg-light text-muted'
                                                }`}
                                            style={{ width: '30px', height: '30px', fontSize: '14px' }}
                                        >
                                            {step}
                                        </div>
                                        <small className="mt-1 text-muted">
                                            {step === 1 && 'Basic'}
                                            {step === 2 && 'Details'}
                                        </small>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : null}

                    <Form>
                        {renderContent()}
                    </Form>
                </Offcanvas.Body>

                <br />
                <div className="p-3 d-flex justify-content-between border-top">
                    <div>
                        {/* Only show previous button for edit/create mode if single bill */}
                        {isCreateMode && billMode === 'multiple' ? null : (isCreateMode || isEditMode ? (
                            currentStep > 1 && (
                                <button
                                    type="button"
                                    className="btn btn-secondary me-2"
                                    onClick={prevStep}
                                >
                                    Previous
                                </button>
                            )
                        ) : null)}
                    </div>

                    <div>
                        <button
                            type="button"
                            className="btn btn-secondary me-2"
                            onClick={handleClose}
                        >
                            Close
                        </button>

                        {isCreateMode && billMode === 'multiple' ? (
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleMultipleBillsSubmit}
                                disabled={loading}
                            >
                                {loading ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-1" />
                                        <span>Saving Bills...</span>
                                    </>
                                ) : (
                                    `Save Expense (${multipleBills.length} ${multipleBills.length === 1 ? 'Bill' : 'Bills'})`
                                )}
                            </button>
                        ) : (isCreateMode || isEditMode ? (
                            // Edit/Create mode buttons
                            currentStep < 2 ? (
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={nextStep}
                                >
                                    Next
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? <Spinner animation="border" size="sm" /> : 'Submit'}
                                </button>
                            )
                        ) : (
                            // View mode - only show Edit button
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => {
                                    setIsEditMode(true);
                                    setCurrentStep(1); // Start edit mode from step 1
                                }}
                            >
                                Edit
                            </button>
                        ))}
                    </div>
                </div>
            </Offcanvas>
        </>
    );

};

export default ExpenseModal;
